<template>
  <div class="mtto-ticket-form-root">
  <div class="ticket-form-container" :class="{ 'admin-view': esAdmin }">
    <!-- Contenedor principal con tabla y botón -->
    <div class="main-content">
      <!-- Header con botón de nuevo ticket y estadísticas -->
      <div class="table-header">
        <h3 v-if="!showTicketDetail">📋 Tickets Generados</h3>
        <div v-else class="detail-header">
          <button class="back-btn" @click="cerrarDetalle">
            ← Volver a la Lista
          </button>
          <h3>Detalle del Ticket #{{ ticketDetalle ? ticketDetalle.id : '' }}</h3>
        </div>
        <div class="header-actions" v-if="!showTicketDetail">
          <button class="new-ticket-btn" @click="abrirModalTipoTicket">
            ➕ Nuevo Ticket
          </button>
          <!-- Botón de Garrafón de Agua (mismo tamaño que Nuevo Ticket) -->
          <button
            class="new-ticket-btn garrafon-btn"
            type="button"
            @click="abrirGarrafonModal"
            title="Solicitar garrafón de agua"
          >
            Garrafón 🧴
          </button>

          <!-- Botón de Manuales (mismo tamaño que Nuevo Ticket) -->
          <button
            class="new-ticket-btn manuales-btn"
            type="button"
            @click="abrirManualesModal"
            title="Ver manuales del sistema"
          >
            📚 Manuales
          </button>

          <!-- Botón de chat para técnicos (comentado) -->
          <!--
          <button
            v-if="esAdminOTecnico"
            class="quick-ticket-btn"
            type="button"
            @click="abrirTelegramChat"
            title="Chat entre técnicos (Telegram)"
          >
            Chat
          </button>-->
          
          <div v-if="esAdminOTecnico" class="admin-actions">
            <button
              type="button"
              class="stats-btn stats-toggle-btn"
              @click="toggleAccionesEstadisticas"
              :aria-expanded="mostrarAccionesEstadisticas.toString()"
            >
              📊 Estadísticas
              <span class="dropdown-arrow" :class="{ open: mostrarAccionesEstadisticas }">▼</span>
            </button>
            <transition name="fade">
              <div
                v-if="mostrarAccionesEstadisticas"
                class="stats-buttons"
              >
                <button class="stats-option-btn" @click="verTicketsCreadosResueltos">📊 Tickets Creados y Resueltos</button>
                <button class="stats-option-btn" @click="verTiempoPromedio">⏱️ Tiempo Promedio</button>
                <button class="stats-option-btn" @click="verTicketsPorTecnico">👥 Tickets por Técnico</button>
                <button class="stats-option-btn" @click="verTicketsPorArea">🏥 Tickets por Área</button>
                <button class="stats-option-btn" @click="verProblemasMasComunes">🧩 Problemas Más Comunes</button>
                <button class="stats-option-btn" @click="verEstadisticasPreventivas">Estadísticas Preventivas</button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
      <!-- Contenido principal: Tabla o Detalle -->
      <div class="ticket-list" v-if="!showTicketDetail">
        <!-- Filtro por área -->
        <div class="filter-section">
          <div class="filter-controls">
            <div class="filter-group autocomplete-container">
              <v-autocomplete
                v-model="filtroArea"
                :items="areasDisponibles"
                item-text="nombre"
                item-value="nombre"
                :filter="filtrarAreas"
                label="🔍 Filtrar por Área"
                placeholder="Selecciona un área"
                clearable
                dense
                outlined
                hide-details
                class="area-autocomplete"
              >
                <template v-slot:prepend-item>
                  <v-list-item @click="filtroArea = ''">
                    <v-list-item-content>
                      <v-list-item-title>📋 Todas las áreas</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-autocomplete>
            </div>
            <div v-if="esAdminOTecnico" class="filter-group">
              <label for="prioridadFilter">🚨 Filtrar por Prioridad:</label>
              <select id="prioridadFilterUnique" v-model="filtroPrioridad" class="area-filter">
                <option value="">Todas las prioridades</option>
                <option value="ALTA">🔴 Alta</option>
                <option value="MEDIA">🟡 Media</option>
                <option value="BAJA">🟢 Baja</option>
              </select>
            </div>
            <!-- Filtro de estado (solo para admin/tecnico) -->
            <div v-if="esAdminOTecnico" class="filter-group">
              <label for="filtroEstado">Estado:</label>
              <select id="filtroEstado" v-model="filtroEstado" class="area-filter">
                <option value="activos">🟢 Activos</option>
                <option value="resueltos">🔵 Resueltos</option>
                <option value="cancelados">🔴 Cancelados</option>
                <option value="todos">📈 Todos</option>
              </select>
            </div>
            
            <div v-if="esAdminOTecnico" class="filter-group">
              <label for="filtroGestionInformacion">Gestión de Información:</label>
              <select id="filtroGestionInformacion" v-model="filtroGestionInformacion" class="area-filter">
                <option value="pendientes">🟣 En Revisión</option>
                <option value="rechazados">❌ Rechazados</option>
                <option value="ejecutados">✅ Aprobados</option>
                <option value="todos_gestion">📋 Todos gestión</option>
              </select>
            </div>

            <!-- Filtro de turno -->
            <div class="filter-group">
              <label for="filtroTurno">🕐 Turno:</label>
              <select id="filtroTurno" v-model="filtroTurno" class="area-filter">
                <option value="">Todos los turnos</option>
                <option value="manana">🌅 Mañana (6am - 2pm)</option>
                <option value="tarde">🌇 Tarde (2pm - 10pm)</option>
                <option value="noche">🌙 Noche (10pm - 6am)</option>
              </select>
            </div>

            <button v-if="filtroArea || (esAdminOTecnico && filtroPrioridad ||filtroGestionInformacion) || filtroEstado !== 'activos' || filtroTurno"  @click="limpiarFiltros" class="clear-filter-btn">
              ❌ Limpiar filtros
            </button>

          </div>

          <div class="chatbot-trigger-wrapper">
            <button class="chatbot-trigger" type="button" @click.stop="toggleChatbot" title="Asistente de soluciones">
              <div class="chatbot-bot-icon" aria-hidden="true">
                <div class="chatbot-bot-antenna">
                  <div class="chatbot-bot-antenna-ball"></div>
                </div>
                <div class="chatbot-bot-head">
                  <div class="chatbot-bot-eye left"></div>
                  <div class="chatbot-bot-eye right"></div>
                  <div class="chatbot-bot-mouth"></div>
                </div>
                <div class="chatbot-bot-body">
                  <div class="chatbot-bot-badge"></div>
                </div>
              </div>

              <div class="bot-thought" aria-hidden="true">
                <div class="bot-thought-dots">
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                </div>
                <transition name="bot-thought-text" mode="out-in">
                  <div class="bot-thought-text" :key="botPhraseIndex">{{ botPhrase }}</div>
                </transition>
              </div>
            </button>
          </div>
          <div class="filter-info">
            <span v-if="filtroArea || (esAdminOTecnico && filtroPrioridad) || filtroTurno">
              Mostrando tickets de:
              <strong v-if="filtroArea">{{ filtroArea }}</strong>
              <span v-if="filtroArea && (esAdminOTecnico && filtroPrioridad || filtroTurno)">, </span>
              <strong v-if="esAdminOTecnico && filtroPrioridad">{{ filtroPrioridad }}</strong>
              <span v-if="(esAdminOTecnico && filtroPrioridad) && filtroTurno">, </span>
              <strong v-if="filtroTurno">{{ formatoTurno(filtroTurno) }}</strong>
            </span>
            <span v-else>Mostrando todos los tickets</span>
            <span class="ticket-count">({{ ticketsFiltrados.length }} tickets)</span>
          </div>

          <transition name="chatbot-pop">
            <div v-if="showChatbot" class="chatbot-panel" @click.stop>
              <div class="chatbot-header">
                <div class="chatbot-title">Asistente de soluciones</div>
                <div class="chatbot-header-actions">
                  <button class="chatbot-clear" type="button" :disabled="chatbotLoading" @click="limpiarChatbot">Limpiar</button>
                  <button class="chatbot-close" type="button" @click.stop="cerrarChatbot">Cerrar</button>
                </div>
              </div>

              <div class="chatbot-messages" ref="chatbotMessages">
                <div v-for="m in chatbotMensajes" :key="m.id" class="chatbot-message" :class="m.from">
                  <div class="chatbot-bubble">
                    <div v-if="m.type === 'text'" class="chatbot-bubble-text">{{ m.text }}</div>

                    <div v-else-if="m.type === 'basicas'" class="chatbot-basicas">
                      <div class="chatbot-basicas-title">Soluciones básicas ({{ m.area }})</div>
                      <div v-for="g in (m.items || [])" :key="g.id" class="chatbot-basica">
                        <div class="chatbot-basica-header">{{ g.titulo }}</div>
                        <ol class="chatbot-basica-list">
                          <li v-for="(s, i) in (g.soluciones || [])" :key="i" class="chatbot-basica-step">{{ s }}</li>
                        </ol>
                      </div>
                      <button class="chatbot-back-btn" type="button" @click="volverAlMenu">← Volver al menú</button>
                    </div>

                    <div v-else-if="m.type === 'confirm'" class="chatbot-confirm">
                      <div class="chatbot-confirm-text">{{ m.text }}</div>
                      <div class="chatbot-confirm-actions">
                        <button class="chatbot-confirm-btn yes" type="button" @click="responderConfirmacionChatbot(true, m)">Sí</button>
                        <button class="chatbot-confirm-btn no" type="button" @click="responderConfirmacionChatbot(false, m)">No</button>
                      </div>
                      <button class="chatbot-back-btn" type="button" @click="volverAlMenu">← Volver al menú</button>
                    </div>

                    <div v-else-if="m.type === 'soluciones'" class="chatbot-soluciones">
                      <div v-if="m.keywords && Array.isArray(m.keywords) && m.keywords.length" class="chatbot-keywords">
                        <span class="chatbot-keywords-label">Palabras:</span>
                        <span v-for="kw in m.keywords" :key="kw" class="chatbot-keyword">{{ kw }}</span>
                      </div>

                      <div v-if="m.resultados && Array.isArray(m.resultados) && m.resultados.length" class="chatbot-results">
                        <div v-for="(r, idx) in m.resultados" :key="idx" class="chatbot-result">
                          <div class="chatbot-result-meta">
                            <span class="chatbot-result-tech" v-if="r.tecnico">{{ r.tecnico }}</span>
                            <span class="chatbot-result-date" v-if="r.fecha">{{ r.fecha }}</span>
                            <span class="chatbot-result-score" v-if="r.score !== undefined && r.score !== null">Coincidencias: {{ r.score }}</span>
                          </div>
                          <div v-if="esAdminOTecnico && (r.ticketFolio || r.ticketId)" class="chatbot-result-ticket">
                            Ticket: {{ r.ticketFolio || r.ticketId }}
                          </div>
                          <div class="chatbot-result-text">{{ r.solucion }}</div>
                        </div>
                      </div>

                      <div v-else class="chatbot-empty">No se encontraron soluciones relacionadas.</div>
                      <button class="chatbot-back-btn" type="button" @click="volverAlMenu">← Volver al menú</button>
                    </div>

                    <div v-else-if="m.type === 'menu'" class="chatbot-menu">
                      <div class="chatbot-menu-title">{{ m.title }}</div>
                      <div class="chatbot-menu-options">
                        <button v-for="opt in m.options" :key="opt.id" class="chatbot-menu-btn" type="button" @click="seleccionarOpcionMenu(opt.id)">
                          <span class="chatbot-menu-icon">{{ opt.icon }}</span>
                          <span class="chatbot-menu-text">{{ opt.text }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="chatbotLoading" class="chatbot-typing">
                  <div class="chatbot-typing-dot"></div>
                  <div class="chatbot-typing-dot"></div>
                  <div class="chatbot-typing-dot"></div>
                </div>
              </div>

              <div class="chatbot-inputbar">
                <input
                  v-model="chatbotProblema"
                  class="chatbot-input"
                  type="text"
                  placeholder="Describe el problema..."
                  :disabled="chatbotLoading"
                  @keydown.enter.prevent="enviarChatbot"
                />
                <button class="chatbot-send" type="button" :disabled="chatbotLoading || !chatbotProblema" @click="enviarChatbot">Enviar</button>
              </div>

              <div v-if="chatbotError" class="chatbot-error">{{ chatbotError }}</div>
            </div>
          </transition>
        </div>
        
        <table>
        <thead>
          <tr>
            <th v-if="esAdminOTecnico" class="folio-header">ID</th>
            <th v-else class="folio-header">Folio</th>
            <th>Título</th>
            <th v-if="esAdminOTecnico">Solicitante</th>
            <th>Área Solicitante</th>
            <th>Prioridad</th>
            <th>Fecha Creación</th>
            <th>Fecha Cierre</th>
            <th>Técnico</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
                      <tr v-for="ticket in ticketsFiltrados" :key="ticket.id" @click="abrirDetalle(ticket)" class="ticket-row" :style="getPrioridadStyle(ticket)">
              <td v-if="esAdminOTecnico" class="folio-cell">{{ ticket.id }}</td>
              <td v-else class="folio-cell">{{ generarFolio(ticket) }}</td>
              <td>{{ ticket.titulo }}</td>
              <td v-if="esAdminOTecnico">{{ ticket.nombre }}</td>
              <td>{{ ticket.areaSolicita }}</td>
              <td v-if="esAdminOTecnico" @click.stop>
                <select 
                  v-model="ticket.prioridad" 
                  @change="cambiarPrioridadManual(ticket)" 
                  class="inline-select"
                  :disabled="ticket.esCancelado || ticket.esResuelto">
                  <option value="ALTA">🟠 Alta</option>
                  <option value="MEDIA">🟡 Media</option>
                  <option value="BAJA">🟢 Baja</option>
                </select>
              </td>
              <td v-else>
                <span class="prioridad-badge" :style="getPrioridadBadgeStyle(ticket)">
                  {{ ticket.prioridad || 'Media' }}
                  <span v-if="ticket.prioridadManual" class="manual-indicator" title="Prioridad establecida manualmente por administrador">👤</span>
                </span>
              </td>
              <td class="fecha-hora-cell">
                <div class="fecha-line">{{ formatearFechaHoraCorta(ticket.fechaCreacion).fecha }}</div>
                <div class="hora-line">{{ formatearFechaHoraCorta(ticket.fechaCreacion).hora }}</div>
              </td>
              <td class="fecha-hora-cell">
                <div v-if="ticket.fechaCierre && ticket.fechaCierre !== ''" class="fecha-line">{{ formatearFechaHoraCorta(ticket.fechaCierre).fecha }}</div>
                <div v-if="ticket.fechaCierre && ticket.fechaCierre !== ''" class="hora-line">{{ formatearFechaHoraCorta(ticket.fechaCierre).hora }}</div>
                <div v-else class="fecha-line text-muted">Pendiente</div>
              </td>
              <td v-if="esAdminOTecnico" @click.stop>
                <div class="inline-select-with-team">
                <select
                  v-model="ticket.tecnicoAsignadoId" 
                  @change="actualizarTecnico(ticket)" 
                  class="inline-select"
                  :disabled="ticket.esCancelado || ticket.esResuelto">
                  <option :value="null">Sin asignar</option>
                  <option v-for="tecnico in listaTecnicos" :key="tecnico.id" :value="tecnico.id">{{ tecnico.nombre }}</option>
                </select>
                <button class="team-btn" title="Asignar equipo" @click.stop="abrirModalEquipo(ticket)" :disabled="ticket.esCancelado || ticket.esResuelto">👥</button>
                </div>
              </td>
              <td v-else>
                {{ ticket.equipoNombres || ticket.tecnico || 'Sin asignar' }}
              </td>
              <td v-if="esAdminOTecnico" @click.stop>
                <select 
                  v-model="ticket.estado" 
                  @focus="guardarEstadoActual(ticket)"
                  @change="actualizarEstado(ticket)" 
                  class="inline-select"
                  :disabled="ticket.esCancelado || ticket.esResuelto">
                  <!-- Estados para gestión de información -->
                  <template v-if="ticket.esGestionInformacion">
                    <option value="PENDIENTE">Pendiente</option>
                    <option value="EN_PROCESO">En Revisión</option>
                    <option value="RESUELTO">Ejecutado</option>
                    <option value="CANCELADO">Rechazado</option>
                  </template>
                  <!-- Estados normales para tickets regulares -->
                  <template v-else>
                    <option value="PENDIENTE">Pendiente</option>
                    <option value="ASIGNADO">Asignado</option>
                    <option value="EN_PROCESO">En Proceso</option>
                    <option value="REASIGNAR">Reasignar</option>
                    <option value="RESUELTO">Resuelto</option>
                  </template>
                </select>
              </td>
              <td v-else>
                <span class="estado-badge" :class="getEstadoClass(ticket.estado)">
                  {{ getEstadoText(ticket.estado, ticket.esGestionInformacion) }}
                </span>
              </td>
            </tr>
        </tbody>
      </table>
    </div>

    <!-- Panel de detalle del ticket -->
     <div v-if="showTicketDetail && ticketDetalle" class="ticket-detail-panel">
        <div class="detail-content">
          <!-- Card única con toda la información -->
          <div class="single-detail-card">
            <div class="card-header">
              <div class="header-left">
                <h2>Detalle del Ticket {{ generarFolio(ticketDetalle) }}</h2>
                <div class="status-summary">
                  <span class="detail-badge detail-badge-prioridad" :style="getPrioridadBadgeStyle(ticketDetalle)">{{ ticketDetalle.prioridad || 'Media' }}</span>
                  <span class="detail-badge detail-badge-estado" :class="getEstadoClass(ticketDetalle ? ticketDetalle.estado : null)">{{ getEstadoText(ticketDetalle ? ticketDetalle.estado : null, ticketDetalle ? ticketDetalle.esGestionInformacion : null) }}</span>
                </div>
              </div>
              <div class="header-actions">
                
                <!-- Botón de cancelar para usuarios (solo si es el creador y está pendiente) -->
                <button 
                  v-if="puedeCancelarTicket(ticketDetalle)"
                  @click="abrirModalCancelacion(ticketDetalle)" 
                  class="cancel-ticket-btn-detail"
                  title="Cancelar este ticket"
                >
                  ❌ Cancelar Ticket
                </button>
              </div>
            </div>
            
            <!-- Botones de descarga para usuarios (solo reporte normal) -->
                <button 
                  v-if="ticketDetalle && !esAdminOTecnico && ticketDetalle.estado === 'resuelto'" 
                  @click="descargarTicketNormal" 
                  class="download-btn" 
                  title="Descargar reporte del ticket"
                >
                  📄 Descargar Reporte
                </button>
                
                <!-- Botones de descarga para administradores y técnicos -->
                <div v-if="esAdminOTecnico" class="admin-download-buttons">
                  <button 
                    @click="descargarTicketNormal" 
                    class="download-btn normal-report" 
                    title="Descargar reporte normal"
                  >
                    📄 Reporte Normal
                  </button>
                  <button 
                    @click="descargarTicketCompleto" 
                    class="download-btn complete-report" 
                    title="Descargar reporte completo con todas las soluciones"
                  >
                    📋 Reporte Completo
                  </button>
                </div>
                <button @click="cerrarDetalle" class="close-detail-btn" title="Cerrar">
                  ✕
                </button>
              </div>
            </div>
            
            <div class="card-content">
              <!-- Diseño en filas organizadas -->
              
              <!-- Sección 1: Información Principal - Solo mostrar si NO es solicitud de insumos/equipo o si hay notas -->
              <div v-if="(!esSolicitudInsumos(ticketDetalle) && !esSolicitudEquipo(ticketDetalle)) || (ticketDetalle.notas && ticketDetalle.notas.trim() !== '')" class="detail-section">
                <div class="section-header">
                  <h3> Información Principal</h3>
                </div>
                <div class="section-content">
                  <div v-if="!esSolicitudInsumos(ticketDetalle) && !esSolicitudEquipo(ticketDetalle)" class="detail-form-group">
                    <label>Título del Problema</label>
                    <div class="detail-value title-value">{{ ticketDetalle.titulo || 'Sin título' }}</div>
                  </div>
                  
                  <div class="detail-form-row">
                    <div v-if="!esSolicitudInsumos(ticketDetalle) && !esSolicitudEquipo(ticketDetalle) || ticketDetalle.tipo === 'GESTION_INFORMACION' || (ticketDetalle.descripcion && ticketDetalle.descripcion.includes('DIAGNÓSTICO AUTOMÁTICO'))" class="detail-form-group">
                      <label>Descripción Detallada</label>
                      <div class="detail-value description-value">{{ descripcionLimpia || 'Sin descripción' }}</div>
                    </div>
                    
                    <div v-if="ticketDetalle.notas && ticketDetalle.notas.trim() !== ''" class="detail-form-group">
                      <label> Notas y Comentarios</label>
                      <div class="detail-value">{{ ticketDetalle.notas }}</div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Sección de Diagnóstico Automático -->
              <div v-if="diagnosticoAutomaticoInfo" class="detail-section diagnostic-section">
                <div class="section-header">
                  <h3> Diagnóstico Automático del Sistema</h3>
                </div>
                <div class="section-content">
                  <div class="diagnostic-grid">
                    <div v-for="dato in diagnosticoAutomaticoInfo.datos" :key="dato.clave" class="diagnostic-item">
                      <div class="diagnostic-label">{{ dato.clave }}:</div>
                      <div class="diagnostic-value">{{ dato.valor }}</div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Sección 2: Información del Solicitante y Ubicación -->
              <div class="detail-section">
                <div class="section-header">
                  <h3>👤 Información del Solicitante</h3>
                </div>
                <div class="section-content">
              <div class="detail-form-row">
                <div class="detail-form-group">
                  <label> Solicitante</label>
                  <div class="detail-value">{{ ticketDetalle.nombre || 'No especificado' }}</div>
                </div>
                <div class="detail-form-group">
                  <label> Área que Solicita</label>
                  <div class="detail-value">{{ ticketDetalle.areaSolicita || 'No especificado' }}</div>
                </div>
                <div v-if="ticketDetalle.ubicacion && ticketDetalle.ubicacion.trim() !== '' && !esSolicitudInsumos(ticketDetalle)" class="detail-form-group">
                  <label>Ubicación</label>
                  <div class="detail-value">{{ ticketDetalle.ubicacion }}</div>
                </div>
              </div>
              </div>
              </div>
              
              <!-- Sección 3: Información Técnica -->
              <div class="detail-section">
                <div class="section-header">
                  <h3>🔧 Información Técnica</h3>
                </div>
                <div class="section-content">
                  <!-- Para tickets de insumos o equipo, mostrar información solicitada con más espacio -->
                  <div v-if="esSolicitudInsumos(ticketDetalle) || esSolicitudEquipo(ticketDetalle)" class="detail-form-row">
                    <div class="detail-form-group full-width">
                      <label>Área Requerida</label>
                      <div class="detail-value">{{ getSolicitudText(ticketDetalle.solicitudArea) || 'No especificado' }}</div>
                    </div>
                  </div>
                  
                  <div v-if="ticketDetalle.equipo && ticketDetalle.equipo.trim() !== ''" class="detail-form-row">
                    <div class="detail-form-group" :class="{ 'full-width': esSolicitudEquipo(ticketDetalle) }">
                      <label>Equipo Afectado</label>
                      <div class="detail-value">{{ ticketDetalle.equipo }}</div>
                      <div v-if="ticketDetalle.serialNumber" class="detail-sub-value">
                        <small>🏷️ Serie: {{ ticketDetalle.serialNumber }}</small>
                      </div>
                      <div v-if="ticketDetalle.descripcionEquipo" class="detail-sub-value">
                        <small> {{ ticketDetalle.descripcionEquipo }}</small>
                      </div>
                    </div>
                  </div>
                  <div v-if="ticketDetalle.insumos && ticketDetalle.insumos.trim() !== ''" class="detail-form-row">
                    <div class="detail-form-group" :class="{ 'full-width': esSolicitudInsumos(ticketDetalle) }">
                      <label>📦 Insumos Requeridos</label>
                      <div class="detail-value">{{ ticketDetalle.insumos }}</div>
                      <div v-if="ticketDetalle.cantidadInsumos" class="detail-sub-value">
                        <small> Cantidad: {{ ticketDetalle.cantidadInsumos }}</small>
                      </div>
                      <div v-if="ticketDetalle.descripcionInsumos" class="detail-sub-value">
                        <small> {{ ticketDetalle.descripcionInsumos }}</small>
                      </div>
                    </div>
                  </div>

                  <!-- Lista de insumos múltiples -->
                  <div v-if="ticketDetalle.listaInsumos && ticketDetalle.listaInsumos.length > 0" class="detail-form-row">
                    <div class="detail-form-group full-width">
                      <label>Lista de Insumos</label>
                      <div class="insumos-list-container">
                        <div v-for="(insumo, index) in ticketDetalle.listaInsumos" :key="index" class="insumo-list-item">
                          <div class="insumo-list-header">
                            <strong>{{ insumo.nombre }}</strong>
                            <span class="insumo-list-cantidad">Cantidad: {{ insumo.cantidad }}</span>
                          </div>
                          <div v-if="insumo.descripcion" class="insumo-list-description">
                            {{ insumo.descripcion }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Para tickets normales, mostrar información técnica estándar -->
                  <div v-if="!esSolicitudInsumos(ticketDetalle) && !esSolicitudEquipo(ticketDetalle)" class="detail-form-row">
                    <div class="detail-form-group">
                      <label>Área Requerida</label>
                      <div class="detail-value">{{ getSolicitudText(ticketDetalle.solicitudArea) || 'No especificado' }}</div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Sección 4: Estado y Seguimiento -->
              <div class="detail-section">
                <div class="section-header">
                  <h3>Estado y Seguimiento</h3>
                </div>
                <div class="section-content">
                  <div class="status-badges-row">
                    <div class="status-badge-item">
                      <label>Prioridad</label>
                      <span class="detail-badge detail-badge-prioridad" :style="getPrioridadBadgeStyle(ticketDetalle)">
                        {{ ticketDetalle.prioridad || 'Media' }}
                        <span v-if="ticketDetalle.prioridadManual" class="manual-indicator" title="Prioridad establecida manualmente por administrador">👤</span>
                      </span>
                    </div>
                    <div class="status-badge-item">
                      <label>Estado</label>
                      <span class="detail-badge detail-badge-estado" :class="getEstadoClass(ticketDetalle ? ticketDetalle.estado : null)">{{ getEstadoText(ticketDetalle ? ticketDetalle.estado : null, ticketDetalle ? ticketDetalle.esGestionInformacion : null) }}</span>
                </div>
              </div>
              
              <div class="detail-form-row">
                <div class="detail-form-group">
                  <label>👨‍💼 Técnico Asignado</label>
                  <div class="detail-value" :class="{ 'empty': !ticketDetalle.tecnico }">{{ ticketDetalle.tecnico || 'Sin asignar' }}</div>
                </div>
                <div class="detail-form-group">
                  <label>📅 Fecha de Creación</label>
                  <div class="detail-value">{{ formatearFecha(ticketDetalle.fechaCreacion) }}</div>
                </div>
                <div class="detail-form-group">
                  <label>✅ Fecha de Cierre</label>
                <div class="detail-value" :class="{ 'empty': !ticketDetalle.fechaCierre || !esFechaPosterior(ticketDetalle.fechaCreacion, ticketDetalle.fechaCierre) }">
                  {{ ticketDetalle.fechaCierre && esFechaPosterior(ticketDetalle.fechaCreacion, ticketDetalle.fechaCierre) ? formatearFecha(ticketDetalle.fechaCierre) : 'Sin cerrar' }}
                </div>
                </div>
                <div class="detail-form-group">
                  <label>⏱ Tiempo de Resolución</label>
                  <div class="detail-value">
                    {{ ticketDetalle.fechaCierre ? calcularTiempoResolucion(ticketDetalle.fechaCreacion, ticketDetalle.fechaCierre) : 'En proceso' }}
                  </div>
                    </div>
                  <div class="detail-form-group">
                  <label>⏱ Tiempo de Atención</label>
                  <div class="detail-value">
                    {{ ticketDetalle.fechaAsignacion && ticketDetalle.fechaCierre ? calcularTiempoAtencion(ticketDetalle.fechaAsignacion, ticketDetalle.fechaCierre) : 
                       ticketDetalle.fechaAsignacion && !ticketDetalle.fechaCierre ? calcularTiempoAtencion(ticketDetalle.fechaAsignacion, new Date()) : 
                       'Sin asignar' }}
                  </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Documentos PDF Adjuntos -->
              <div v-if="ticketDetalle && ticketDetalle.documentosPdf && ticketDetalle.documentosPdf.length > 0" class="pdf-actions-section">
                <h4>Documentos PDF Adjuntos</h4>
                <div class="pdf-list">
                  <div v-for="(pdf, index) in ticketDetalle.documentosPdf" :key="index" class="pdf-item">
                    <div class="pdf-info">
                      <div class="pdf-name">{{ pdf.nombre }}</div>
                      <div class="pdf-meta">
                        <span class="pdf-size">Tamaño: {{ pdf.tamano }}</span>
                        <span class="pdf-date">Fecha: {{ pdf.fecha }}</span>
                      </div>
                    </div>
                    <div class="pdf-actions">
                      <button 
                        @click="verPdf(pdf.url, pdf.nombre)" 
                        class="pdf-action-btn view-btn"
                        title="Ver PDF"
                      >
                        Ver
                      </button>
                      <button 
                        @click="descargarPdf(pdf.url, pdf.nombre)" 
                        class="pdf-action-btn download-btn"
                        title="Descargar PDF"
                      >
                        Descargar
                      </button>
                    </div>
                  </div>
                </div>
                
                <!-- Botón para subir PDFs en tickets (solo en estado en_proceso) -->
                <div v-if="ticketDetalle && (esAdminOTecnico || esUsuarioEnEquipo(ticketDetalle)) && ticketDetalle.estado === 'en_proceso'" class="pdf-upload-section">
                  <h4>Subir Documento PDF</h4>
                  <div class="pdf-upload-controls">
                    <input 
                      type="file" 
                      ref="pdfDetailInput"
                      @change="handlePdfDetailChange"
                      accept=".pdf"
                      class="pdf-detail-input"
                    />
                    <button 
                      @click="$refs.pdfDetailInput.click()" 
                      class="pdf-upload-btn"
                      :disabled="form.pdfDetailUploadLoading"
                    >
                      <span v-if="!form.pdfDetailUploadLoading">Seleccionar PDF</span>
                      <span v-else>Subiendo...</span>
                    </button>
                    <button
                      v-if="form.pdfDetailFiles && form.pdfDetailFiles.length > 0"
                      type="button"
                      @click="subirPdfsDetalle"
                      class="pdf-upload-btn"
                      :disabled="form.pdfDetailUploadLoading"
                    >
                      <span v-if="!form.pdfDetailUploadLoading">Subir PDF(s)</span>
                      <span v-else>Subiendo...</span>
                    </button>
                  </div>
                  <div v-if="form.pdfDetailFiles && form.pdfDetailFiles.length > 0" class="pdf-detail-files">
                    <h5>Archivos seleccionados:</h5>
                    <div v-for="(file, index) in form.pdfDetailFiles" :key="index" class="pdf-detail-item">
                      <span class="pdf-detail-name">{{ file.name }}</span>
                      <span class="pdf-detail-size">({{ formatFileSize(file.size) }})</span>
                      <button type="button" @click="removePdfDetailFile(index)" class="remove-pdf-detail-btn">Remove</button>
                    </div>
                  </div>
                  <div v-if="form.pdfDetailUploadLoading" class="upload-loading-detail">
                    <span>Subiendo archivo PDF...</span>
                  </div>
                </div>
              </div>
              
              <!-- Feed de Soluciones del Técnico -->
              <div v-if="solucionesVisibles.length > 0" class="solutions-feed-section">
                <div class="feed-header">
                  <h3>🛠️ Historial de Soluciones y Seguimientos</h3>
                  <span class="feed-count">{{ solucionesVisibles.length }} {{ solucionesVisibles.length === 1 ? 'registro' : 'registros' }}</span>
            </div>
                
                <div class="solutions-feed">
                  <div 
                    v-for="solucion in solucionesVisibles" 
                    :key="solucion.id" 
                    class="feed-item"
                    :class="`feed-type-${solucion.tipo}`"
                  >
                    <div class="feed-avatar">
                      <span class="avatar-icon">👨‍💻</span>
          </div>
                    <div class="feed-content">
                      <div class="feed-header">
                        <strong class="feed-author">{{ solucion.tecnico }}</strong>
                        <span class="feed-type-badge" :class="`badge-${solucion.tipo}`">
                          {{ getTipoSolucionText(solucion.tipo) }}
                        </span>
                        <span class="feed-time">{{ formatearFechaHora(solucion.fecha) }}</span>
        </div>
                        <div v-if="solucion.accionLabel" class="feed-action">
                          {{ solucion.accionLabel }}
                        </div>
                      <div class="feed-message">
                        {{ solucion.solucion }}
                      </div>
                      <div v-if="solucion.tiempoTexto" class="feed-extra-info">
                        ⏱️ {{ solucion.tiempoTexto }}
                      </div>
                      <div v-if="solucion.exitosa !== null && solucion.exitosa !== undefined" class="feed-extra-info">
                        ✅ {{ solucion.exitosa ? 'Marcada como exitosa' : 'Marcada como no exitosa' }}
                      </div>
                      
                      <!-- Mostrar imágenes si existen -->
                      <div v-if="solucion.imagenes && solucion.imagenes.length > 0" class="feed-images">
                        <div class="feed-images-grid">
                          <div v-for="(imagen, index) in solucion.imagenes" :key="index" class="feed-image-item">
                            <img 
                              :src="imagen.url" 
                              :alt="imagen.nombre" 
                              class="feed-image" 
                              @click="openImageModal(imagen)"
                              @error="handleImageError($event, imagen)"
                              @load="handleImageLoad($event, imagen)" />
                            <div v-if="imagen.error" class="image-error-placeholder">
                              📷 Imagen no disponible<br>
                              <small>{{ imagen.nombre }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
              <!-- Formulario para Agregar Nueva Solución (administradores, técnicos o miembros del equipo) -->
              <div v-if="ticketDetalle && (esAdminOTecnico || esUsuarioEnEquipo(ticketDetalle)) && (ticketDetalle.estado === 'en_proceso' || ticketDetalle.estado === 'resuelto')" class="new-solution-section">
                <div class="new-solution-header">
                  <h3>💬 Agregar Solución</h3>
                  <span class="solution-status">{{ getEstadoText(ticketDetalle ? ticketDetalle.estado : null, ticketDetalle ? ticketDetalle.esGestionInformacion : null) }}</span>
                </div>
                
                <div class="new-solution-form">
                  <div class="form-group">
                    <label>Tipo de Solución</label>
                    <select v-model="nuevaSolucion.tipo" class="detail-input">
                      <option value="solucion_inicial" :disabled="ticketDetalle && ticketDetalle.estado === 'resuelto'">🛠️ Solución</option>
                      <option value="seguimiento" :disabled="!ticketDetalle || ticketDetalle.estado !== 'resuelto'">📋 Seguimiento</option>
                    </select>
                  </div>
                  
                  <div class="form-group">
                    <label>Descripción de la Solución</label>
                  <textarea 
                      v-model="nuevaSolucion.solucion" 
                    class="detail-textarea"
                      placeholder="Describe los pasos que seguiste, actualizaciones, o cualquier información relevante..."
                      rows="4"
                  ></textarea>
                </div>
                
                  <div class="form-group">
                    <label>📷 Adjuntar Imágenes (Opcional)</label>
                    <div class="image-upload-section">
                    <input 
                      type="file" 
                        ref="solutionImageInput" 
                        @change="handleSolutionImageUpload" 
                      accept="image/*" 
                      multiple 
                        class="image-input"
                        id="solutionImageUpload"
                    />
                      <label for="solutionImageUpload" class="image-upload-btn">
                        📷 Seleccionar Imágenes
                    </label>
                      <p class="image-help-text">Puedes seleccionar múltiples imágenes para documentar la solución</p>
                  </div>
                  
                    <!-- Vista previa de imágenes seleccionadas -->
                    <div v-if="nuevaSolucion.imagenes && nuevaSolucion.imagenes.length > 0" class="images-preview">
                      <h4>📸 Imágenes Seleccionadas ({{ nuevaSolucion.imagenes.length }})</h4>
                      <div class="images-grid">
                        <div v-for="(imagen, index) in nuevaSolucion.imagenes" :key="index" class="image-item">
                          <img :src="imagen.url" :alt="imagen.nombre" class="image-preview" />
                          <div class="image-info">
                            <span class="image-name">{{ imagen.nombre }}</span>
                            <button @click="removeSolutionImage(index)" class="remove-image-btn">❌</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                  <div class="form-actions">
                    <button @click="agregarSolucion" class="add-solution-btn" :disabled="!nuevaSolucion.solucion.trim() || guardandoSolucion">
                      {{ guardandoSolucion ? '⏳ Guardando...' : '💬 Agregar Solución' }}
                    </button>
                    <button @click="limpiarFormularioSolucion" class="clear-btn">
                      🗑️ Limpiar
                    </button>
                  </div>
                </div>
              </div>

              <!-- Botón Generar Dictamen Técnico -->
              <div v-if="ticketDetalle && (esAdminOTecnico || esUsuarioEnEquipo(ticketDetalle)) && (ticketDetalle.estado === 'en_proceso' || ticketDetalle.estado === 'resuelto')" class="dictamen-section" style="margin-top: 20px; text-align: center;">
                <button @click="abrirModalDictamen" class="dictamen-btn" style="background: #17a2b8; color: white; padding: 12px 24px; border: none; border-radius: 8px; cursor: pointer; font-size: 1rem; display: inline-flex; align-items: center; gap: 8px;">
                  📋 Generar Dictamen Técnico
                </button>
              </div>
      <!-- Modal para ver imágenes en tamaño completo -->
    <div v-if="imagenModal.visible" class="image-modal-overlay" @click="closeImageModal">
      <div class="image-modal-content" @click.stop>
        <div class="image-modal-header">
          <h3>{{ imagenModal.imagen.nombre }}</h3>
          <button @click="closeImageModal" class="close-modal-btn">❌</button>
        </div>
        <div class="image-modal-body">
          <img :src="imagenModal.imagen.url" :alt="imagenModal.imagen.nombre" class="modal-image" />
            </div>
      </div>
    </div>

    <!-- Modal de Dictamen Técnico -->
    <div v-if="showDictamenModal" class="modal-overlay" @click.self="cerrarModalDictamen">
      <div class="modal-content form-modal dictamen-modal" @click.stop>
        <div class="modal-header">
          <h3>📋 Generar Dictamen Técnico</h3>
          <button @click="cerrarModalDictamen" class="close-btn">✕</button>
        </div>
        <form class="ticket-form-modal" @submit.prevent="generarDictamenTecnico">
          <!-- Equipo -->
          <div class="form-group">
            <label for="equipoDictamen">Equipo <span class="required">*</span></label>
            <input 
              type="text" 
              id="equipoDictamen" 
              v-model="dictamenTecnico.equipo" 
              required 
              placeholder="Ej: Laptop, Servidor, Impresora..."
            />
          </div>

          <!-- Marca -->
          <div class="form-group">
            <label for="marcaDictamen">Marca <span class="required">*</span></label>
            <input 
              type="text" 
              id="marcaDictamen" 
              v-model="dictamenTecnico.marca" 
              required 
              placeholder="Ej: Dell, HP, Lenovo..."
            />
          </div>

          <!-- Modelo -->
          <div class="form-group">
            <label for="modeloDictamen">Modelo <span class="required">*</span></label>
            <input 
              type="text" 
              id="modeloDictamen" 
              v-model="dictamenTecnico.modelo" 
              required 
              placeholder="Ej: Latitude 5520, EliteBook 840..."
            />
          </div>

          <!-- Número de Serie -->
          <div class="form-group">
            <label for="numeroSerie">Número de Serie <span class="required">*</span></label>
            <input 
              type="text" 
              id="numeroSerie" 
              v-model="dictamenTecnico.numeroSerie" 
              required 
              placeholder="Ej: SN123456789"
            />
          </div>

          <!-- Área (del ticket) -->
          <div class="form-group">
            <label for="areaDictamen">Área</label>
            <input 
              type="text" 
              id="areaDictamen" 
              :value="getSolicitudText(ticketDetalle ? ticketDetalle.solicitudArea : null) || 'No especificado'" 
              readonly 
              class="readonly-field"
            />
          </div>

          <!-- Descripción -->
          <div class="form-group">
            <label for="descripcionDictamen">Descripción <span class="required">*</span></label>
            <textarea 
              id="descripcionDictamen" 
              v-model="dictamenTecnico.descripcion" 
              rows="4" 
              required
              placeholder="Describe el estado del equipo, fallas encontradas, diagnóstico técnico..."
            ></textarea>
          </div>

          <!-- Recomendaciones -->
          <div class="form-group">
            <label for="recomendacionesDictamen">Recomendaciones <span class="required">*</span></label>
            <textarea 
              id="recomendacionesDictamen" 
              v-model="dictamenTecnico.recomendaciones" 
              rows="4" 
              required
              placeholder="Recomendaciones técnicas para solucionar el problema..."
            ></textarea>
          </div>

          <!-- Conclusión -->
          <div class="form-group">
            <label for="conclusionDictamen">Conclusión <span class="required">*</span></label>
            <textarea 
              id="conclusionDictamen" 
              v-model="dictamenTecnico.conclusion" 
              rows="3" 
              required
              placeholder="Conclusión final del dictamen técnico..."
            ></textarea>
          </div>

          <!-- Botones -->
          <div class="modal-actions">
            <button type="button" @click="cerrarModalDictamen" class="cancel-btn">❌ Cancelar</button>
            <button type="submit" class="submit-btn" :disabled="guardandoDictamen">
              <span v-if="!guardandoDictamen">📋 Generar Dictamen</span>
              <span v-else>⏳ Generando...</span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal de selección de tipo de ticket -->
    <div v-if="showTipoTicketModal" class="modal-overlay" @click.self="cerrarModalTipoTicket">
      <div class="modal-content tipo-ticket-modal compact">
        <div class="modal-header">
          <h3>📝 Nuevo Ticket</h3>
          <button class="close-btn" @click="cerrarModalTipoTicket">✕</button>
        </div>
        <div class="tipo-ticket-form">
          <!-- Nombre del solicitante -->
          <div class="form-group compact-field">
            <label>👤 Solicitante</label>
            <input type="text" :value="form.nombre" readonly class="readonly-field" />
          </div>
          
          <!-- Tipo de solicitud dropdown -->
          <div class="form-group compact-field">
            <label for="tipoSolicitudModal">📋 Tipo de Solicitud <span class="required">*</span></label>
            <select id="tipoSolicitudModal" v-model="tipoFormulario" class="tipo-solicitud-select">
              <option value="crear_ticket">🛠️ Reportar falla o solicitar servicio</option>
              <option value="gestion_informacion">📊 Gestion o administracion de Informacion</option>
            </select>
          </div>
          
          <!-- Botón continuar -->
          <div class="modal-actions compact-actions">
            <button type="button" @click="cerrarModalTipoTicket" class="cancel-btn">Cancelar</button>
            <button type="button" @click="continuarConTipoTicket" class="submit-btn">Continuar ➜</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal rápido: Manuales -->
    <div v-if="showManualesModal" class="modal-overlay" @click.self="cerrarManualesModal">
      <div class="modal-content form-modal" @click.stop>
        <div class="modal-header">
          <h3>📚 Manuales del Sistema</h3>
          <button class="close-btn" @click="cerrarManualesModal">✕</button>
        </div>
        <div class="manuales-content">
          <div class="manuales-list">
            <div class="manual-item">
              <h4>Manuales para el usuario</h4>
              <p>Guía para acceso remoto</p>
              <button class="manual-btn" @click="descargarManual('usuario')">Ver</button>

            </div>
            <div class="manual-item">
              <h4>Manual Técnico</h4>
              <p>Guia de procedimiento para la eliminacion de notas</p>
              <button class="manual-btn" @click="descargarManual('tecnico')">Ver</button>
            </div>
            <div class="manual-item">
              <h4>Preguntas Frecuentes</h4>
              <p>Respuestas a las preguntas más comunes</p>
              <button class="manual-btn" @click="descargarManual('faq')">Ver</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de confirmación para paciente -->
    <div v-if="showConfirmacionPacienteModal" class="modal-overlay modal-paciente-confirmacion" @click.self="cerrarConfirmacionPaciente">
      <div class="modal-content form-modal" @click.stop>
        <div class="modal-header">
          <h3>⚠️ Confirmación Requerida</h3>
          <button class="close-btn" @click="cerrarConfirmacionPaciente">✕</button>
        </div>
        <div class="confirmacion-paciente-content">
          <div class="alerta-paciente">
            <p class="mensaje-principal">Se detectó la palabra <strong>"paciente"</strong> en tu solicitud.</p>
            <p class="mensaje-instruccion">Para continuar, debes confirmar que has registrado correctamente:</p>
            <ul class="lista-requisitos">
              <li>✅ Número de expediente del paciente, <strong>O</strong></li>
              <li>✅ Nombre completo del paciente</li>
            </ul>
          </div>
          <div class="checkbox-confirmacion">
            <label class="checkbox-label-large">
              <input type="checkbox" v-model="pacienteConfirmado" />
              <span class="checkmark-large"></span>
              <span class="texto-checkbox">Confirmo que he registrado el número de expediente o nombre completo del paciente</span>
            </label>
          </div>
        </div>
        <div class="modal-actions">
          <button type="button" @click="cerrarConfirmacionPaciente" class="cancel-btn">Cancelar</button>
          <button type="button" @click="confirmarCreacionTicketPaciente" class="submit-btn" :disabled="!pacienteConfirmado">
            Continuar ➜
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de formulario para nuevo ticket -->
    <div v-if="showFormModal" class="modal-overlay" @click.self="cerrarFormulario">
      <div class="modal-content form-modal">
        <div class="modal-header">
          <h3>📝 Crear Nuevo Ticket</h3>
          <button class="close-btn" @click="cerrarFormulario">✕</button>
        </div>
        <form class="ticket-form-modal" @submit.prevent="crearTicketCompleto">
          <!-- Selector de tipo de formulario -->
          <div class="form-group">
            <label for="tipoFormulario">Tipo de Solicitud</label>
            <select id="tipoFormulario" v-model="tipoFormulario" @change="onTipoFormularioChange">
              <option value="crear_ticket">Crear Ticket</option>
              <option value="gestion_informacion">Gestión de Información</option>
            </select>
          </div>
          
          <!-- Información Básica -->
          <div class="form-row">
            <div class="form-group">
              <label for="nombre">👤 Nombre del Solicitante</label>
              <input type="text" id="nombre" v-model="form.nombre" required readonly />
            </div>
            <div class="form-group">
              <label for="solicitudArea">Área Requerida <span class="required">*</span></label>
              <select v-if="tipoFormulario === 'crear_ticket'" id="solicitudArea" v-model="form.solicitudArea" required @change="onAreaRequeridaChange">
                <option value="">Selecciona un área</option>
                <option value="TECNOLOGIAS">💻 Tecnologías</option>
                <option value="MANTENIMIENTO">🔧 Mantenimiento</option>
                <option value="BIOMEDICA">🏥 Biomédica</option>
              </select>
              <input v-else type="text" value="💻 Tecnologías" readonly class="readonly-field" />
            </div>
          </div>

          <!-- Campos adicionales que aparecen después de seleccionar área -->
          <div v-if="form.solicitudArea">
            <!-- FORMULARIO DE GESTIÓN DE INFORMACIÓN -->
            <div v-if="tipoFormulario === 'gestion_informacion'">
              
              <!-- Área Solicitante -->
              <div class="form-group">
                <label for="areaSolicitaGestion">Área Solicitante <span class="required">*</span></label>
                <v-combobox
                  id="areaSolicitaGestion"
                  v-model="form.areaSolicita"
                  :items="areasDisponibles"
                  item-text="nombre"
                  item-value="nombre"
                  :filter="filtrarAreas"
                  placeholder="Selecciona o escribe el área..."
                  required
                />
              </div>
              
              <!-- Ubicación -->
              <div class="form-group">
                <label for="ubicacionGestion">Ubicación <span class="required">*</span></label>
                <v-combobox
                  id="ubicacionGestion"
                  v-model="form.ubicacion"
                  :items="areasDisponibles"
                  item-text="nombre"
                  item-value="nombre"
                  :filter="filtrarAreas"
                  placeholder="Selecciona o escribe la ubicación..."
                  required
                />
              </div>
              
              <!-- Acción Solicitada -->
              <div class="form-group">
                <label for="accionSolicitada">Acción Solicitada <span class="required">*</span></label>
                <input id="accionSolicitada" v-model="form.accionSolicitada" type="text" required maxlength="100" placeholder="Describe la acción que necesitas..." />
                <small class="help-text">Máx. 100 caracteres. ({{ form.accionSolicitada ? form.accionSolicitada.length : 0 }}/100)</small>
              </div>
              
              <!-- Motivo - Guarda en descripcion -->
              <div class="form-group">
                <label for="motivo">Motivo <span class="required">*</span></label>
                <textarea id="motivo" v-model="form.motivo" rows="4" required placeholder="Explica el motivo de tu solicitud..."></textarea>
              </div>
              
              <!-- Checkbox de auditoría -->
              <div class="form-group">
                <label class="checkbox-label">
                  <input type="checkbox" id="auditoria" v-model="form.auditoriaAceptada" required />
                  <span class="checkmark"></span>
                  Entiendo que esta acción será auditada
                </label>
              </div>
            </div>
            
            <!-- FORMULARIO CREAR TICKET (EXISTENTE) -->
            <div v-else>

            <div v-if="mostrarDiagnosticoAutomatico" class="auto-diagnostic-panel">
              <div class="auto-diagnostic-text">
                Diagnóstico automático disponible para: <strong>{{ tipoDiagnosticoDetectado }}</strong>
              </div>
              <button
                type="button"
                class="auto-diagnostic-btn"
                @click="ejecutarDiagnosticoAutomatico"
                :disabled="diagnosticoLoading"
              >
                <span v-if="!diagnosticoLoading">Diagnóstico automático</span>
                <span v-else>Recolectando...</span>
              </button>
            </div>

          <!-- FORMULARIO PARA ÁREAS DE TECNOLOGÍAS Y MANTENIMIENTO -->
          <div v-if="form.solicitudArea && form.solicitudArea !== 'BIOMEDICA'">
            <!-- Título del Problema -->
            <div class="form-group">
              <label for="titulo">Título del Problema <span class="required">*</span></label>
              <input id="titulo" v-model="form.titulo" type="text" required maxlength="30" placeholder="Ej: Falla en sistema de aire acondicionado" />
              <small class="help-text">Máx. 30 caracteres. ({{ form.titulo ? form.titulo.length : 0 }}/30)</small>
            </div>

            <!-- Descripción -->
            <div class="form-group">
              <label for="descripcion">Descripción Detallada <span class="required">*</span></label>
              <textarea id="descripcion" v-model="form.descripcion" rows="2" required placeholder="Describe el problema en detalle..."></textarea>
            </div>

            <!-- Ubicación -->
            <div class="form-row">
              <div class="form-group">
                <label for="areaSolicita"> Área que Solicita <span class="required">*</span></label>
                <div class="autocomplete-container">
                  <v-autocomplete
                    id="areaSolicita"
                    v-model="form.areaSolicita"
                    :items="areasDisponibles"
                    item-text="nombre"
                    item-value="nombre"
                    :filter="filtrarAreas"
                    label="Selecciona o escribe el área"
                    placeholder="Ej: Quirófano, Enfermería"
                    :rules="[v => !!v || 'El área es requerida']"
                    required
                    clearable
                    dense
                    outlined
                    hide-details
                    class="area-autocomplete"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item @click="form.areaSolicita = ''">
                        <v-list-item-content>
                          <v-list-item-title>Limpiar selección</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
              <div class="form-group">
                <label for="ubicacion"> Ubicación Específica <span class="required">*</span></label>
                <div class="autocomplete-container">
                  <v-combobox
                    id="ubicacion"
                    v-model="form.ubicacion"
                    :items="areasDisponibles"
                    item-text="nombre"
                    item-value="nombre"
                    :filter="filtrarAreas"
                    label="Selecciona o escribe la ubicación"
                    placeholder="Ej: Quirófano, Oficina 3"
                    :rules="[v => !!v || 'La ubicación es requerida']"
                    required
                    clearable
                    dense
                    outlined
                    hide-details
                    class="area-autocomplete"
                  />
                </div>
              </div>
            </div>

            <!-- Notas -->
            <div class="form-group">
              <label for="notas">Notas y Comentarios</label>
              <textarea id="notas" v-model="form.notas" rows="1" placeholder="Información adicional útil para el técnico..."></textarea>
            </div>
          </div>

          <!-- FORMULARIO PARA ÁREA BIOMÉDICA -->
          <div v-if="form.solicitudArea === 'BIOMEDICA'">
            <!-- Pestañas para las 3 secciones -->
            <div class="biomedica-tabs">
              <button 
                type="button" 
                class="tab-btn" 
                :class="{ active: biomedicaTab === 'solicitud' }"
                @click="biomedicaTab = 'solicitud'"
              >
                📋 Solicitud
              </button>
              <button 
                type="button" 
                class="tab-btn" 
                :class="{ active: biomedicaTab === 'insumos' }"
                @click="biomedicaTab = 'insumos'"
              >
                📦 Insumos
              </button>
              <button 
                type="button" 
                class="tab-btn" 
                :class="{ active: biomedicaTab === 'equipo' }"
                @click="biomedicaTab = 'equipo'"
              >
                ⚙️ Reportar Equipo
              </button>
            </div>

            <!-- Contenido de las pestañas -->
            <div class="tab-content">
              <!-- SECCIÓN SOLICITUD -->
              <div v-if="biomedicaTab === 'solicitud'" class="tab-panel">
                <!-- Título del Problema -->
                <div class="form-group">
                  <label for="titulo">Título del Problema <span class="required">*</span></label>
                  <input id="titulo" v-model="form.titulo" type="text" required maxlength="30" placeholder="Ej: Falla en sistema de aire acondicionado" />
                  <small class="help-text">Máx. 30 caracteres. ({{ form.titulo ? form.titulo.length : 0 }}/30)</small>
                </div>

                <!-- Descripción -->
                <div class="form-group">
                  <label for="descripcion">Descripción Detallada <span class="required">*</span></label>
                  <textarea id="descripcion" v-model="form.descripcion" rows="2" required placeholder="Describe el problema en detalle..."></textarea>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label for="areaSolicita"> Área que Solicita <span class="required">*</span></label>
                    <div class="autocomplete-container">
                      <v-autocomplete
                        id="areaSolicita"
                        v-model="form.areaSolicita"
                        :items="areasDisponibles"
                        item-text="nombre"
                        item-value="nombre"
                        :filter="filtrarAreas"
                        label="Selecciona o escribe el área"
                        placeholder="Ej: Quirófano, Enfermería"
                        :rules="[v => !!v || 'El área es requerida']"
                        required
                        clearable
                        dense
                        outlined
                        hide-details
                        class="area-autocomplete"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item @click="form.areaSolicita = ''">
                            <v-list-item-content>
                              <v-list-item-title>Limpiar selección</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="ubicacion"> Ubicación Específica <span class="required">*</span></label>
                    <div class="autocomplete-container">
                      <v-combobox
                        id="ubicacion"
                        v-model="form.ubicacion"
                        :items="areasDisponibles"
                        item-text="nombre"
                        item-value="nombre"
                        :filter="filtrarAreas"
                        label="Selecciona o escribe la ubicación"
                        placeholder="Ej: Quirófano, Oficina 3"
                        :rules="[v => !!v || 'La ubicación es requerida']"
                        required
                        clearable
                        dense
                        outlined
                        hide-details
                        class="area-autocomplete"
                      />
                    </div>
                  </div>
                </div>

                <!-- Notas -->
                <div class="form-group">
                  <label for="notas">Notas y Comentarios</label>
                  <textarea id="notas" v-model="form.notas" rows="1" placeholder="Información adicional útil para el técnico..."></textarea>
                </div>
              </div>

              <!-- SECCIÓN INSUMOS -->
              <div v-if="biomedicaTab === 'insumos'" class="tab-panel">
                <div class="form-row">
                  <div class="form-group">
                    <label for="areaSolicita"> Área que Solicita <span class="required">*</span></label>
                    <div class="autocomplete-container">
                      <v-autocomplete
                        id="areaSolicita"
                        v-model="form.areaSolicita"
                        :items="areasDisponibles"
                        item-text="nombre"
                        item-value="nombre"
                        :filter="filtrarAreas"
                        label="Selecciona o escribe el área"
                        placeholder="Ej: Quirófano, Enfermería"
                        :rules="[v => !!v || 'El área es requerida']"
                        required
                        clearable
                        dense
                        outlined
                        hide-details
                        class="area-autocomplete"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item @click="form.areaSolicita = ''">
                            <v-list-item-content>
                              <v-list-item-title>Limpiar selección</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="ubicacion"> Ubicación Específica</label>
                    <div class="autocomplete-container">
                      <v-combobox
                        id="ubicacion"
                        v-model="form.ubicacion"
                        :items="areasDisponibles"
                        item-text="nombre"
                        item-value="nombre"
                        :filter="filtrarAreas"
                        label="Selecciona o escribe la ubicación"
                        placeholder="Ej: Quirófano, Oficina 3"
                        clearable
                        dense
                        outlined
                        hide-details
                        class="area-autocomplete"
                      />
                    </div>
                  </div>
                </div>

                <!-- Formulario de insumos -->
                <div class="form-group">
                  <label for="insumos">📦 Insumos Requeridos <span class="required">*</span></label>
                  <div class="autocomplete-container">
                    <input
                      id="insumos"
                      v-model="form.insumos"
                      type="text"
                      placeholder="Ej: Cartuchos de tinta, Papel, Consumibles médicos, etc."
                      @input="buscarSugerenciasInsumos"
                      @focus="mostrarSugerencias = true"
                      @blur="ocultarSugerencias"
                    />
                    <div v-if="mostrarSugerencias && sugerenciasInsumos.length > 0" class="sugerencias-dropdown">
                      <div
                        v-for="sugerencia in sugerenciasInsumos"
                        :key="sugerencia.textoCompleto"
                        class="sugerencia-item"
                        @mousedown="seleccionarSugerencia(sugerencia)"
                      >
                        <div class="sugerencia-descripcion">{{ sugerencia.descripcion }}</div>
                        <div class="sugerencia-presentacion">{{ sugerencia.presentacion }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="cantidadInsumos">🔢 Cantidad Requerida</label>
                    <div class="quantity-counter">
                      <button type="button" @click="decrementarCantidad" class="counter-btn">-</button>
                      <input id="cantidadInsumos" v-model="form.cantidadInsumos" type="number" min="1" max="999" class="counter-input" />
                      <button type="button" @click="incrementarCantidad" class="counter-btn">+</button>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="descripcionInsumos">Observaciones</label>
                    <textarea id="descripcionInsumos" v-model="form.descripcionInsumos" rows="2" placeholder="Ej: 1 caja de 60 cubrebocas, 2 paquetes de papel A4, etc..."></textarea>
                  </div>
                  <div class="form-group">
                    <label>&nbsp;</label>
                    <button type="button" @click="agregarInsumo" class="btn-agregar-insumo">+ Agregar Insumo</button>
                  </div>
                </div>

                <!-- Lista de insumos agregados -->
                <div v-if="form.listaInsumos.length > 0" class="lista-insumos">
                  <label>📋 Insumos Agregados:</label>
                  <div v-for="(insumo, index) in form.listaInsumos" :key="index" class="insumo-item">
                    <div class="insumo-info">
                      <strong>{{ insumo.nombre }}</strong>
                      <span class="insumo-cantidad">Cantidad: {{ insumo.cantidad }}</span>
                      <span v-if="insumo.descripcion" class="insumo-descripcion">{{ insumo.descripcion }}</span>
                    </div>
                    <button type="button" @click="eliminarInsumo(index)" class="btn-eliminar-insumo">✕</button>
                  </div>
                </div>
              </div>

              <!-- SECCIÓN EQUIPO -->
              <div v-if="biomedicaTab === 'equipo'" class="tab-panel">
                <div class="form-row">
                  <div class="form-group">
                    <label for="areaSolicita"> Área que Solicita <span class="required">*</span></label>
                    <div class="autocomplete-container">
                      <v-autocomplete
                        id="areaSolicita"
                        v-model="form.areaSolicita"
                        :items="areasDisponibles"
                        item-text="nombre"
                        item-value="nombre"
                        :filter="filtrarAreas"
                        label="Selecciona o escribe el área"
                        placeholder="Ej: Quirófano, Enfermería"
                        :rules="[v => !!v || 'El área es requerida']"
                        required
                        clearable
                        dense
                        outlined
                        hide-details
                        class="area-autocomplete"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item @click="form.areaSolicita = ''">
                            <v-list-item-content>
                              <v-list-item-title>Limpiar selección</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="ubicacion"> Ubicación Específica <span class="required">*</span></label>
                    <div class="autocomplete-container">
                      <v-combobox
                        id="ubicacion"
                        v-model="form.ubicacion"
                        :items="areasDisponibles"
                        item-text="nombre"
                        item-value="nombre"
                        :filter="filtrarAreas"
                        label="Selecciona o escribe la ubicación"
                        placeholder="Ej: Quirófano, Oficina 3"
                        :rules="[v => !!v || 'La ubicación es requerida']"
                        required
                        clearable
                        dense
                        outlined
                        hide-details
                        class="area-autocomplete"
                      />
                    </div>
                  </div>
                </div>

                <!-- Formulario de equipo -->
                <!-- Escáner QR para equipo biomédico -->
                <div class="qr-scanner-section">
                  <div class="qr-scanner-header">
                    <label class="qr-label">
                      <span class="qr-icon">📷</span> Escanear Código QR del Equipo
                    </label>
                    <button 
                      type="button" 
                      class="qr-scan-btn" 
                      @click="abrirQrScanner"
                      :disabled="isScanningQr"
                    >
                      <span v-if="!isScanningQr">🔍 Escanear QR</span>
                      <span v-else>⏳ Escaneando...</span>
                    </button>
                  </div>
                  
                  <!-- Input manual de QR ID -->
                  <div class="qr-manual-input">
                    <div class="input-with-button">
                      <input 
                        v-model="qrInputId" 
                        type="text" 
                        placeholder="O ingresa el ID del QR manualmente..."
                        @keyup.enter="buscarEquipoPorQr(qrInputId)"
                        :disabled="isLoadingEquipo"
                      />
                      <button 
                        type="button" 
                        class="search-btn"
                        @click="buscarEquipoPorQr(qrInputId)"
                        :disabled="!qrInputId || isLoadingEquipo"
                      >
                        <span v-if="!isLoadingEquipo">🔍 Buscar</span>
                        <span v-else>⏳</span>
                      </button>
                    </div>
                  </div>
                  
                  <!-- Resultado del escaneo -->
                  <div v-if="equipoEscaneado" class="qr-result success">
                    <div class="qr-result-header">
                      <span class="success-icon">✅</span>
                      <span class="success-text">Equipo encontrado</span>
                    </div>
                    <div class="equipo-info-escaneado">
                      <p><strong>Marca:</strong> {{ equipoEscaneado.marca || 'N/A' }}</p>
                      <p><strong>Modelo:</strong> {{ equipoEscaneado.modelo || 'N/A' }}</p>
                      <p><strong>Descripción:</strong> {{ equipoEscaneado.descripcion || 'N/A' }}</p>
                      <p><strong>N° Serie:</strong> {{ equipoEscaneado.numeroSerie || 'N/A' }}</p>
                    </div>
                    <button type="button" class="clear-btn" @click="limpiarEquipoEscaneado">
                      ❌ Limpiar
                    </button>
                  </div>
                  
                  <div v-if="qrError" class="qr-result error">
                    <span class="error-icon">❌</span>
                    <span class="error-text">{{ qrError }}</span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="equipo">🔧 Equipo Afectado <span class="required">*</span></label>
                  <input id="equipo" v-model="form.equipo" type="text" required placeholder="Ej: Sistema de aire acondicionado, Computadora, etc." />
                </div>
                <div class="form-group">
                  <label for="serialNumber">🏷️ Número de Serie</label>
                  <input id="serialNumber" v-model="form.serialNumber" type="text" placeholder="Número de serie (si aplica)" />
                </div>
                <div class="form-group">
                  <label for="descripcionEquipo">Detalles del equipo</label>
                  <textarea
                    id="descripcionEquipo"
                    v-model="form.descripcionEquipo"
                    rows="3"
                    placeholder="Ej: Diagnóstico, mensajes de error, configuración, etc..."
                  ></textarea>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>

          <!-- Botones de Acción -->
          <div class="modal-actions">
            <button type="button" @click="cerrarFormulario" class="cancel-btn">❌ Cancelar</button>
            <button type="submit" class="submit-btn" @click="probarBoton" :disabled="isCreatingTicket">
              <span v-if="!isCreatingTicket">✅ {{ tipoFormulario === 'gestion_informacion' ? 'Enviar Solicitud' : 'Crear Ticket' }}</span>
              <span v-else>⏳ {{ tipoFormulario === 'gestion_informacion' ? 'Enviando...' : 'Creando...' }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal: Chat técnicos (Telegram) -->
    <div v-if="showTelegramChatModal" class="modal-overlay" @click.self="cerrarTelegramChat">
      <div class="modal-content form-modal telegram-chat-modal" @click.stop>
        <div class="modal-header">
          <h3>Chat Técnicos (Telegram)</h3>
          <button class="close-btn" @click="cerrarTelegramChat">✕</button>
        </div>

        <div class="telegram-chat-body">
          <div class="telegram-chat-layout">
            <div class="telegram-sidebar">
              <div class="telegram-sidebar-header">
                <div class="telegram-sidebar-title">Técnicos</div>
                <button
                  type="button"
                  class="telegram-refresh"
                  @click="cargarTecnicosTelegram"
                  :disabled="chatLoading"
                >
                  Actualizar
                </button>
              </div>
              <div class="telegram-sidebar-list">
                <button
                  v-for="t in chatTecnicos"
                  :key="t.id"
                  type="button"
                  class="telegram-contact"
                  :class="String(t.id) === String(chatTecnicoSeleccionadoId) ? 'active' : ''"
                  @click="seleccionarTecnicoChat(t)"
                >
                  <div class="telegram-contact-name">{{ t.nombre }}</div>
                  <div class="telegram-contact-meta">{{ t.area }}</div>
                </button>
              </div>
            </div>

            <div class="telegram-thread">
              <div class="telegram-thread-header">
                <div class="telegram-thread-title">
                  {{ nombreTecnicoSeleccionado || 'Selecciona un técnico' }}
                </div>
                <button
                  type="button"
                  class="telegram-refresh"
                  @click="cargarMensajesTelegram"
                  :disabled="chatLoading || !chatTecnicoSeleccionadoId"
                >
                  <span v-if="!chatLoading">Actualizar</span>
                  <span v-else>Cargando...</span>
                </button>
              </div>

              <div class="telegram-messages" ref="telegramMessages">
                <div v-if="!chatTecnicoSeleccionadoId" class="telegram-empty">
                  Selecciona un técnico para iniciar.
                </div>
                <div v-else-if="chatMensajes.length === 0" class="telegram-empty">
                  Sin mensajes.
                </div>
                <div v-else>
                  <div
                    v-for="(m, idx) in chatMensajes"
                    :key="m.ts ? String(m.ts) + '-' + idx : idx"
                    class="telegram-msg"
                    :class="m.dir === 'out' ? 'out' : 'in'"
                  >
                    <div class="telegram-msg-meta">
                      <span class="telegram-msg-name">{{ m.nombre || (m.dir === 'out' ? 'Tú' : 'Técnico') }}</span>
                      <span class="telegram-msg-time">{{ formatearHoraChat(m.ts) }}</span>
                    </div>
                    <div class="telegram-msg-text">{{ m.texto }}</div>
                  </div>
                </div>
              </div>

              <div class="telegram-input-row">
                <input
                  v-model="chatTexto"
                  type="text"
                  placeholder="Escribe un mensaje..."
                  @keyup.enter="enviarMensajeTelegram"
                  :disabled="!chatTecnicoSeleccionadoId"
                />
                <button class="submit-btn" type="button" @click="enviarMensajeTelegram" :disabled="!chatTecnicoSeleccionadoId || !chatTexto.trim()">
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal rápido: Garrafón de agua -->
    <div v-if="showGarrafonModal" class="modal-overlay" @click.self="cerrarGarrafonModal">
      <div class="modal-content form-modal" @click.stop>
        <div class="modal-header">
          <h3>Solicitar garrafón de agua</h3>
          <button class="close-btn" @click="cerrarGarrafonModal">✕</button>
        </div>
        <form class="ticket-form-modal" @submit.prevent="crearTicketGarrafon">
          <div class="form-row">
            <div class="form-group">
              <label for="garrafonAreaSolicita">Área que solicita <span class="required">*</span></label>
              <div class="autocomplete-container">
                <v-autocomplete
                  id="garrafonAreaSolicita"
                  v-model="garrafonForm.areaSolicita"
                  :items="areasDisponibles"
                  item-text="nombre"
                  item-value="nombre"
                  :filter="filtrarAreas"
                  label="Selecciona o escribe el área"
                  placeholder="Ej: Secretaría, Enfermería"
                  required
                  clearable
                  dense
                  outlined
                  hide-details
                  class="area-autocomplete"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="garrafonUbicacion">Ubicación específica <span class="required">*</span></label>
              <v-combobox
                id="garrafonUbicacion"
                v-model="garrafonForm.ubicacion"
                :items="areasDisponibles"
                item-text="nombre"
                item-value="nombre"
                :filter="filtrarAreas"
                placeholder="Selecciona o escribe la ubicación..."
                required
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="garrafonCantidad">Cantidad de garrafones <span class="required">*</span></label>
              <input
                id="garrafonCantidad"
                v-model.number="garrafonForm.cantidad"
                type="number"
                min="1"
                max="99"
                required
                placeholder="Ej: 1"
              />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" @click="cerrarGarrafonModal" class="cancel-btn">Cancelar</button>
            <button type="submit" class="submit-btn" :disabled="garrafonLoading">
              <span v-if="!isCreatingTicket">Crear Ticket</span>
              <span v-else>Creando...</span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Componente de Estadísticas -->
    <TicketStatsModal
      :showTicketsCreadosResueltos="showTicketsCreadosResueltos"
      :showTiempoPromedio="showTiempoPromedio"
      :showTicketsPorTecnico="showTicketsPorTecnico"
      :showTicketsPorArea="showTicketsPorArea"
      :showProblemasComunes="showProblemasMasComunes"
      :showEstadisticasPreventivas="showEstadisticasPreventivas"
      :tickets="tickets"
      @cerrar-tickets-creados-resueltos="cerrarTicketsCreadosResueltos"
      @cerrar-tiempo-promedio="cerrarTiempoPromedio"
      @cerrar-tickets-por-tecnico="cerrarTicketsPorTecnico"
      @cerrar-tickets-por-area="cerrarTicketsPorArea"
      @cerrar-problemas-comunes="cerrarProblemasMasComunes"
      @cerrar-estadisticas-preventivas="cerrarEstadisticasPreventivas"
    />

    <!-- Modal de Reasignación -->
    <div v-if="showReassignModal" class="modal-overlay" @click="cancelarReasignacion">
      <div class="modal-content reassign-modal" @click.stop>
        <div class="modal-header">
          <h3>🔄 Reasignar Ticket #{{ ticketToReassign ? ticketToReassign.id : '' }}</h3>
          <button @click="cancelarReasignacion" class="close-btn">&times;</button>
        </div>
        
        <div class="modal-body">
          <div class="reassign-info">
            <p><strong>Ticket:</strong> {{ ticketToReassign ? ticketToReassign.titulo : '' }}</p>
            <p><strong>Área actual:</strong> {{ getSolicitudText(ticketToReassign ? ticketToReassign.solicitudArea : null) }}</p>
          </div>
          
          <div class="form-group">
            <label for="razonReasignacion">📝 Razón de la reasignación <span class="required">*</span></label>
            <textarea 
              id="razonReasignacion"
              v-model="reassignData.razon" 
              placeholder="Explica por qué necesitas reasignar este ticket..."
              rows="3"
              required
            ></textarea>
          </div>
          
          <div class="form-group">
            <label for="nuevaAreaReasignacion">🎯 Área de destino <span class="required">*</span></label>
            <select id="nuevaAreaReasignacion" v-model="reassignData.nuevaArea" required>
              <option value="">Selecciona el área de destino</option>
              <option value="TECNOLOGIAS">Tecnologías</option>
              <option value="MANTENIMIENTO">Mantenimiento</option>
              <option value="BIOMEDICA">Biomédica</option>
            </select>
          </div>
        </div>
        
        <div class="modal-footer">
          <button @click="cancelarReasignacion" class="btn btn-secondary">Cancelar</button>
          <button @click="confirmarReasignacion" class="btn btn-primary">Confirmar Reasignación</button>
        </div>
      </div>
    </div>

    <!-- Modal de Equipo de Técnicos -->
    <div v-if="showEquipoModal" class="modal-overlay" @click="cancelarEquipo">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>👥 Asignar Equipo - Ticket {{ generarFolio(ticketParaEquipo) }}</h3>
          <button @click="cancelarEquipo" class="close-btn">&times;</button>
        </div>
        <div class="modal-body">
          <p>Selecciona entre 2 y 3 técnicos para conformar un equipo.</p>
          <div class="checkbox-list">
            <label v-for="tecnico in listaTecnicos" :key="tecnico.id" class="checkbox-item">
              <input type="checkbox" :value="tecnico.id" v-model="equipoSeleccionado" 
                     :disabled="equipoSeleccionado.length >= 3 && !equipoSeleccionado.includes(tecnico.id)">
              {{ tecnico.nombre }}
            </label>
          </div>
          <div v-if="equipoSeleccionado.length < 2" class="validation-message">Selecciona al menos 2 técnicos.</div>
          <div v-if="equipoSeleccionado.length > 3" class="validation-message">Máximo 3 técnicos permitidos.</div>
        </div>
        <div class="modal-footer">
          <button @click="cancelarEquipo" class="btn btn-secondary">Cancelar</button>
          <button @click="asignarEquipo" class="btn btn-primary" :disabled="equipoSeleccionado.length < 2 || equipoSeleccionado.length > 3">Asignar</button>
        </div>
      </div>
  </div>
  
  <!-- Modal de Cancelación (al final del contenedor raíz para z-index correcto) -->
  <div v-if="showCancelModal" class="modal-overlay modal-cancelacion" @click="cancelarCancelacion">
    <div class="modal-content cancel-modal" @click.stop>
      <div class="modal-header">
        <h3>❌ Cancelar Ticket {{ generarFolio(ticketToCancel) }}</h3>
        <button @click="cancelarCancelacion" class="close-btn">&times;</button>
      </div>
      <div class="modal-body">
        <div class="cancel-info">
          <p><strong>Ticket:</strong> {{ ticketToCancel ? ticketToCancel.titulo : '' }}</p>
          <p><strong>Estado actual:</strong> {{ getEstadoText(ticketToCancel ? ticketToCancel.estado : null, esAdmin, ticketToCancel ? ticketToCancel.esGestionInformacion : null) }}</p>
          <p><strong>Área:</strong> {{ getSolicitudText(ticketToCancel ? ticketToCancel.solicitudArea : null) }}</p>
        </div>
        
        <div class="form-group">
          <label for="motivoCancelacion">📝 Motivo de la cancelación <span class="required">*</span></label>
          <textarea 
            id="motivoCancelacion"
            v-model="cancelData.motivo" 
            placeholder="Explica por qué necesitas cancelar este ticket..."
            rows="4"
            required
          ></textarea>
        </div>
        
        <div class="warning-message">
          <p>⚠️ <strong>Advertencia:</strong> Una vez cancelado, este ticket no podrá ser reabierto. Asegúrate de que la cancelación sea necesaria.</p>
        </div>
      </div>
      
      <div class="modal-footer">
        <button @click="cancelarCancelacion" class="btn btn-secondary">No Cancelar</button>
        <button @click="confirmarCancelacion" class="btn btn-danger">Confirmar Cancelación</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InsumosService from './insumos-service.js';
// ✅ InsumosService se conecta al BACKEND (InsumosController.groovy)
import TicketStatsModal from './TicketStatsModal.vue';
import solucionesBasicasTickets from '@/utils/solucionesBasicasTickets.json';


export default {
  name: 'TicketForm',
  props: {
    role: {
      type: String,
      default: 'personal',
    },
    userName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isCreatingTicket: false, // Estado de carga para el botón crear ticket
      diagnosticoLoading: false,
      showTelegramChatModal: false,
      chatTecnicos: [],
      chatTecnicoSeleccionadoId: '',
      chatMensajes: [],
      chatTexto: '',
      chatLoading: false,
      chatPollingId: null,
      showGarrafonModal: false,
      garrafonLoading: false,
      garrafonForm: {
        areaSolicita: '',
        ubicacion: '',
        cantidad: 1
      },
      showManualesModal: false,
      showConfirmacionPacienteModal: false,
      pacienteConfirmado: false,
      biomedicaTab: 'solicitud', // Pestaña activa para área biomédica
      form: {
        nombre: '',
        titulo: '',
        descripcion: '',
        areaSolicita: '',
        ubicacion: '',
        equipo: '',
        tieneEquipo: false,
        descripcionEquipo: '',
        tieneInsumos: false,
        insumos: '',
        descripcionInsumos: '',
        cantidadInsumos: 1,
        listaInsumos: [], // Array para múltiples insumos
        solicitudArea: 'TECNOLOGIAS',
        serialNumber: '',
        notas: '',
        fechaCreacion: '',
        fechaCierre: '',
        // Campos para gestión de información
        accionSolicitada: '',
        motivo: '',
        descripcionDetallada: '',
        auditoriaAceptada: false,
        // Campos para PDFs
        pdfFiles: [], // Array para archivos PDF seleccionados
        pdfUploadLoading: false, // Estado de carga para subida de PDFs
        // Campos adicionales para PDFs en detalle
        pdfDetailFiles: [], // Archivos PDF seleccionados en el detalle
        pdfDetailUploadLoading: false, // Estado de carga para subida de PDFs en detalle
      },
      tickets: [],
      nextId: 1,
      ticketDetalle: null,
      showTicketDetail: false,
      mostrarAccionesEstadisticas: false,
      showFormModal: false,
      showTipoTicketModal: false,
      tipoFormulario: 'crear_ticket', // 'crear_ticket' o 'gestion_informacion'
      showTicketsCreadosResueltos: false,
      showTiempoPromedio: false,
      showTicketsPorTecnico: false,
      showTicketsPorArea: false,
      showProblemasMasComunes: false,
      showEstadisticasPreventivas: false,
      filtroArea: '',
      filtroPrioridad: '',
      filtroEstado: 'activos', // 'activos', 'resueltos', 'cancelados', 'todos'
      filtroGestionInformacion: '', // 'pendientes', 'revision', 'rechazados', 'ejecutados', 'todos_gestion'
      filtroTurno: '', // '', 'manana', 'tarde', 'noche'
      areasDisponibles: [], // Lista de áreas desde catalogo_areas
      // Formulario para nueva solución
            nuevaSolucion: {
              solucion: '',
              tipo: 'solucion_inicial',
              imagenes: []
            },
            guardandoSolucion: false,
            // Variables para dictamen técnico
            showDictamenModal: false,
            guardandoDictamen: false,
            dictamenTecnico: {
              equipo: '',
              marca: '',
              modelo: '',
              numeroSerie: '',
              descripcion: '',
              recomendaciones: '',
              conclusion: ''
            },
            // Modal para ver imágenes
            imagenModal: {
              visible: false,
              imagen: { nombre: '', url: '' }
            },
      listaTecnicos: [], // Se cargarán desde el backend (array de objetos {id, nombre})
      listaTecnicosNombres: [], // Solo nombres para compatibilidad
      // Propiedades para autocompletado de insumos
      sugerenciasInsumos: [],
      mostrarSugerencias: false,
      // Variable para guardar estados anteriores de solicitud
      solicitudAreaAnterior: {},
      // Variables para manejo de fotos adjuntas
      fotosSeleccionadas: [],
      // Variables para modal de reasignación
      showReassignModal: false,
      ticketToReassign: null,
      reassignData: {
        razon: '',
        nuevaArea: ''
      },
      // Variables para modal de cancelación
      showCancelModal: false,
      showEquipoModal: false,
      equipoSeleccionado: [],
      ticketParaEquipo: null,
      ticketToCancel: null,
      cancelData: {
        motivo: ''
      },
      historialSoluciones: [],

      showChatbot: false,
      chatbotProblema: '',
      chatbotLoading: false,
      chatbotResultados: [],
      chatbotKeywords: [],
      chatbotError: '',
      chatbotBuscado: false,
      chatbotMensajes: [],
      chatbotUltimoProblema: '',
      chatbotEsperandoConfirmacion: false,

      botPhrases: [
        '¿Necesitas ayuda?',
        'Hola, estoy para ayudarte.',
        'Bienvenido al sistema de soporte técnico.'
      ],
      botPhraseIndex: 0,
      botPhraseIntervalId: null,
      
      // Variables para escaneo QR de equipo biomédico
      qrInputId: '',
      equipoEscaneado: null,
      isScanningQr: false,
      isLoadingEquipo: false,
      qrError: '',
      showQrScannerModal: false,
    };
  },
  computed: {
    textoParaDiagnostico() {
      const t = (this.form?.titulo || '').toString();
      const d = (this.form?.descripcion || '').toString();
      return `${t} ${d}`.toLowerCase();
    },
    tipoDiagnosticoDetectado() {
      const texto = this.textoParaDiagnostico;
      const internet = [
        'internet',
        'red',
        'sin red',
        'no hay red',
        'wifi',
        'wi fi',
        'conexión',
        'conexion',
        'sin internet',
        'no hay internet'
      ];
      const lenta = [
        'computadora lenta',
        'pc lenta',
        'lenta',
        'se traba',
        'se congela',
        'muy lenta'
      ];

      const contiene = (arr) => arr.some(k => texto.includes(k));
      if (contiene(internet)) return 'Internet / Red';
      if (contiene(lenta)) return 'Computadora lenta';
      return '';
    },
    mostrarDiagnosticoAutomatico() {
      return !!this.tipoDiagnosticoDetectado;
    },
    // Parsear información de diagnóstico automático del ticket actual
    diagnosticoAutomaticoInfo() {
      if (!this.ticketDetalle || !this.ticketDetalle.descripcion) {
        return null;
      }
      
      const descripcion = this.ticketDetalle.descripcion;
      if (!descripcion.includes('DIAGNÓSTICO AUTOMÁTICO')) {
        return null;
      }

      const lineas = descripcion.split('\n');
      const diagnostico = {
        titulo: '',
        datos: []
      };

      let enSeccionDiagnostico = false;
      
      for (let i = 0; i < lineas.length; i++) {
        const linea = lineas[i].trim();
        
        if (linea.includes('DIAGNÓSTICO AUTOMÁTICO')) {
          enSeccionDiagnostico = true;
          diagnostico.titulo = linea;
          continue;
        }
        
        if (enSeccionDiagnostico && linea) {
          // Detener al encontrar la sección de CLASIFICACIÓN AUTOMÁTICA
          if (linea.includes('CLASIFICACIÓN AUTOMÁTICA')) {
            break;
          }
          
          // Parsear líneas con formato "clave: valor"
          if (linea.includes(':')) {
            const [clave, valor] = linea.split(':').map(s => s.trim());
            diagnostico.datos.push({ clave, valor });
          }
        }
      }
      
      return diagnostico.datos.length > 0 ? diagnostico : null;
    },
    // Obtener descripción limpia sin información de diagnóstico
    descripcionLimpia() {
      if (!this.ticketDetalle || !this.ticketDetalle.descripcion) {
        return '';
      }
      
      const descripcion = this.ticketDetalle.descripcion;
      if (!descripcion.includes('DIAGNÓSTICO AUTOMÁTICO')) {
        return descripcion;
      }
      
      const lineas = descripcion.split('\n');
      const descripcionLimpia = [];
      
      for (const linea of lineas) {
        if (linea.includes('DIAGNÓSTICO AUTOMÁTICO')) {
          break;
        }
        descripcionLimpia.push(linea);
      }
      
      return descripcionLimpia.join('\n').trim();
    },
    botPhrase() {
      const arr = Array.isArray(this.botPhrases) ? this.botPhrases : [];
      if (arr.length === 0) return '';
      const idx = Math.min(Math.max(this.botPhraseIndex, 0), arr.length - 1);
      return arr[idx];
    },
    nombreTecnicoSeleccionado() {
      const id = (this.chatTecnicoSeleccionadoId || '').toString();
      if (!id) return '';
      const t = Array.isArray(this.chatTecnicos) ? this.chatTecnicos.find(x => String(x.id) === id) : null;
      return t?.nombre || '';
    },
    esAdmin() {
      // Verificar si el usuario es administrador (acceso total)
      const roles = this.$store.state.security.roles || [];
      const rolesArray = Array.isArray(roles) ? roles : (typeof roles === 'string' ? roles.split(',') : []);
      return rolesArray.some(r => r.trim() === 'ROLE_ADMIN');
    },
    
    esTecnico() {
      // Verificar si el usuario es técnico (cualquier tipo)
      const roles = this.$store.state.security.roles || [];
      const rolesArray = Array.isArray(roles) ? roles : (typeof roles === 'string' ? roles.split(',') : []);
      return rolesArray.some(r => 
        ['ROLE_TECNICO_MTTO', 'ROLE_TECNICO_TEC', 'ROLE_TECNICO_BIO'].includes(r.trim())
      );
    },
    
    esAdminOTecnico() {
      // Verificar si tiene permisos de administración (admin o técnico)
      return this.esAdmin || this.esTecnico;
    },
    
    areaTecnico() {
      // Determinar el área del técnico según su rol
      const roles = this.$store.state.security.roles || [];
      const rolesArray = Array.isArray(roles) ? roles : (typeof roles === 'string' ? roles.split(',') : []);
      
      if (rolesArray.some(r => r.trim() === 'ROLE_TECNICO_MTTO')) {
        return 'MANTENIMIENTO';
      }
      if (rolesArray.some(r => r.trim() === 'ROLE_TECNICO_TEC')) {
        return 'TECNOLOGIAS';
      }
      if (rolesArray.some(r => r.trim() === 'ROLE_TECNICO_BIO')) {
        return 'BIOMEDICA';
      }
      return null;
    },
    solucionesVisibles() {
      if (this.historialSoluciones && this.historialSoluciones.length > 0) {
        return this.historialSoluciones;
      }
      if (!this.ticketDetalle || !this.ticketDetalle.solucionesTecnico) {
        return [];
      }
      return this.ticketDetalle.solucionesTecnico;
    },
    
    ticketsFiltrados() {
      let tickets = this.tickets;

      // 1. FILTRO POR ROL - Determinar qué tickets puede ver el usuario
      if (this.esAdmin) {
        // Admin ve TODOS los tickets
        tickets = this.tickets;
      } else if (this.esTecnico && this.areaTecnico) {
        // Técnico ve solo tickets de su área
        tickets = this.tickets.filter(t =>
          t.solicitudArea?.toUpperCase() === this.areaTecnico
        );
      } else {
        // Usuario normal (ROLE_PACIENTES) ve todos los tickets de su hospital
        // Luego aplicamos la regla de 24h y el filtro por estado más abajo
        tickets = this.tickets;
      }

      // 2. Filtrar por área solicitante (filtro manual del usuario)
      if (this.filtroArea) {
        const filtroNormalizado = this.normalizarTexto(this.filtroArea);
        tickets = tickets.filter(t => this.normalizarTexto(t.areaSolicita) === filtroNormalizado);
      }

      // 3. Filtrar por prioridad (solo para administradores y técnicos, excluyendo solicitudes especiales)
      // Las solicitudes especiales (gestión de información, insumos, equipo afectado, garrafón) siempre se muestran
      if (this.esAdminOTecnico && this.filtroPrioridad) {
        tickets = tickets.filter(t =>
          t.tipo === 'GESTION_INFORMACION' ||
          t.tipo === 'INSUMOS' ||
          t.tipo === 'EQUIPO_AFECTADO' ||
          t.tipo === 'GARRAFON_AGUA' ||
          t.prioridad === this.filtroPrioridad
        );
      }

      // 4. Filtrar por turno
      if (this.filtroTurno) {
        tickets = tickets.filter(t => {
          const fechaCreacion = t.dateCreated || t.fechaCreacion;
          if (!fechaCreacion) return false;
          
          const fecha = new Date(fechaCreacion);
          const hora = fecha.getHours();
          const minutos = fecha.getMinutes();
          const horaDecimal = hora + (minutos / 60);
          
          switch (this.filtroTurno) {
            case 'manana':
              // Turno mañana: 6:00 - 14:00 (6am - 2pm)
              return horaDecimal >= 6 && horaDecimal < 14;
            case 'tarde':
              // Turno tarde: 14:00 - 22:00 (2pm - 10pm)
              return horaDecimal >= 14 && horaDecimal < 22;
            case 'noche':
              // Turno noche: 22:00 - 6:00 (10pm - 6am)
              return horaDecimal >= 22 || horaDecimal < 6;
            default:
              return true;
          }
        });
      }

      // 5. Regla de 24 horas para tickets resueltos de usuarios normales
      const MILISEGUNDOS_EN_DIA = 24 * 60 * 60 * 1000;

      const esTicketResueltoReciente = (ticket) => {
        // Si el ticket no está resuelto, no aplica la regla
        if (!ticket.esResuelto ) return true;
        
        // Para tickets resueltos, verificar la fecha de cierre
        const fechaCierre = this.obtenerFechaFinalizacion(ticket);
        if (!fechaCierre) return false;
        
        const fechaMs = new Date(fechaCierre).getTime();
        if (Number.isNaN(fechaMs)) return false;
        
        const diferencia = Date.now() - fechaMs;
        // Si la fecha es futura, mostrarlo de todos modos
        if (diferencia < 0) return true;
        
        // Solo mostrar si tiene menos de 24 horas de resuelto
        return diferencia <= MILISEGUNDOS_EN_DIA;
      };
      

      // 5. Aplicar filtro de estado
      if (this.esAdminOTecnico) {
        // Primero aplicar filtro de gestión de información si está activo
        if (this.filtroGestionInformacion && this.filtroGestionInformacion !== '') {
          switch (this.filtroGestionInformacion) {
            case 'pendientes':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'PENDIENTE');
              break;
            case 'revision':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'EN_PROCESO');
              break;
            case 'rechazados':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'CANCELADO');
              break;
            case 'ejecutados':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'RESUELTO');
              break;
            case 'todos_gestion':
              tickets = tickets.filter(t => t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion);
              break;
          }
        } else {
          // Aplicar filtro de estado general
          switch (this.filtroEstado) {
            case 'resueltos':
              // Mostrar TODOS los tickets resueltos sin importar el tiempo 
              tickets = tickets.filter(t => t.esResuelto);
              break;
            case 'cancelados':
              tickets = tickets.filter(t => t.esCancelado);
              break;
            case 'gestion_pendientes':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'PENDIENTE');
              break;
            case 'gestion_revision':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'EN_PROCESO');
              break;
            case 'gestion_rechazados':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'CANCELADO');
              break;
            case 'gestion_ejecutados':
              tickets = tickets.filter(t => (t.tipo === 'GESTION_INFORMACION' || t.esGestionInformacion) && t.estado === 'RESUELTO');
              break;
            case 'todos':
              // No aplicar filtro de estado
              break;
            case 'activos':
            default:
              // Mostrar solo tickets no finalizados
              tickets = tickets.filter(t => !this.esTicketFinalizado(t));
              break;
          }
        }
      } else {
        // Para usuarios normales:
        // - Mostrar tickets no finalizados
        // - Mostrar sus propios tickets resueltos en las últimas 24 horas
        tickets = tickets.filter(t => {
          if (!this.esTicketFinalizado(t)) return true;
          
          // Si es un ticket resuelto, verificar si es del usuario y reciente
          if (t.esResuelto) {
            const usuarioId = this.$store.state.security.user?.id;
            if (!usuarioId) return false;

            // Determinar si el ticket pertenece al usuario actual.
            const perteneceAlUsuario = (
              (t.usuarioId && t.usuarioId === usuarioId) ||
              (t.solicitanteId && t.solicitanteId === usuarioId) ||
              // Fallback: comparar por nombre de usuario si no hay ids
              (t.nombre && this.$store.state.security.username && t.nombre === this.$store.state.security.username)
            );

            return perteneceAlUsuario && (esTicketResueltoReciente(t));
          }
          
          return false;
        });
      }


      // 5. Ordenar tickets activos por prioridad dejando finales al final
      tickets.sort((a, b) => {
        const esFinalizadoA = this.esTicketFinalizado(a);
        const esFinalizadoB = this.esTicketFinalizado(b);
        if (esFinalizadoA !== esFinalizadoB) {
          return esFinalizadoA ? 1 : -1; // Finalizados siempre al final
        }

        const prioridadA = this.obtenerNivelPrioridad(a.prioridad);
        const prioridadB = this.obtenerNivelPrioridad(b.prioridad);

        if (prioridadA !== prioridadB) {
          return prioridadB - prioridadA;
        }

        const fechaA = new Date(a.fechaCreacion);
        const fechaB = new Date(b.fechaCreacion);
        return fechaB - fechaA; // Más recientes primero
      });

      return tickets;
    },
  },
  mounted() {
    // Establecer el nombre del usuario logueado desde el store
    if (this.userName) {
      this.form.nombre = this.userName;
    } else if (this.$store.state.security.username) {
      this.form.nombre = this.$store.state.security.username;
    }
    
    // Cargar datos desde el backend
    this.cargarTicketsDesdeBackend();
    this.cargarTecnicosDesdeBackend();
    this.cargarAreasDesdeBackend();

    this.iniciarRotacionFrasesBot();
  },
  beforeDestroy() {
    this.detenerRotacionFrasesBot();
    this.detenerPollingChat();
  },
  components: {
    TicketStatsModal
  },
  methods: {
    async abrirTelegramChat() {
      this.showTelegramChatModal = true;
      this.chatTexto = '';
      await this.cargarTecnicosTelegram();
      this.iniciarPollingChat();
    },
    cerrarTelegramChat() {
      this.showTelegramChatModal = false;
      this.detenerPollingChat();
      this.chatMensajes = [];
      this.chatTexto = '';
      this.chatTecnicoSeleccionadoId = '';
    },
    seleccionarTecnicoChat(t) {
      const id = t?.id !== undefined && t?.id !== null ? String(t.id) : '';
      if (!id) return;
      if (String(this.chatTecnicoSeleccionadoId) === id) return;
      this.chatTecnicoSeleccionadoId = id;
      this.cargarMensajesTelegram();
    },
    iniciarPollingChat() {
      this.detenerPollingChat();
      this.chatPollingId = setInterval(() => {
        if (!this.showTelegramChatModal) return;
        if (!this.chatTecnicoSeleccionadoId) return;
        this.cargarMensajesTelegram(false);
      }, 5000);
    },
    detenerPollingChat() {
      if (this.chatPollingId) {
        clearInterval(this.chatPollingId);
        this.chatPollingId = null;
      }
    },
    async cargarTecnicosTelegram() {
      try {
        const res = await this.$http({
          url: '/telegramChat/tecnicos',
          method: 'GET'
        });
        if (res.data && (res.data.success || res.data.estado)) {
          this.chatTecnicos = Array.isArray(res.data.root) ? res.data.root : [];
        } else {
          this.chatTecnicos = [];
        }
      } catch (e) {
        this.chatTecnicos = [];
      }
    },
    async cargarMensajesTelegram(mostrarCarga = true) {
      if (!this.chatTecnicoSeleccionadoId) {
        this.chatMensajes = [];
        return;
      }
      if (mostrarCarga) this.chatLoading = true;
      try {
        const res = await this.$http({
          url: '/telegramChat/mensajes',
          method: 'GET',
          params: {
            tecnicoId: this.chatTecnicoSeleccionadoId
          }
        });
        if (res.data && (res.data.success || res.data.estado)) {
          this.chatMensajes = Array.isArray(res.data.root) ? res.data.root : [];
          this.$nextTick(() => this.scrollTelegramToBottom());
        }
      } catch (e) {
        return;
      } finally {
        if (mostrarCarga) this.chatLoading = false;
      }
    },
    async enviarMensajeTelegram() {
      const texto = (this.chatTexto || '').toString().trim();
      if (!texto || !this.chatTecnicoSeleccionadoId) return;
      try {
        await this.$http({
          url: '/telegramChat/enviar',
          method: 'POST',
          data: {
            tecnicoId: this.chatTecnicoSeleccionadoId,
            texto: texto
          }
        });
        this.chatTexto = '';
        await this.cargarMensajesTelegram(false);
      } catch (e) {
        this.mostrarNotificacion('No se pudo enviar el mensaje');
      }
    },
    scrollTelegramToBottom() {
      try {
        const el = this.$refs.telegramMessages;
        if (!el) return;
        el.scrollTop = el.scrollHeight;
      } catch (e) {
        return;
      }
    },
    formatearHoraChat(ts) {
      if (!ts) return '';
      try {
        const d = new Date(Number(ts));
        return d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      } catch (e) {
        return '';
      }
    },
    detectarNavegadorSO() {
      const ua = (navigator.userAgent || '').toString();
      const plataforma = (navigator.platform || '').toString();

      let navegador = 'No disponible';
      if (/edg\//i.test(ua)) navegador = 'Edge';
      else if (/chrome\//i.test(ua) && !/edg\//i.test(ua)) navegador = 'Chrome';
      else if (/firefox\//i.test(ua)) navegador = 'Firefox';
      else if (/safari\//i.test(ua) && !/chrome\//i.test(ua)) navegador = 'Safari';

      let so = 'No disponible';
      if (/windows nt/i.test(ua)) so = 'Windows';
      else if (/android/i.test(ua)) so = 'Android';
      else if (/iphone|ipad|ipod/i.test(ua)) so = 'iOS';
      else if (/mac os x/i.test(ua)) so = 'macOS';
      else if (/linux/i.test(ua)) so = 'Linux';

      return { navegador, so, plataforma };
    },
    async medirLatenciaServidorMs() {
      try {
        const t0 = performance.now();
        await this.$http({
          url: '/mantenimiento/tickets/listarTickets',
          method: 'GET',
          params: { _ping: Date.now() },
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });
        const t1 = performance.now();
        const ms = Math.max(0, Math.round(t1 - t0));
        return ms;
      } catch (e) {
        return null;
      }
    },
    async obtenerIpLocalBestEffort() {
      return await new Promise(resolve => {
        try {
          const RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
          if (!RTCPeerConnection) return resolve('No disponible');

          const pc = new RTCPeerConnection({ iceServers: [] });
          pc.createDataChannel('');
          pc.onicecandidate = (evt) => {
            try {
              if (!evt || !evt.candidate || !evt.candidate.candidate) return;
              const cand = evt.candidate.candidate;
              const match = cand.match(/(\d{1,3}(?:\.\d{1,3}){3})/);
              if (match && match[1]) {
                resolve(match[1]);
                pc.onicecandidate = null;
                pc.close();
              }
            } catch (e) {
              resolve('No disponible');
            }
          };
          pc.createOffer()
            .then(offer => pc.setLocalDescription(offer))
            .catch(() => resolve('No disponible'));

          setTimeout(() => {
            try { pc.close(); } catch (e) { return; }
            resolve('No disponible');
          }, 1200);
        } catch (e) {
          resolve('No disponible');
        }
      });
    },
    async ejecutarDiagnosticoAutomatico() {
      if (this.diagnosticoLoading) return;
      this.diagnosticoLoading = true;
      try {
        this.form.tieneEquipo = true;
        if (!this.form.equipo) {
          this.form.equipo = this.tipoDiagnosticoDetectado === 'Internet / Red' ? 'Red / Internet' : 'Computadora';
        }

        const usuario = (this.userName || this.$store?.state?.security?.user?.username || this.$store?.state?.security?.username || '').toString().trim() || 'No disponible';
        const idioma = (navigator.language || '').toString();
        const infoNav = this.detectarNavegadorSO();
        const latenciaMs = await this.medirLatenciaServidorMs();

        const conexion = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const red = {
          effectiveType: conexion?.effectiveType || 'No disponible',
          downlinkMbps: (conexion?.downlink !== undefined && conexion?.downlink !== null) ? String(conexion.downlink) : 'No disponible',
          rttMs: (conexion?.rtt !== undefined && conexion?.rtt !== null) ? String(conexion.rtt) : 'No disponible',
          saveData: (conexion?.saveData !== undefined && conexion?.saveData !== null) ? String(conexion.saveData) : 'No disponible'
        };

        let storage = { usage: 'No disponible', quota: 'No disponible' };
        try {
          if (navigator.storage?.estimate) {
            const est = await navigator.storage.estimate();
            const usageMB = est?.usage ? (est.usage / (1024 * 1024)).toFixed(1) : null;
            const quotaMB = est?.quota ? (est.quota / (1024 * 1024)).toFixed(1) : null;
            storage = {
              usage: usageMB ? `${usageMB} MB` : 'No disponible',
              quota: quotaMB ? `${quotaMB} MB` : 'No disponible'
            };
          }
        } catch (e) {
          storage = { usage: 'No disponible', quota: 'No disponible' };
        }

        let memoria = { deviceMemoryGB: 'No disponible', jsHeapUsedMB: 'No disponible', jsHeapTotalMB: 'No disponible' };
        try {
          const deviceMemory = navigator.deviceMemory;
          const perfMem = performance?.memory;
          memoria = {
            deviceMemoryGB: deviceMemory ? `${deviceMemory} GB` : 'No disponible',
            jsHeapUsedMB: perfMem?.usedJSHeapSize ? `${(perfMem.usedJSHeapSize / (1024 * 1024)).toFixed(1)} MB` : 'No disponible',
            jsHeapTotalMB: perfMem?.totalJSHeapSize ? `${(perfMem.totalJSHeapSize / (1024 * 1024)).toFixed(1)} MB` : 'No disponible'
          };
        } catch (e) {
          memoria = { deviceMemoryGB: 'No disponible', jsHeapUsedMB: 'No disponible', jsHeapTotalMB: 'No disponible' };
        }

        const ipLocal = await this.obtenerIpLocalBestEffort();
        const fecha = new Date().toLocaleString('es-ES');

        const bloque = [
          `DIAGNÓSTICO AUTOMÁTICO (${fecha})`,
          `Tipo detectado: ${this.tipoDiagnosticoDetectado || 'No especificado'}`,
          `IP del equipo: ${ipLocal}`,
          `Nombre del equipo: No disponible`,
          `Usuario logueado: ${usuario}`,
          `Navegador: ${infoNav.navegador}`,
          `Sistema operativo: ${infoNav.so}`,
          `Plataforma: ${infoNav.plataforma}`,
          `Idioma: ${idioma}`,
          `Latencia al servidor: ${latenciaMs !== null ? latenciaMs + ' ms' : 'No disponible'}`,
          `Velocidad de red (downlink): ${red.downlinkMbps} Mbps`,
          `Red (tipo): ${red.effectiveType}`,
          `Red (RTT): ${red.rttMs} ms`,
          `Espacio en disco: No disponible`,
          `Espacio (storage uso/cuota): ${storage.usage} / ${storage.quota}`,
          `Memoria RAM usada: No disponible`,
          `Memoria (deviceMemory): ${memoria.deviceMemoryGB}`,
          `Memoria JS (usada/total): ${memoria.jsHeapUsedMB} / ${memoria.jsHeapTotalMB}`
        ].join('\n');

        const actual = (this.form.descripcion || '').toString().trim();
        this.form.descripcion = actual ? `${actual}\n\n${bloque}` : bloque;
        this.mostrarNotificacion('Diagnóstico agregado a Descripción del problema');

        this.$nextTick(() => {
          try {
            const el = document.getElementById('descripcion');
            if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (e) {
            return;
          }
        });
      } catch (e) {
        this.mostrarNotificacion('No se pudo completar el diagnóstico');
      } finally {
        this.diagnosticoLoading = false;
      }
    },
    iniciarRotacionFrasesBot() {
      this.detenerRotacionFrasesBot();
      this.botPhraseIntervalId = setInterval(() => {
        const arr = Array.isArray(this.botPhrases) ? this.botPhrases : [];
        if (arr.length <= 1) return;
        this.botPhraseIndex = (this.botPhraseIndex + 1) % arr.length;
      }, 3500);
    },
    detenerRotacionFrasesBot() {
      if (this.botPhraseIntervalId) {
        clearInterval(this.botPhraseIntervalId);
        this.botPhraseIntervalId = null;
      }
    },
    normalizarTextoPlano(valor) {
      if (valor === null || valor === undefined) return '';
      try {
        return valor
          .toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9\s]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      } catch (e) {
        return (valor || '').toString().toLowerCase();
      }
    },
    detectarAreaChatbot(texto) {
      const textoNorm = this.normalizarTextoPlano(texto);
      if (!textoNorm) return 'TECNOLOGIAS';

      const areas = ['TECNOLOGIAS', 'MANTENIMIENTO'];
      const scores = areas.reduce((acc, areaKey) => {
        const db = solucionesBasicasTickets?.areas?.[areaKey];
        if (!Array.isArray(db) || db.length === 0) {
          acc[areaKey] = 0;
          return acc;
        }
        const score = db.reduce((total, item) => {
          const kws = Array.isArray(item?.keywords) ? item.keywords : [];
          const s = kws.reduce((cnt, kw) => {
            const kwNorm = this.normalizarTextoPlano(kw);
            if (!kwNorm) return cnt;
            return textoNorm.includes(kwNorm) ? cnt + 1 : cnt;
          }, 0);
          return total + s;
        }, 0);
        acc[areaKey] = score;
        return acc;
      }, {});

      if ((scores.MANTENIMIENTO || 0) > (scores.TECNOLOGIAS || 0)) return 'MANTENIMIENTO';
      return 'TECNOLOGIAS';
    },
    buscarSolucionesBasicasLocal(texto, area) {
      const areaKey = (area || '').toString().trim().toUpperCase();
      if (!['TECNOLOGIAS', 'MANTENIMIENTO'].includes(areaKey)) return [];

      const db = solucionesBasicasTickets?.areas?.[areaKey];
      if (!Array.isArray(db) || db.length === 0) return [];

      const textoNorm = this.normalizarTextoPlano(texto);
      if (!textoNorm) return [];

      const items = db
        .map(item => {
          const kws = Array.isArray(item?.keywords) ? item.keywords : [];
          const score = kws.reduce((acc, kw) => {
            const kwNorm = this.normalizarTextoPlano(kw);
            if (!kwNorm) return acc;
            return textoNorm.includes(kwNorm) ? acc + 1 : acc;
          }, 0);
          return { item, score };
        })
        .filter(x => x.score > 0)
        .sort((a, b) => b.score - a.score);

      return items.slice(0, 2).map(x => x.item);
    },
    toggleChatbot() {
      this.showChatbot = !this.showChatbot;
      if (this.showChatbot) {
        this.chatbotError = '';
        if (!this.chatbotMensajes || this.chatbotMensajes.length === 0) {
          this.chatbotMensajes = [
            { id: `${Date.now()}-bot-1`, from: 'bot', type: 'text', text: '¡Hola! Soy tu asistente virtual. ¿Necesitas ayuda para crear un ticket? 🎫' },
            { 
              id: `${Date.now()}-bot-menu`, 
              from: 'bot', 
              type: 'menu', 
              title: '¿Qué información necesitas?',
              options: [
                { id: 'crear_ticket', icon: '📝', text: 'Cómo crear un ticket' },
                { id: 'crear_ticket_gestion_informacion', icon: '📝', text: 'Cómo crear un ticket de Gestion de Informacion' },
                { id: 'garrafon', icon: '🧴', text: 'Solicitar garrafón de agua' },
                { id: 'gestion_ticket', icon: '👁️', text: 'Ver gestión de mi ticket' },
                { id: 'cancelar', icon: '❌', text: 'Cómo cancelar un ticket' },
                { id: 'reporte', icon: '📄', text: 'Descargar reporte de ticket' },
                { id: 'funcionalidades', icon: '🔧', text: 'Funcionalidades del sistema' }
              ]
            }
          ];
        }
        this.$nextTick(() => this.scrollChatbotToBottom());
      }
    },
    cerrarChatbot() {
      this.showChatbot = false;
    },
    limpiarChatbot() {
      this.chatbotProblema = '';
      this.chatbotResultados = [];
      this.chatbotKeywords = [];
      this.chatbotError = '';
      this.chatbotBuscado = false;
      this.chatbotUltimoProblema = '';
      this.chatbotEsperandoConfirmacion = false;
      this.chatbotMensajes = [
        { id: `${Date.now()}-bot-1`, from: 'bot', type: 'text', text: '¡Hola! Soy tu asistente virtual. ¿Necesitas ayuda para crear un ticket? 🎫' },
        { 
          id: `${Date.now()}-bot-menu`, 
          from: 'bot', 
          type: 'menu', 
          title: '¿Qué información necesitas?',
          options: [
            { id: 'crear_ticket', icon: '📝', text: 'Cómo crear un ticket' },
            { id: 'crear_ticket_gestion_informacion', icon: '📝', text: 'Cómo crear un ticket de Gestion de Informacion' },
            { id: 'garrafon', icon: '🧴', text: 'Solicitar garrafón de agua' },
            { id: 'gestion_ticket', icon: '👁️', text: 'Ver gestión de mi ticket' },
            { id: 'cancelar', icon: '❌', text: 'Cómo cancelar un ticket' },
            { id: 'reporte', icon: '📄', text: 'Descargar reporte de ticket' },
            { id: 'funcionalidades', icon: '🔧', text: 'Funcionalidades del sistema' }
          ]
        }
      ];
      this.$nextTick(() => this.scrollChatbotToBottom());
    },
    scrollChatbotToBottom() {
      const el = this.$refs.chatbotMessages;
      if (!el) return;
      try {
        el.scrollTop = el.scrollHeight;
      } catch (e) {
        return;
      }
    },

    /**
     * Manejar selección de opción del menú de ayuda
     * @param {string} opcionId - ID de la opción seleccionada
     */
    seleccionarOpcionMenu(opcionId) {
      const respuestas = {
        crear_ticket: '📝 Cómo crear un ticket:\n\n1. Haz clic en el botón verde "Crear Ticket"\n2 Selecciona  el tipo de solicitud, selecciona: Reportar falla o solicitar servicio\n .\n3 Selecciona el área de servicio:\n   • 🔧 Mantenimiento - Para fallas en instalaciones\n   • 💻 Tecnologías - Para problemas de cómputo,red o apoyo tecnico\n   • 🏥 Biomédica - Para equipo médico e insumos\n4. Completa los campos requeridos (los marcados con *)\n5. Haz clic en "✅ Crear Ticket"\n6. ¡Listo! Recibirás un folio para dar seguimiento',

        crear_ticket_gestion_informacion: '📝 Cómo crear un ticket de Gestion de Informacion:\n\n1.Haz clic en el botón verde "Crear Ticket"\n2. Selecciona el tipo de solicitud, selecciona: Gestion o administracion de informacion\n3. Completa los campos requeridos \n\n4 Selecciona la casilla para autorizar la auditoria de esta accion\n6. Haz clic en "✅ Enviar Solicitud"\n\n5. ¡Listo! Recibirás un folio para dar seguimiento',
        
        garrafon: '🧴 Solicitar garrafón de agua:\n\n1. Haz clic en el boton Garrafón 🧴 (botón  junto a "Nuevo Ticket")\n2. Selecciona tu área y ubicación\n3. Indica la cantidad de garrafones que necesitas\n4. Haz clic en "Crear Ticket"\n5. El área de Mantenimiento recibirá tu pedido',
        
        gestion_ticket: '👁️ Ver gestión de tu ticket:\n\n1. En la tabla de tickets, busca tu ticket por folio o título\n2. El estado se muestra en la tabla en la columna: ESTADO:\n   •  Pendiente\n   •  Asignado/En proceso\n   •  Resuelto\n   •  Cancelado\n3. Haz clic en el ticket para ver detalles completos\n',
        
        cancelar: '❌ Cómo cancelar un ticket: \n\nCondiciones: Solo puedes cancelar tickets que estén en estado "PENDIENTE"\n\nPasos:\n1. Busca tu ticket en la lista\n2. Haz clic en el botón "❌ Cancelar"\n3. Indica el motivo de la cancelación\n4. Confirma la acción\n\n⚠️ Nota: Los tickets ya asignados o en proceso no pueden cancelarse. Contacta al administrador si es urgente.',
        
        reporte: '📄 Descargar reporte de ticket:\n\nCondiciones: Solo disponible para tickets en estado "RESUELTO"\n\nPasos:\n1. Localiza tu ticket resuelto en la lista\n2. Haz clic en el icono 📄 o "PDF" del ticket\n3. El sistema generará un PDF con:\n   • Datos del ticket y folio\n   • Descripción del problema\n   • Solución aplicada por el técnico\n   • Fechas de creación y resolución\n   • Técnico que atendió\n4. Descarga el archivo para tus registros',
        
        funcionalidades: '🔧 Funcionalidades del sistema:\n\n• 🎫 Crear tickets de servicio tecnico o administrativo\n• 👁️ Consultar estado de tickets en tiempo real\n•  🔍 Buscar soluciones a problemas comunes\n• 📷 Escaneo QR para equipo biomédico\n• 📦 Solicitar insumos (Biomédica)\n• ⚙️ Reportar fallas en equipo médico\n• 📄 Descargar reportes PDF de tickets resueltos\n• 🚰 Solicitar garrafones de agua'
      };

      const mensaje = respuestas[opcionId] || 'Opción no disponible.';
      
      // Agregar mensaje del usuario (selección)
      const opcionSeleccionada = {
        crear_ticket: '📝 Cómo crear un ticket',
        crear_ticket_gestion_informacion: '📝 Cómo crear un ticket de Gestion de Informacion',
        garrafon: '🧴 Solicitar garrafón de agua',
        gestion_ticket: '👁️ Ver gestión de mi ticket',
        cancelar: '❌ Cómo cancelar un ticket',
        reporte: '📄 Descargar reporte de ticket',
        funcionalidades: '🔧 Funcionalidades del sistema'
      }[opcionId];

      this.chatbotMensajes.push({
        id: `${Date.now()}-user-menu`,
        from: 'user',
        type: 'text',
        text: opcionSeleccionada
      });

      // Agregar respuesta del bot
      this.chatbotMensajes.push({
        id: `${Date.now()}-bot-resp`,
        from: 'bot',
        type: 'text',
        text: mensaje
      });

      // Volver a mostrar el menú
      this.chatbotMensajes.push({
        id: `${Date.now()}-bot-menu`,
        from: 'bot',
        type: 'menu',
        title: '¿Te gustaría saber algo más?',
        options: [
          { id: 'crear_ticket', icon: '📝', text: 'Cómo crear un ticket' },
          { id: 'crear_ticket_gestion_informacion', icon: '📝', text: 'Cómo crear un ticket de Gestion de Informacion' },
          { id: 'garrafon', icon: '🧴', text: 'Solicitar garrafón de agua' },
          { id: 'gestion_ticket', icon: '👁️', text: 'Ver gestión de mi ticket' },
          { id: 'cancelar', icon: '❌', text: 'Cómo cancelar un ticket' },
          { id: 'reporte', icon: '📄', text: 'Descargar reporte de ticket' },
          { id: 'funcionalidades', icon: '🔧', text: 'Funcionalidades del sistema' }
        ]
      });

      this.$nextTick(() => this.scrollChatbotToBottom());
    },

    /**
     * Volver al menú principal del chatbot
     */
    volverAlMenu() {
      // Agregar mensaje de vuelta al menú
      this.chatbotMensajes.push({
        id: `${Date.now()}-user-back`,
        from: 'user',
        type: 'text',
        text: '← Volver al menú'
      });

      // Mostrar menú principal
      this.chatbotMensajes.push({
        id: `${Date.now()}-bot-menu-back`,
        from: 'bot',
        type: 'menu',
        title: '¿Qué información necesitas?',
        options: [
          { id: 'crear_ticket', icon: '📝', text: 'Cómo crear un ticket' },
          { id: 'crear_ticket_gestion_informacion', icon: '📝', text: 'Cómo crear un ticket' },
          { id: 'garrafon', icon: '🧴', text: 'Solicitar garrafón de agua' },
          { id: 'gestion_ticket', icon: '👁️', text: 'Ver gestión de mi ticket' },
          { id: 'cancelar', icon: '❌', text: 'Cómo cancelar un ticket' },
          { id: 'reporte', icon: '📄', text: 'Descargar reporte de ticket' },
          { id: 'funcionalidades', icon: '🔧', text: 'Funcionalidades del sistema' }
        ]
      });

      this.$nextTick(() => this.scrollChatbotToBottom());
    },

    async enviarChatbot() {
      if (!this.chatbotProblema || this.chatbotLoading) return;
      const texto = this.chatbotProblema;

      this.chatbotEsperandoConfirmacion = false;
      this.chatbotUltimoProblema = texto;

      this.chatbotMensajes = [
        ...(this.chatbotMensajes || []),
        { id: `${Date.now()}-user`, from: 'user', type: 'text', text: texto }
      ];
      this.$nextTick(() => this.scrollChatbotToBottom());

      if (this.esAdminOTecnico) {
        this.chatbotMensajes = [
          ...(this.chatbotMensajes || []),
          {
            id: `${Date.now()}-bot-tech-intro-direct`,
            from: 'bot',
            type: 'text',
            text: 'Buscaré soluciones técnicas relacionadas.',
          }
        ];
        this.$nextTick(() => this.scrollChatbotToBottom());
        await this.buscarSolucionesChatbot(texto);
        this.chatbotProblema = '';
        return;
      }

      const areaDetectada = this.detectarAreaChatbot(texto);
      const basicas = this.buscarSolucionesBasicasLocal(texto, areaDetectada);
      if (basicas && basicas.length) {
        this.chatbotMensajes = [
          ...(this.chatbotMensajes || []),
          {
            id: `${Date.now()}-bot-basicas`,
            from: 'bot',
            type: 'basicas',
            area: areaDetectada,
            items: basicas,
          }
        ];
        this.$nextTick(() => this.scrollChatbotToBottom());

        this.chatbotMensajes = [
          ...(this.chatbotMensajes || []),
          {
            id: `${Date.now()}-bot-confirm`,
            from: 'bot',
            type: 'confirm',
            text: '¿El problema se solucionó?',
            problema: texto,
          }
        ];
        this.chatbotEsperandoConfirmacion = true;
        this.$nextTick(() => this.scrollChatbotToBottom());
      } else {
        this.chatbotMensajes = [
          ...(this.chatbotMensajes || []),
          {
            id: `${Date.now()}-bot-basicas-empty`,
            from: 'bot',
            type: 'text',
            text: 'No encontré una guía básica para ese problema. Buscaré en soluciones técnicas.',
          }
        ];
        this.$nextTick(() => this.scrollChatbotToBottom());
        await this.buscarSolucionesChatbot(texto);
      }

      this.chatbotProblema = '';
    },
    async responderConfirmacionChatbot(resuelto, mensaje) {
      if (this.chatbotLoading) return;
      this.chatbotEsperandoConfirmacion = false;
      const problema = mensaje?.problema || this.chatbotUltimoProblema;

      this.chatbotMensajes = [
        ...(this.chatbotMensajes || []),
        { id: `${Date.now()}-user-confirm`, from: 'user', type: 'text', text: resuelto ? 'Sí' : 'No' }
      ];
      this.$nextTick(() => this.scrollChatbotToBottom());

      if (resuelto) {
        this.chatbotMensajes = [
          ...(this.chatbotMensajes || []),
          { id: `${Date.now()}-bot-thanks`, from: 'bot', type: 'text', text: 'Perfecto. Me da gusto que se haya solucionado. Que tengas un buen día.' }
        ];
        this.$nextTick(() => this.scrollChatbotToBottom());
        return;
      }

      this.chatbotMensajes = [
        ...(this.chatbotMensajes || []),
        { id: `${Date.now()}-bot-tech-intro`, from: 'bot', type: 'text', text: 'De acuerdo. Te muestro soluciones técnicas relacionadas.' }
      ];
      this.$nextTick(() => this.scrollChatbotToBottom());
      await this.buscarSolucionesChatbot(problema);
    },
    async buscarSolucionesChatbot(problemaOverride) {
      const problema = (problemaOverride !== undefined && problemaOverride !== null) ? problemaOverride : this.chatbotProblema;
      if (!problema || this.chatbotLoading) return;
      this.chatbotLoading = true;
      this.chatbotError = '';
      this.chatbotBuscado = true;
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/chatbotSoluciones',
          method: 'POST',
          data: {
            problema: problema,
            maxResultados: 7,
          }
        });

        const data = response?.data || {};
        if (data.success === false || data.estado === false) {
          this.chatbotResultados = [];
          this.chatbotKeywords = [];
          this.chatbotError = data.mensaje || 'No se pudieron obtener soluciones.';
          return;
        }
        const root = data.root || {};
        this.chatbotKeywords = Array.isArray(root.keywords) ? root.keywords : [];
        this.chatbotResultados = Array.isArray(root.resultados) ? root.resultados : [];

        this.chatbotMensajes = [
          ...(this.chatbotMensajes || []),
          {
            id: `${Date.now()}-bot-sol`,
            from: 'bot',
            type: 'soluciones',
            keywords: this.chatbotKeywords,
            resultados: this.chatbotResultados,
          }
        ];
        this.chatbotProblema = '';
        this.$nextTick(() => this.scrollChatbotToBottom());
      } catch (e) {
        this.chatbotResultados = [];
        this.chatbotKeywords = [];
        this.chatbotError = 'Error al consultar el asistente de soluciones.';

        this.chatbotMensajes = [
          ...(this.chatbotMensajes || []),
          { id: `${Date.now()}-bot-err`, from: 'bot', type: 'text', text: 'No pude consultar soluciones en este momento. Intenta de nuevo.' }
        ];
        this.$nextTick(() => this.scrollChatbotToBottom());
      } finally {
        this.chatbotLoading = false;
      }
    },
    // Los roles se obtienen automáticamente del store de Vuex (this.$store.state.security.roles)
    // No se necesita método para cambiar roles manualmente
    normalizarTexto(valor) {
      if (valor === null || valor === undefined) return '';
      try {
        return valor
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase()
          .trim();
      } catch (error) {
        return valor.toString().toUpperCase().trim();
      }
    },
    filtrarAreas(item, queryText, itemText) {
      const textoBuscar = this.normalizarTexto(queryText);
      if (!textoBuscar) return true;
      const textoItem = this.normalizarTexto(itemText || item?.nombre || '');
      return textoItem.includes(textoBuscar);
    },
    toggleAccionesEstadisticas() {
      this.mostrarAccionesEstadisticas = !this.mostrarAccionesEstadisticas;
    },
    verTicketsCreadosResueltos() {
      this.cerrarDashboards();
      this.showTicketsCreadosResueltos = true;
      this.mostrarAccionesEstadisticas = false;
    },
    verTiempoPromedio() {
      this.cerrarDashboards();
      this.showTiempoPromedio = true;
      this.mostrarAccionesEstadisticas = false;
    },
    verTicketsPorTecnico() {
      this.cerrarDashboards();
      this.showTicketsPorTecnico = true;
      this.mostrarAccionesEstadisticas = false;
    },
    verTicketsPorArea() {
      this.cerrarDashboards();
      this.showTicketsPorArea = true;
      this.mostrarAccionesEstadisticas = false;
    },
    verProblemasMasComunes() {
      this.cerrarDashboards();
      this.showProblemasMasComunes = true;
      this.mostrarAccionesEstadisticas = false;
    },
    verEstadisticasPreventivas() {
      this.cerrarDashboards();
      this.showEstadisticasPreventivas = true;
      this.mostrarAccionesEstadisticas = false;
    },
    cerrarDashboards() {
      this.showTicketsCreadosResueltos = false;
      this.showTiempoPromedio = false;
      this.showTicketsPorTecnico = false;
      this.showTicketsPorArea = false;
      this.showProblemasMasComunes = false;
      this.showEstadisticasPreventivas = false;
    },

    abrirGarrafonModal() {
      this.garrafonForm.areaSolicita = '';
      this.garrafonForm.ubicacion = '';
      this.garrafonForm.cantidad = 1;
      this.showGarrafonModal = true;
    },
    abrirManualesModal() {
      // Abre el modal de manuales o redirige a la página de manuales
      this.showManualesModal = true;
    },
    cerrarManualesModal() {
      this.showManualesModal = false;
    },
    cerrarConfirmacionPaciente() {
      this.showConfirmacionPacienteModal = false;
      this.pacienteConfirmado = false;
      this.isCreatingTicket = false;
    },
    async confirmarCreacionTicketPaciente() {
      if (!this.pacienteConfirmado) {
        this.mostrarNotificacion('❌ Debes confirmar que has registrado el número de expediente o nombre del paciente');
        return;
      }
      
      this.showConfirmacionPacienteModal = false;
      // Continuar con la creación del ticket
      await this.continuarCreacionTicket();
    },
    async continuarCreacionTicket() {
      // Este método continúa la creación del ticket después de la confirmación del paciente
      console.log('✅ Continuando creación de ticket después de confirmación de paciente');
      
      // Reactivar estado de carga
      this.isCreatingTicket = true;
      
      try {
        // Obtener los datos del formulario ya preparados (repetimos la preparación de datos)
        const esGestionInformacion = this.tipoFormulario === 'gestion_informacion';
        const datosTicket = {
          nombre: this.form.nombre,
          titulo: esGestionInformacion ? (this.form.accionSolicitada || '') : (this.form.titulo || ''),
          descripcion: esGestionInformacion ? (this.form.descripcion || this.form.motivo || '') : (this.form.descripcion || ''),
          areaSolicita: this.form.areaSolicita,
          ubicacion: this.extraerStringDeUbicacion(this.form.ubicacion),
          solicitudArea: this.form.solicitudArea.toUpperCase(),
          notas: this.form.notas || null,
          equipo: null,
          serialNumber: null,
          descripcionEquipo: null,
          insumos: null,
          cantidadInsumos: null,
          descripcionInsumos: null,
        };

        // Si es gestión de información, agregar campos específicos
        if (esGestionInformacion) {
          datosTicket.esGestionInformacion = true;
          datosTicket.auditoriaAceptada = this.form.auditoriaAceptada;
          datosTicket.tipo = 'GESTION_INFORMACION';
        }

        // Llamar al método que finalmente crea el ticket
        await this.procesarCreacionTicket(datosTicket);
        
      } catch (error) {
        console.error('❌ Error al continuar creación de ticket:', error);
        this.mostrarNotificacion('❌ Error al crear el ticket. Intenta de nuevo.');
        this.isCreatingTicket = false;
      }
    },
    async procesarCreacionTicket(datosTicket) {
      // Este método contiene la lógica de envío al backend que estaba originalmente en crearTicketCompleto
      try {
        console.log(' Enviando datos al backend:', datosTicket);
        
        let endpoint;
        if (datosTicket.esGestionInformacion) {
          endpoint = '/mantenimiento/tickets/crearTicket';
        } else if (datosTicket.solicitudArea === 'BIOMEDICA') {
          endpoint = '/mantenimiento/tickets/crearTicket';
        } else {
          endpoint = '/mantenimiento/tickets/crearTicket';
        }
        
        const response = await this.$http({
          url: endpoint,
          method: 'POST',
          data: datosTicket,
        });

        if (response.data.success || response.data.estado) {
          this.mostrarNotificacion(datosTicket.esGestionInformacion ? '✅ Solicitud creada correctamente' : '✅ Ticket creado correctamente');
          await this.cargarTicketsDesdeBackend();
          this.cerrarFormulario();
          this.resetearFormulario();
        } else {
          const msg = response.data.mensaje || 'Error al crear el ticket';
          this.mostrarNotificacion(msg);
        }
      } catch (error) {
        console.error('❌ Error al procesar creación de ticket:', error);
        this.mostrarNotificacion('❌ Error al crear el ticket');
        this.$store.dispatch('security/revisaError', error);
      } finally {
        this.isCreatingTicket = false;
      }
    },
    descargarManual(tipo) {
      // Aquí puedes implementar la lógica para descargar los manuales
      // Por ahora, mostramos una notificación
      this.mostrarNotificacion(`Descargando manual ${tipo}...`, 'info');
      
      // Ejemplo de redirección a archivos estáticos (ajusta las rutas según tu servidor)
      const manualesUrls = {
        usuario: 'https://docs.google.com/document/d/1T6eW_T_mJpK9rPWw3WMY4taznin8GjVF/edit?usp=sharing&ouid=112545182377376808991&rtpof=true&sd=true',
        tecnico: '/manuales/Manual_Tecnico.pdf',
        faq: '/manuales/FAQ.pdf'
      };
      
      if (manualesUrls[tipo]) {
        window.open(manualesUrls[tipo], '_blank');
      }
    },
    cerrarGarrafonModal() {
      this.showGarrafonModal = false;
      this.garrafonLoading = false;
    },
    async crearTicketGarrafon() {
      // Validar campos requeridos con la función robusta
      const erroresValidacion = [];
      
      // Validar nombre
      const nombreValidacion = this.validarCampoRequerido(this.form.nombre || '', 'nombre');
      if (!nombreValidacion.valido) {
        erroresValidacion.push(nombreValidacion.mensaje);
      }
      
      // Validar campos específicos del garrafón
      const camposGarrafon = [
        { campo: this.garrafonForm.areaSolicita, nombre: 'Área Solicitante' },
        { campo: this.garrafonForm.ubicacion, nombre: 'Ubicación' },
        { campo: this.garrafonForm.cantidad, nombre: 'Cantidad' }
      ];
      
      camposGarrafon.forEach(({ campo, nombre }) => {
        const validacion = this.validarCampoRequerido(campo, nombre);
        if (!validacion.valido) {
          erroresValidacion.push(validacion.mensaje);
        }
      });
      
      // Validación específica para cantidad (debe ser al menos 1)
      if (this.garrafonForm.cantidad < 1 || this.garrafonForm.cantidad > 99) {
        erroresValidacion.push('La cantidad debe estar entre 1 y 99 garrafones');
      }
      
      if (erroresValidacion.length > 0) {
        this.mostrarNotificacion(`Por favor corrige los siguientes campos:\n${erroresValidacion.join('\n')}`);
        return;
      }

      this.garrafonLoading = true;
      try {
        const areaSolicita = (this.garrafonForm.areaSolicita || '').toString().trim();
        const ubicacion = (this.garrafonForm.ubicacion || '').toString().trim();
        const cantidad = Number(this.garrafonForm.cantidad || 0) || 0;

        const datosTicket = {
          nombre: this.form.nombre || 'Usuario',
          titulo: 'Solicitud de garrafón de agua',
          descripcion: `Se requieren ${cantidad} garrafón(es) de agua. Área: ${areaSolicita}. Ubicación: ${ubicacion}.`,
          areaSolicita: areaSolicita,
          ubicacion: this.extraerStringDeUbicacion(ubicacion),
          solicitudArea: 'MANTENIMIENTO',
          tipo: 'GARRAFON_AGUA'
        };

        const response = await this.$http({
          url: '/mantenimiento/tickets/crearTicket',
          method: 'POST',
          data: datosTicket,
        });

        if (response.data.success || response.data.estado) {
          this.mostrarNotificacion('Solicitud de garrafón creada');
          await this.cargarTicketsDesdeBackend();
          this.cerrarGarrafonModal();
        } else {
          const msg = response.data.mensaje || 'Error al crear la solicitud';
          this.mostrarNotificacion(msg);
        }
      } catch (error) {
        this.mostrarNotificacion('Error al crear la solicitud');
        this.$store.dispatch('security/revisaError', error);
      } finally {
        this.garrafonLoading = false;
      }
    },

    revisarAsignacionesUsuario(ticketsNuevos = []) {
      try {
        const usuarioId = this.$store.state.security.user?.id;
        if (!usuarioId) return;

        const key = `mtto_notif_asignacion_${usuarioId}`;
        const yaNotificados = new Set(JSON.parse(localStorage.getItem(key) || '[]'));

        const asignados = (ticketsNuevos || []).filter(t => {
          const pertenece = (t.usuarioId && String(t.usuarioId) === String(usuarioId)) ||
            (t.solicitanteId && String(t.solicitanteId) === String(usuarioId)) ||
            (t.usuarioCreadorId && String(t.usuarioCreadorId) === String(usuarioId));
          if (!pertenece) return false;
          if (!t.fechaAsignacion) return false;
          // ya notificado
          return !yaNotificados.has(String(t.id));
        });

        if (asignados.length > 0) {
          // Notificar solo el primero para no spamear
          const t = asignados[0];
          this.mostrarNotificacion(`El técnico está en camino a tu área (Ticket ${t.folio || t.id})`);
          yaNotificados.add(String(t.id));
          localStorage.setItem(key, JSON.stringify(Array.from(yaNotificados)));
        }
      } catch (e) {
        return;
      }
    },
    
    
    
    
    // Cargar tickets desde el backend
    async cargarTicketsDesdeBackend() {
      try {
        // No enviar filtro de prioridad al backend para que todas las solicitudes especiales lleguen
        // El filtro se aplicará solo en el frontend (ticketsFiltrados)
        const response = await this.$http({
          url: '/mantenimiento/tickets/listarTickets',
          method: 'GET',
          params: {
            area: this.filtroArea || undefined,
            // prioridad: this.filtroPrioridad ? this.filtroPrioridad.toUpperCase() : undefined,
          }
        });
        
        if (response.data && response.data.root) {
          // Mapear los datos del backend al formato del frontend
          this.tickets = response.data.root.map(ticket => ({
            id: ticket.id,
            folio: ticket.folio || ticket.id,
            nombre: ticket.nombre,
            titulo: ticket.titulo,
            descripcion: ticket.descripcion,
            areaSolicita: ticket.areaSolicita,
            ubicacion: ticket.ubicacion,
            equipo: ticket.equipo,
            solicitudArea: ticket.solicitudArea?.toLowerCase(),
            serialNumber: ticket.serialNumber,
            notas: ticket.notas,
            insumos: ticket.insumos,
            cantidadInsumos: ticket.cantidadInsumos,
            descripcionInsumos: ticket.descripcionInsumos,
            prioridad: ticket.prioridad || 'MEDIA',  // Backend retorna: ALTA, MEDIA, BAJA
            prioridadColor: this.obtenerColorPrioridad(ticket.prioridad),
            estado: ticket.estado || 'PENDIENTE',  // Backend retorna: PENDIENTE, ASIGNADO, EN_PROCESO, RESUELTO, CANCELADO
            estadoAnterior: ticket.estado || 'PENDIENTE',  // Guardar estado original para restaurar si cancela reasignación
            tecnico: ticket.tecnicoAsignado,
            tecnicoAsignadoId: ticket.tecnicoAsignadoId,
            tecnicosEquipo: ticket.tecnicosEquipo || [],
            equipoNombres: ticket.equipoNombres || null,
            comentariosInternos: ticket.comentariosInternos,
            fechaCreacion: ticket.fechaCreacion,
            fechaCierre: ticket.fechaCierre,
            fechaAsignacion: ticket.fechaAsignacion,
            solucionesTecnico: ticket.solucionesTecnico || [],
            // Flags de permisos del backend
            esCancelado: ticket.esCancelado || false,
            esResuelto: ticket.esResuelto || false,
            esGestionInformacion: ticket.tipo === 'GESTION_INFORMACION' || ticket.esGestionInformacion || false,
            puedeEditar: ticket.puedeEditar !== false,
            puedeCancelar: ticket.puedeCancelar || false,
            usuarioCreadorId: ticket.usuarioCreadorId,
            usuarioId: ticket.usuarioCreadorId || ticket.usuarioId,
            solicitanteId: ticket.usuarioCreadorId || ticket.solicitanteId,
            // Agregar campo tipo para detección de garrafones
            tipo: ticket.tipo || 'TICKET',
          }));
          
          console.log('✅ Tickets cargados desde backend:', this.tickets.length);
          
          // Verificar y corregir automáticamente tickets de garrafón con prioridad incorrecta
          await this.verificarYCorregirTicketsGarrafon(this.tickets);

          // Notificación in-app para el usuario creador cuando se asigne el ticket
          this.revisarAsignacionesUsuario(this.tickets);
        }
      } catch (error) {
        console.error('❌ Error al cargar tickets desde backend:', error);
        this.$store.dispatch('security/revisaError', error);
      }
    },
    
    async cargarTecnicosDesdeBackend() {
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/listarTecnicos',
          method: 'GET',
        });
        
        if (response.data && response.data.root) {
          // El backend devuelve un array de objetos con { id, nombre, area, etc. }
          if (Array.isArray(response.data.root)) {
            // Guardar lista completa con IDs
            this.listaTecnicos = response.data.root.map(t => ({
              id: t.id,
              nombre: typeof t === 'string' ? t : (t.nombre || t.nombreCompleto || `${t.nombres} ${t.apellidoPaterno || ''}`.trim())
            }));
            // Lista de solo nombres para compatibilidad
            this.listaTecnicosNombres = this.listaTecnicos.map(t => t.nombre);
            console.log(`✅ ${this.listaTecnicos.length} técnicos cargados desde el backend`);
          }
        }
      } catch (error) {
        console.error('Error al cargar técnicos desde backend:', error);
        // No mostrar notificación al usuario, usar lista vacía
        this.listaTecnicos = [];
        console.warn('⚠️ No se pudieron cargar técnicos. Usando lista vacía.');
      }
    },
    
    // Cargar áreas desde catalogo_areas
    async cargarAreasDesdeBackend() {
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/listarAreas',
          method: 'GET',
        });
        
        if (response.data && response.data.success && response.data.root) {
          this.areasDisponibles = response.data.root.map(area => {
            const nombre = area.nombre || '';
            return {
              id: area.id,
              nombre,
              activo: area.activo,
              nombreNormalizado: this.normalizarTexto(nombre)
            };
          });
          console.log(`✅ ${this.areasDisponibles.length} áreas cargadas desde catalogo_areas`);
        }
      } catch (error) {
        console.error('Error al cargar áreas desde backend:', error);
        // Usar lista vacía si falla
        this.areasDisponibles = [];
        console.warn('⚠️ No se pudieron cargar áreas. Usando lista vacía.');
      }
    },
    
    capitalizarPrioridad(prioridad) {
      if (!prioridad) return 'Media';
      const pri = prioridad.toLowerCase();
      return pri.charAt(0).toUpperCase() + pri.slice(1);
    },
    
    obtenerColorPrioridad(prioridad) {
      if (!prioridad) return '#FFCC00';
      const pri = prioridad.toUpperCase();
      const colores = {
        'BAJA': '#00CC00',
        'MEDIA': '#FFCC00',
        'ALTA': '#FF6600',
      };
      return colores[pri] || '#FFCC00';
    },
    
    // Método eliminado - ahora se cargan tickets desde el backend
    
    probarBoton() {
      console.log('🔍 Botón Crear Ticket clickeado');
      console.log('🔍 Estado del formulario:', this.form);
      
      // Prevenir múltiples clics
      if (this.isCreatingTicket) {
        console.log('⏳ Ya se está creando un ticket, ignorando clic adicional');
        return;
      }
      
      try {
      // Llamar al método principal
      this.crearTicketCompleto();
      } catch (error) {
        console.error('❌ Error en probarBoton:', error);
        this.mostrarNotificacion(`❌ Error al procesar el formulario: ${error.message || 'Error desconocido'}`);
        this.isCreatingTicket = false; // Resetear estado en caso de error
      }
    },
    // Función de validación robusta para campos nulos/vacíos
    validarCampoRequerido(valor, nombreCampo) {
      // Verificar si es null, undefined o vacío
      if (valor === null || valor === undefined) {
        return { valido: false, mensaje: `El campo "${nombreCampo}" es requerido` };
      }
      
      // Si es string, verificar que no esté vacío después de trim
      if (typeof valor === 'string') {
        if (valor.trim() === '') {
          return { valido: false, mensaje: `El campo "${nombreCampo}" no puede estar vacío` };
        }
        // Verificar longitud mínima (al menos 2 caracteres)
        if (valor.trim().length < 2) {
          return { valido: false, mensaje: `El campo "${nombreCampo}" debe tener al menos 2 caracteres` };
        }
      }
      
      // Si es número, verificar que sea válido
      if (typeof valor === 'number') {
        if (isNaN(valor) || valor <= 0) {
          return { valido: false, mensaje: `El campo "${nombreCampo}" debe ser un número válido mayor a 0` };
        }
      }
      
      return { valido: true };
    },

    // Validar formulario completo según tipo
    validarFormularioCompleto() {
      const errores = [];
      
      // Validar nombre (siempre requerido)
      const nombreValidacion = this.validarCampoRequerido(this.form.nombre, 'nombre');
      if (!nombreValidacion.valido) {
        errores.push(nombreValidacion.mensaje);
      }
      
      // Validar según tipo de formulario
      if (this.tipoFormulario === 'gestion_informacion') {
        // Validación específica para gestión de información
        const camposGestion = [
          { campo: 'areaSolicita', nombre: 'Área Solicitante' },
          { campo: 'ubicacion', nombre: 'Ubicación' },
          { campo: 'accionSolicitada', nombre: 'Acción Solicitada' },
          { campo: 'motivo', nombre: 'Motivo' }
        ];
        
        camposGestion.forEach(({ campo, nombre }) => {
          const validacion = this.validarCampoRequerido(this.form[campo], nombre);
          if (!validacion.valido) {
            errores.push(validacion.mensaje);
          }
        });
        
        // Validar aceptación de auditoría
        if (!this.form.auditoriaAceptada) {
          errores.push('Debe aceptar la auditoría de la solicitud');
        }
        
      } else if (this.form.solicitudArea === 'BIOMEDICA') {
        // Validación específica para biomédica según pestaña
        if (this.biomedicaTab === 'solicitud') {
          const camposSolicitud = [
            { campo: 'titulo', nombre: 'Título' },
            { campo: 'descripcion', nombre: 'Descripción' },
            { campo: 'areaSolicita', nombre: 'Área Solicitante' },
            { campo: 'ubicacion', nombre: 'Ubicación' }
          ];
          
          camposSolicitud.forEach(({ campo, nombre }) => {
            const validacion = this.validarCampoRequerido(this.form[campo], nombre);
            if (!validacion.valido) {
              errores.push(validacion.mensaje);
            }
          });
          
        } else if (this.biomedicaTab === 'insumos') {
          // Validar que haya insumos individuales o en la lista
          if (!this.form.insumos && (!this.form.listaInsumos || this.form.listaInsumos.length === 0)) {
            errores.push('El campo "Insumos" no puede estar vacío');
          }
          
        } else if (this.biomedicaTab === 'equipo') {
          const camposEquipo = [
            { campo: 'equipo', nombre: 'Equipo' },
            { campo: 'ubicacion', nombre: 'Ubicación' }
          ];
          
          camposEquipo.forEach(({ campo, nombre }) => {
            const validacion = this.validarCampoRequerido(this.form[campo], nombre);
            if (!validacion.valido) {
              errores.push(validacion.mensaje);
            }
          });
        }
        
      } else {
        // Validación para TECNOLOGIAS y MANTENIMIENTO
        const camposNormales = [
          { campo: 'titulo', nombre: 'Título' },
          { campo: 'descripcion', nombre: 'Descripción' },
          { campo: 'areaSolicita', nombre: 'Área Solicitante' },
          { campo: 'ubicacion', nombre: 'Ubicación' }
        ];
        
        camposNormales.forEach(({ campo, nombre }) => {
          const validacion = this.validarCampoRequerido(this.form[campo], nombre);
          if (!validacion.valido) {
            errores.push(validacion.mensaje);
          }
        });
      }
      
      // Validar solicitudArea (siempre requerido excepto para garrafón)
      if (!this.form.solicitudArea || this.form.solicitudArea.trim() === '') {
        errores.push('El área de atención es requerida');
      }
      
      return errores;
    },

    // Método automático para corregir prioridad de tickets de garrafón
    async corregirPrioridadGarrafonAutomatico(ticket) {
      // Detectar si es un ticket de garrafón con prioridad incorrecta
      if (ticket && 
          ticket.tipo === 'GARRAFON_AGUA' && 
          ticket.prioridad !== 'MEDIA') {
        
        console.log(`Detectado ticket de garrafón con prioridad incorrecta: ID=${ticket.id}, Prioridad=${ticket.prioridad}`);
        
        try {
          const response = await this.$http({
            url: '/mantenimiento/tickets/actualizarPrioridad',
            method: 'POST',
            data: {
              ticketId: ticket.id,
              prioridad: 'MEDIA'
            }
          });
          
          if (response.data.success || response.data.estado) {
            console.log(`Prioridad del ticket ${ticket.id} corregida automáticamente a MEDIA`);
            this.mostrarNotificacion(`Prioridad del ticket ${ticket.folio || ticket.id} corregida automáticamente a MEDIA`, 'info');
            
            // Actualizar el ticket localmente
            ticket.prioridad = 'MEDIA';
            
            return true;
          }
        } catch (error) {
          console.error('Error al corregir prioridad automáticamente:', error);
        }
      }
      return false;
    },

    // Verificar y corregir múltiples tickets de garrafón
    async verificarYCorregirTicketsGarrafon(tickets) {
      if (!tickets || !Array.isArray(tickets)) return;
      
      const ticketsGarrafon = tickets.filter(ticket => 
        ticket.tipo === 'GARRAFON_AGUA' && ticket.prioridad !== 'MEDIA'
      );
      
      if (ticketsGarrafon.length > 0) {
        console.log(`Detectados ${ticketsGarrafon.length} tickets de garrafón con prioridad incorrecta`);
        
        // Corregir cada ticket
        const correcciones = await Promise.allSettled(
          ticketsGarrafon.map(ticket => this.corregirPrioridadGarrafonAutomatico(ticket))
        );
        
        const exitosas = correcciones.filter(r => r.status === 'fulfilled' && r.value).length;
        if (exitosas > 0) {
          this.mostrarNotificacion(`${exitosas} ticket(s) de garrafón corregidos a prioridad MEDIA`, 'success');
        }
      }
    },

    async crearTicketCompleto(event) {
    //console.log('🚀 TicketForm: Método crearTicketCompleto ejecutado');
    //console.log('🔍 Evento recibido:', event);
      
      // Activar estado de carga
      this.isCreatingTicket = true;
      
      try {
        // Prevenir el comportamiento por defecto del formulario
        if (event) {
          event.preventDefault();
        }
        
        // Validar campos requeridos usando la nueva función robusta
        console.log('TicketForm: Validando formulario...');
        console.log(' Formulario actual:', this.form);
        console.log(' Área seleccionada:', this.form.solicitudArea);
        console.log(' Pestaña biomédica:', this.biomedicaTab);
        
        const erroresValidacion = this.validarFormularioCompleto();
        
        if (erroresValidacion.length > 0) {
          console.error('Errores de validación:', erroresValidacion);
          this.mostrarNotificacion(`Por favor corrige los siguientes campos:\n${erroresValidacion.join('\n')}`);
          this.isCreatingTicket = false;
          return;
        }

        // Validación: título máximo 30 caracteres (frontend)
        if (this.form.titulo && this.form.titulo.length > 30) {
          this.mostrarNotificacion('❌ El título no puede tener más de 30 caracteres');
          this.isCreatingTicket = false;
          return;
        }



        // Validación: detectar solicitudes de garrafón de agua
        const esGestionInformacion = this.tipoFormulario === 'gestion_informacion';
        // Para Gestión de Información, usar accionSolicitada y motivo. Para otros, usar titulo y descripcion
        const textoTitulo = esGestionInformacion ? (this.form.accionSolicitada || '') : (this.form.titulo || '');
        const textoDesc = esGestionInformacion ? (this.form.motivo || this.form.descripcion || '') : (this.form.descripcion || '');
        const textoCompleto = `${textoTitulo} ${textoDesc}`.toLowerCase();
        const palabrasGarrafon = ['garrafon', 'garrafón', 'garrafon de agua', 'garrafón de agua','garrafones'];
        const detectaGarrafon = palabrasGarrafon.some(palabra => textoCompleto.includes(palabra));

        if (detectaGarrafon) {
          this.mostrarNotificacion('💡 Haz la solicitud desde el boton Garrafón 🧴');
          this.isCreatingTicket = false;
          return;
        }

        // Bloquear cualquier mención de garrafón en Gestión de Información (incluso sin las palabras clave exactas)
        const tituloIncluyeGarraf = textoTitulo.toLowerCase().includes('garraf');
        const descIncluyeGarraf = textoDesc.toLowerCase().includes('garraf');
        if (esGestionInformacion && (tituloIncluyeGarraf || descIncluyeGarraf)) {
          console.log('🚫 BLOQUEADO: Detectada palabra garraf en Gestión de Información');
          this.mostrarNotificacion('💡 Haz la solicitud desde el boton Garrafón 🧴');
          this.isCreatingTicket = false;
          return;
        }

        // Validación: detectar solicitudes de insumos fuera de Biomédica o en Gestión de Información
        const palabrasInsumo = ['insumo', 'insumos','INSUMOS','INSUMO'];
        const detectaInsumo = palabrasInsumo.some(palabra => textoCompleto.includes(palabra));
        const areaSeleccionada = this.form.solicitudArea?.toUpperCase();
        console.log('🔍 DEBUG VALIDACIÓN - detectaInsumo:', detectaInsumo, 'area:', areaSeleccionada);

        if (detectaInsumo && (areaSeleccionada !== 'BIOMEDICA' || esGestionInformacion)) {
          this.mostrarNotificacion('💡Haz la solicitud en la seccion de insumos 📦 del area de Biomedica')
          this.isCreatingTicket = false;
          return;
        }

        // Notificación: recordar registrar expediente cuando se menciona paciente en Gestión de Información
        if (esGestionInformacion && textoCompleto.includes('paciente')) {
          // Mostrar modal de confirmación en lugar de solo notificación
          this.pacienteConfirmado = false;
          this.showConfirmacionPacienteModal = true;
          this.isCreatingTicket = false; // Detener la creación temporalmente
          return; // Salir del método para esperar confirmación
        }

        // Preparar datos para enviar al backend
        // El BACKEND calculará la prioridad automáticamente
        const datosTicket = {
          nombre: this.form.nombre,
          titulo: this.form.titulo || '',
          descripcion: this.form.descripcion || '',
          areaSolicita: this.form.areaSolicita,
          ubicacion: this.extraerStringDeUbicacion(this.form.ubicacion),
          solicitudArea: this.form.solicitudArea.toUpperCase(), // MANTENIMIENTO, TECNOLOGIAS, BIOMEDICA
          notas: this.form.notas || null,
          // Inicializar campos opcionales como null
          equipo: null,
          serialNumber: null,
          descripcionEquipo: null,
          insumos: null,
          cantidadInsumos: null,
          descripcionInsumos: null,
        };

        // Si es gestión de información, mapear campos específicos
        if (this.tipoFormulario === 'gestion_informacion') {
          // Mapear campos de gestión a los campos del ticket
          datosTicket.titulo = this.form.accionSolicitada || '';
          // Usar descripción (con diagnóstico automático) o motivo como fallback
          datosTicket.descripcion = this.form.descripcion || this.form.motivo || '';
          // Notas queda null para gestión de información
          datosTicket.notas = null;
          // Usar valores reales de áreaSolicita y ubicación
          datosTicket.areaSolicita = this.form.areaSolicita || '';
          datosTicket.ubicacion = this.extraerStringDeUbicacion(this.form.ubicacion) || '';
          // Agregar identificador de tipo de gestión
          datosTicket.esGestionInformacion = true;
          // Agregar campo de auditoría aceptada
          datosTicket.auditoriaAceptada = this.form.auditoriaAceptada;
          // Establecer tipo de ticket
          datosTicket.tipo = 'GESTION_INFORMACION';
        }

        // Manejar valores según el área seleccionada (solo para tickets normales)
        console.log(' DEBUG - Entrando a lógica de área. tipoFormulario:', this.tipoFormulario, 'solicitudArea:', this.form.solicitudArea);
        if (this.tipoFormulario !== 'gestion_informacion' && this.form.solicitudArea === 'BIOMEDICA') {
          console.log(' DEBUG - Entró en bloque BIOMEDICA. biomedicaTab:', this.biomedicaTab);
          // Para biomédica, los campos dependen de la pestaña seleccionada
          if (this.biomedicaTab === 'insumos') {
            // Solo insumos: titulo y descripcion con valor por defecto
            datosTicket.titulo = this.form.titulo || 'Solicitud de Insumos';
            datosTicket.descripcion = this.form.descripcion || 'Solicitud de insumos biomédicos';
            // Extraer string de ubicacion (puede ser objeto o string)
            datosTicket.ubicacion = this.extraerStringDeUbicacion(this.form.ubicacion);
            // Mantener campos de insumos
            datosTicket.insumos = this.form.insumos || null;
            datosTicket.cantidadInsumos = this.form.cantidadInsumos || null;
            datosTicket.descripcionInsumos = this.form.descripcionInsumos || null;
            // Establecer tipo de ticket
            datosTicket.tipo = 'INSUMOS';
          } else if (this.biomedicaTab === 'equipo') {
            // Solo equipo: titulo y descripcion con valor por defecto
            datosTicket.titulo = this.form.titulo || 'Equipo Afectado';
            datosTicket.descripcion = this.form.descripcion || 'Reporte de equipo biomédico afectado';
            // Extraer string de ubicacion (puede ser objeto o string)
            datosTicket.ubicacion = this.extraerStringDeUbicacion(this.form.ubicacion);
            // Mantener campos de equipo
            datosTicket.equipo = this.form.equipo || null;
            datosTicket.serialNumber = this.form.serialNumber || null;
            datosTicket.descripcionEquipo = this.form.descripcionEquipo || null;
            // Establecer tipo de ticket
            datosTicket.tipo = 'EQUIPO AFECTADO';
          } else {
            // Si es 'solicitud', todos los campos específicos quedan como null
            // Establecer tipo de ticket normal
            datosTicket.tipo = 'TICKET';
          }
        } else {
          // Para TECNOLOGIAS y MANTENIMIENTO, enviar todos los campos si existen
          // Establecer tipo de ticket normal (solo si no es gestión de información)
          if (this.tipoFormulario !== 'gestion_informacion') {
            datosTicket.tipo = 'TICKET';
          }
        }
        if (this.form.equipo) {
          datosTicket.equipo = this.form.equipo;
          datosTicket.serialNumber = this.form.serialNumber || null;
          datosTicket.descripcionEquipo = this.form.descripcionEquipo || null;
        }
        if (
             this.form.insumos ||
             (Array.isArray(this.form.listaInsumos) && this.form.listaInsumos.length > 0)
        ) {
          if (Array.isArray(this.form.listaInsumos) && this.form.listaInsumos.length > 0) {
                datosTicket.listaInsumos = this.form.listaInsumos;
          } else {
              datosTicket.insumos = this.form.insumos;
              datosTicket.cantidadInsumos = this.form.cantidadInsumos || null;
              datosTicket.descripcionInsumos = this.form.descripcionInsumos || null;
              }
          }
        
        console.log(' Enviando datos al backend:', datosTicket);
        console.log(' DEBUG - biomedicaTab:', this.biomedicaTab);
        console.log(' DEBUG - tipoFormulario:', this.tipoFormulario);
        console.log(' DEBUG - solicitudArea:', this.form.solicitudArea);
        console.log(' DEBUG - tipo asignado:', datosTicket.tipo);
        console.log(' CONTENIDO COMPLETO A ENVIAR:', JSON.stringify(datosTicket, null, 2));
   
        // Determinar endpoint según tipo de formulario
        let endpoint;
        if (this.tipoFormulario === 'gestion_informacion') {
          // NOTA: El endpoint específico no existe, usar el genérico temporalmente
          endpoint = '/mantenimiento/tickets/crearTicket';
        } else if (this.form.solicitudArea === 'BIOMEDICA') {
          if (this.biomedicaTab === 'insumos') {
            endpoint = '/mantenimiento/tickets/crearTicketInsumos';
          } else if (this.biomedicaTab === 'equipo') {
            endpoint = '/mantenimiento/tickets/crearTicketEquipo';
          } else {
            endpoint = '/mantenimiento/tickets/crearTicket';
          }
        } else {
          endpoint = '/mantenimiento/tickets/crearTicket';
        }
        
        console.log(' DEBUG - Endpoint seleccionado:', endpoint);
          
        const response = await this.$http({
          url: endpoint,
          method: 'POST',
          data: datosTicket,
        });
        
        console.log('📥 Respuesta del backend:', response.data);
        
        if (response.data.success || response.data.estado) {
          // El backend devuelve el ticket con la prioridad ya calculada
          const ticketCreado = response.data.root;
          const prioridadAsignada = ticketCreado.prioridad || 'MEDIA';

          // Si se adjuntaron PDFs en el formulario, subirlos al ticket recién creado.
          console.log('PDF DEBUG - Verificando PDFs para subir:', {
            pdfFiles: this.form.pdfFiles,
            pdfFilesLength: this.form.pdfFiles?.length || 0,
            ticketCreado: ticketCreado,
            ticketId: ticketCreado?.id
          });
          
          console.log('PDF DEBUG - Verificando si hay PDFs para subir...');
          console.log('PDF DEBUG - form.pdfFiles:', this.form.pdfFiles);
          console.log('PDF DEBUG - ticketCreado:', ticketCreado);
          
          if (this.form.pdfFiles && this.form.pdfFiles.length > 0 && ticketCreado && ticketCreado.id) {
            console.log('PDF DEBUG - Iniciando subida de PDFs para ticket ID:', ticketCreado.id);
            console.log('PDF DEBUG - Cantidad de PDFs a subir:', this.form.pdfFiles.length);
            console.log('PDF DEBUG - Llamando a subirPdfsTicket con ticketId:', ticketCreado.id);
          console.log('PDF DEBUG - Antes de llamar a subirPdfsTicket, pdfFiles:', this.form.pdfFiles);
          await this.subirPdfsTicket(ticketCreado.id);
          console.log('PDF DEBUG - Después de llamar a subirPdfsTicket');
          } else {
            console.log('PDF DEBUG - No hay PDFs para subir o falta información del ticket');
            console.log('PDF DEBUG - pdfFiles.length:', this.form.pdfFiles?.length || 0);
            console.log('PDF DEBUG - ticketCreado.id:', ticketCreado?.id);
          }
          
          // Mostrar notificación de éxito según tipo de formulario
          const mensajeExito = this.tipoFormulario === 'gestion_informacion'
            ? `✅ Solicitud de gestión de información creada exitosamente`
            : `✅ Ticket creado exitosamente con prioridad ${this.capitalizarPrioridad(prioridadAsignada)}`;
          
          this.mostrarNotificacion(mensajeExito);
          
          // Recargar lista de tickets desde el backend
          await this.cargarTicketsDesdeBackend();
          
          // Cerrar modal y limpiar formulario
          this.cerrarFormulario();
        } else {
          throw new Error(response.data.mensaje || 'Error al crear el ticket');
        }
        
      } catch (error) {
        console.error('❌ TicketForm: Error general en crearTicketCompleto:', error);
        this.mostrarNotificacion(`❌ Error al crear el ticket: ${error.response?.data?.mensaje || error.message || 'Error desconocido'}`);
        this.$store.dispatch('security/revisaError', error);
        // No cerrar el modal si hay error para que el usuario pueda intentar de nuevo
      } finally {
        // Resetear estado de carga
        this.isCreatingTicket = false;
      }
    },

    onAreaRequeridaChange() {
      // Resetear pestaña biomédica cuando cambia el área requerida
      if (this.form.solicitudArea !== 'BIOMEDICA') {
        this.biomedicaTab = 'solicitud';
      } else {
        // Si cambia a biomédica, resetear a la primera pestaña
        this.biomedicaTab = 'solicitud';
      }
      
      // Limpiar campos que no corresponden al área
      if (this.form.solicitudArea === 'BIOMEDICA') {
        // Limpiar todos los campos específicos hasta que el usuario seleccione una pestaña
        this.form.equipo = '';
        this.form.serialNumber = '';
        this.form.descripcionEquipo = '';
        this.form.insumos = '';
        this.form.descripcionInsumos = '';
        this.form.cantidadInsumos = 1;
      }
    },

    onTipoFormularioChange() {
      // Resetear campos específicos cuando cambia el tipo de formulario
      if (this.tipoFormulario === 'gestion_informacion') {
        // Establecer área TECNOLOGIAS automáticamente para gestión de información
        this.form.solicitudArea = 'TECNOLOGIAS';
        // Limpiar campos que no se usan en gestión de información
        this.form.titulo = '';
        this.form.descripcion = '';
        this.form.notas = '';
      } else {
        // Limpiar campos específicos de gestión de información
        this.form.accionSolicitada = '';
        this.form.motivo = '';
        this.form.descripcionDetallada = '';
        this.form.auditoriaAceptada = false;
      }
    },

    /**
     * Abrir modal o iniciar escaneo de QR
     * En dispositivos móviles con cámara, esto podría abrir la cámara
     * Por ahora, enfoca el input manual
     */
    abrirQrScanner() {
      this.isScanningQr = true;
      this.qrError = '';
      
      // Simular escaneo o enfocar input manual
      this.$nextTick(() => {
        const qrInput = document.querySelector('.qr-manual-input input');
        if (qrInput) {
          qrInput.focus();
        }
      });
      
      // Mostrar notificación de ayuda
      this.mostrarNotificacion('📷 Ingresa el ID del QR manualmente o escanéalo con tu dispositivo');
      
      setTimeout(() => {
        this.isScanningQr = false;
      }, 1000);
    },

    /**
     * Buscar equipo por identificador QR
     * @param {string} qrId - Identificador del QR
     */
    async buscarEquipoPorQr(qrId) {
      if (!qrId || !qrId.trim()) {
        this.qrError = 'Ingresa un identificador válido';
        return;
      }
      
      this.isLoadingEquipo = true;
      this.qrError = '';
      this.equipoEscaneado = null;
      
      try {
        const response = await this.$http({
          url: '/mantenimiento/equipoBiomedica/buscarPorQr',
          method: 'GET',
          params: { qrId: qrId.trim() }
        });
        
        if (response.data.success && response.data.equipo) {
          const equipo = response.data.equipo;
          this.equipoEscaneado = equipo;
          
          // Mapear datos al formulario
          this.form.equipo = equipo.descripcion || `${equipo.marca} ${equipo.modelo}`.trim();
          this.form.serialNumber = equipo.numeroSerie || '';
          this.form.descripcionEquipo = `Marca: ${equipo.marca || 'N/A'}, Modelo: ${equipo.modelo || 'N/A'}, Color: ${equipo.color || 'N/A'}, Área: ${equipo.area || 'N/A'}`;
          
          // Si el equipo tiene área asignada, usarla como sugerencia
          if (equipo.area && !this.form.areaSolicita) {
            this.form.areaSolicita = equipo.area;
          }
          
          this.mostrarNotificacion(`✅ Equipo encontrado: ${equipo.marca} ${equipo.modelo}`);
        } else {
          this.qrError = response.data.mensaje || 'Equipo no encontrado';
          this.mostrarNotificacion(`❌ ${this.qrError}`);
        }
      } catch (error) {
        console.error('Error al buscar equipo por QR:', error);
        this.qrError = 'Error de conexión al buscar el equipo';
        this.mostrarNotificacion('❌ Error de conexión al buscar el equipo');
      } finally {
        this.isLoadingEquipo = false;
      }
    },

    /**
     * Limpiar el equipo escaneado y resetear campos relacionados
     */
    limpiarEquipoEscaneado() {
      this.equipoEscaneado = null;
      this.qrInputId = '';
      this.qrError = '';
      this.form.equipo = '';
      this.form.serialNumber = '';
      this.form.descripcionEquipo = '';
    },

    /**
     * Extraer string de ubicacion (puede ser objeto o string)
     * @param {any} ubicacion - Valor de ubicacion (objeto o string)
     * @returns {string|null} - String de ubicacion o null
     */
    extraerStringDeUbicacion(ubicacion) {
      if (!ubicacion) return null;
      // Si es string, devolverlo directamente
      if (typeof ubicacion === 'string') return ubicacion;
      // Si es objeto con propiedad nombre
      if (typeof ubicacion === 'object') {
        return ubicacion.nombre || ubicacion.toString() || null;
      }
      return null;
    },

    guardarEstadoActual(ticket) {
      // Guardar el estado actual antes de que el usuario lo cambie en el dropdown
      if (ticket && ticket.estado !== 'REASIGNAR') {
        ticket.estadoAnterior = (ticket.estado || '').toString().toUpperCase();
      }
    },

    async actualizarEstado(ticket) {
      console.log(`Estado actualizado para ticket ${ticket.id}: ${ticket.estado}`);
      
      const estadoDeseado = (ticket.estado || '').toString().toUpperCase();
      const tieneTecnico = this.tieneTecnicoAsignado(ticket);
      
      // Si el estado es "reasignar", abrir modal de reasignación
      if (estadoDeseado === 'REASIGNAR') {
        this.ticketToReassign = ticket;
        this.reassignData.razon = '';
        this.reassignData.nuevaArea = '';
        this.showReassignModal = true;
        return;
      }

      if (estadoDeseado === 'EN_PROCESO' && !tieneTecnico) {
        this.mostrarNotificacion('❌ Debes asignar un técnico antes de mover el ticket a "En Proceso".');
        this.revertirEstadoTicket(ticket);
        return;
      }

      if (estadoDeseado === 'RESUELTO' && !tieneTecnico) {
        this.mostrarNotificacion('❌ No puedes marcar el ticket como "Resuelto" sin un técnico asignado.');
        this.revertirEstadoTicket(ticket);
        return;
      }
      
      try {
        // Convertir estado a mayúsculas según backend
        const estadoBackend = estadoDeseado;
        const estadosValidos = {
          'PENDIENTE': 'PENDIENTE',
          'EN_PROCESO': 'EN_PROCESO',
          'RESUELTO': 'RESUELTO',
          'CANCELADO': 'CANCELADO'
        };
        
        const response = await this.$http({
          url: '/mantenimiento/tickets/actualizarEstado',
          method: 'POST',
          data: {
            ticketId: ticket.id,
            estado: estadosValidos[estadoBackend] || 'PENDIENTE',
            comentario: ticket.comentariosInternos || '',
          }
        });
        
        if (response.data.success || response.data.estado) {
          this.mostrarNotificacion(`✅ Estado actualizado correctamente`);
          // Recargar tickets desde backend
          await this.cargarTicketsDesdeBackend();
          if (this.ticketDetalle && this.ticketDetalle.id === ticket.id) {
            await this.cargarDetalleTicket(ticket.id);
          }
        }
      } catch (error) {
        console.error('❌ Error al actualizar estado:', error);
        this.mostrarNotificacion(`❌ Error al actualizar el estado`);
        this.$store.dispatch('security/revisaError', error);
        // Recargar para revertir cambio local
        await this.cargarTicketsDesdeBackend();
      }
    },
    tieneTecnicoAsignado(ticket) {
      if (!ticket) {
        return false;
      }
      const idDirecto = ticket.tecnicoAsignadoId;
      if (idDirecto !== null && idDirecto !== undefined && idDirecto !== '') {
        return true;
      }
      const idAlterno = ticket.tecnicoId || ticket.tecnicoAsignadoIdOriginal;
      if (idAlterno !== null && idAlterno !== undefined && idAlterno !== '') {
        return true;
      }
      if (ticket.tecnicoAsignado && ticket.tecnicoAsignado.id) {
        return true;
      }
      return false;
    },
    revertirEstadoTicket(ticket) {
      const estadoPrevio = (ticket.estadoAnterior || 'PENDIENTE').toString().toUpperCase();
      this.$nextTick(() => {
        ticket.estado = estadoPrevio;
        ticket.estadoAnterior = estadoPrevio;
      });
    },
    async establecerEstadoEnProcesoAutomatico(ticket) {
      if (!ticket || !ticket.id) {
        return;
      }
      const estadoActual = (ticket.estado || '').toString().toUpperCase();
      if (estadoActual === 'EN_PROCESO' || estadoActual === 'RESUELTO' || estadoActual === 'CANCELADO') {
        return;
      }
      try {
        await this.$http({
          url: '/mantenimiento/tickets/actualizarEstado',
          method: 'POST',
          data: {
            ticketId: ticket.id,
            estado: 'EN_PROCESO',
            comentario: ticket.comentariosInternos || ''
          }
        });
        ticket.estado = 'EN_PROCESO';
        ticket.estadoAnterior = 'EN_PROCESO';
        console.log(`🔧 Ticket ${ticket.id} marcado automáticamente como EN_PROCESO tras asignar técnico.`);
      } catch (error) {
        console.warn('No fue posible actualizar el ticket a EN_PROCESO automáticamente:', error);
      }
    },
    async actualizarTecnico(ticket) {
      const tecnicoId = ticket.tecnicoAsignadoId;
      console.log(`🔧 Asignando técnico ID ${tecnicoId} al ticket ${ticket.id}`);
      
      try {
        const tecnicoToSend = (tecnicoId !== null && tecnicoId !== undefined && tecnicoId !== '') ? Number(tecnicoId) : null;
        const response = await this.$http({
          url: '/mantenimiento/tickets/actualizarTecnico',
          method: 'POST',
          data: {
            ticketId: ticket.id,
            tecnicoId: tecnicoToSend,
          }
        });
        
        if (response.data.success || response.data.estado) {
          if (tecnicoId) {
            await this.establecerEstadoEnProcesoAutomatico(ticket);
          }
          const tecnicoNombre = tecnicoId ?
            this.listaTecnicos.find(t => t.id === tecnicoId)?.nombre || 'Técnico' :
            'Sin asignar';
          this.mostrarNotificacion(`✅ Técnico ${tecnicoNombre} asignado correctamente`);
          // Actualizar la fila del ticket con la respuesta del servidor (tecnicoAsignado, tecnicoAsignadoId, etc.)
          if (response.data.root && this.tickets) {
            const idx = this.tickets.findIndex(t => t.id === ticket.id);
            if (idx !== -1) {
              this.$set(this.tickets, idx, { ...this.tickets[idx], ...response.data.root });
            }
          }
          await this.cargarTicketsDesdeBackend();
          if (this.ticketDetalle && this.ticketDetalle.id === ticket.id) {
            await this.cargarDetalleTicket(ticket.id);
          }
        }
      } catch (error) {
        console.error('❌ Error al actualizar técnico:', error);
        this.mostrarNotificacion(`❌ Error al asignar el técnico`);
        this.$store.dispatch('security/revisaError', error);
        // Recargar para revertir cambio local
        await this.cargarTicketsDesdeBackend();
      }
    },
    // Asigna el equipo seleccionado al ticket actual
    async asignarEquipo() {
      if (!this.ticketParaEquipo) return;
      // Validación de clientes: mínimo 2 y máximo 3 técnicos
      if (!this.equipoSeleccionado || this.equipoSeleccionado.length < 2) {
        this.mostrarNotificacion('❌ Debes seleccionar al menos 2 técnicos para conformar un equipo');
        return;
      }
      if (this.equipoSeleccionado.length > 3) {
        this.mostrarNotificacion('❌ No puedes seleccionar más de 3 técnicos');
        return;
      }
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/actualizarTecnico',
          method: 'POST',
          data: {
            ticketId: this.ticketParaEquipo.id,
            tecnicoIds: this.equipoSeleccionado
          }
        });
        if (response.data.success || response.data.estado) {
          this.mostrarNotificacion('✅ Equipo asignado correctamente');
          await this.cargarTicketsDesdeBackend();
          if (this.ticketDetalle && this.ticketDetalle.id === this.ticketParaEquipo.id) {
            await this.cargarDetalleTicket(this.ticketParaEquipo.id);
          }
        } else {
          const msg = response.data.mensaje || 'Error al asignar equipo';
          this.mostrarNotificacion(`❌ ${msg}`);
        }
      } catch (error) {
        console.error('❌ Error al asignar equipo:', error);
        this.mostrarNotificacion('❌ Error al asignar equipo');
        this.$store.dispatch('security/revisaError', error);
      }
      this.showEquipoModal = false;
      this.ticketParaEquipo = null;
      this.equipoSeleccionado = [];
    },
    cancelarEquipo() {
      this.showEquipoModal = false;
      this.ticketParaEquipo = null;
      this.equipoSeleccionado = [];
    },

    abrirModalEquipo(ticket) {
      if (!ticket) return;
      this.ticketParaEquipo = ticket;
      this.equipoSeleccionado = ticket.tecnicosEquipo ? ticket.tecnicosEquipo.map(t => t.id) : [];
      this.showEquipoModal = true;
    },
    
    // Nueva función para asignar ticket usando el endpoint específico
    async asignarTicket(ticketId, tecnicoId, comentario = '') {
      console.log(`Asignando ticket ${ticketId} al técnico ${tecnicoId}`);
      
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/asignarTicket',
          method: 'POST',
          data: {
            ticketId: ticketId,
            tecnicoId: tecnicoId,
            comentario: comentario
          }
        });
        
        if (response.data.success || response.data.estado) {
          this.mostrarNotificacion(`✅ Ticket asignado correctamente`);
          // Recargar tickets desde backend
          await this.cargarTicketsDesdeBackend();
          return true;
        }
        return false;
      } catch (error) {
        console.error('❌ Error al asignar ticket:', error);
        this.mostrarNotificacion(`❌ Error al asignar el ticket`);
        this.$store.dispatch('security/revisaError', error);
        return false;
      }
    },
    
    // función para obtener estadísticas generales
    async obtenerEstadisticas(filtros = {}) {
      console.log('Obteniendo estadísticas de tickets:', filtros);
      
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/estadisticas',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          params: {
            fechaInicio: filtros.fechaInicio || undefined,
            fechaFin: filtros.fechaFin || undefined,
            area: filtros.area || undefined,
            tecnico: filtros.tecnico || undefined
          }
        });
        
        if (response.data && response.data.success) {
          return response.data.estadisticas || response.data;
        }
        return null;
      } catch (error) {
        console.error('❌ Error al obtener estadísticas:', error);
        this.$store.dispatch('security/revisaError', error);
        return null;
      }
    },
    
    // función para obtener historial de un ticket
    async obtenerHistorialTicket(ticketId) {
      console.log(`Obteniendo historial del ticket ${ticketId}`);
      
      try {
        const response = await this.$http({
          url: `/mantenimiento/tickets/obtenerHistorial/${ticketId}`,
          method: 'GET'
        });
        
        if (response.data && response.data.success) {
          return response.data.historial || response.data.root || [];
        }
        return [];
      } catch (error) {
        console.error('❌ Error al obtener historial:', error);
        this.$store.dispatch('security/revisaError', error);
        return [];
      }
    },
    
    // función para obtener estadísticas de un técnico específico
    async obtenerEstadisticasTecnico(tecnicoId, filtros = {}) {
      console.log(`Obteniendo estadísticas del técnico ${tecnicoId}:`, filtros);
      
      try {
        const response = await this.$http({
          url: `/mantenimiento/tickets/estadisticasTecnico/${tecnicoId}`,
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          params: {
            fechaInicio: filtros.fechaInicio || undefined,
            fechaFin: filtros.fechaFin || undefined,
            periodo: filtros.periodo || undefined
          }
        });
        
        if (response.data && response.data.success) {
          return response.data.estadisticas || response.data;
        }
        return null;
      } catch (error) {
        console.error('❌ Error al obtener estadísticas del técnico:', error);
        this.$store.dispatch('security/revisaError', error);
        return null;
      }
    },
    
    actualizarSolicitudArea(ticket) {
      console.log(`Área de solicitud actualizada para ticket ${ticket.id}: ${ticket.solicitudArea}`);
      
      // VALIDACIÓN: Verificar si se puede cambiar el área de solicitud
      if (this.requiereValidacionSolucion(ticket)) {
        // Caso especial: ticket resuelto - BLOQUEAR completamente
        if (ticket.estado === 'resuelto') {
          alert(
            `🚫 CAMBIO NO PERMITIDO\n\n` +
            `El ticket #${ticket.id} está en estado "${this.getEstadoText(ticket.estado, false, ticket.esGestionInformacion)}" y ya no se pueden realizar cambios.\n\n` +
            `Los tickets resueltos son de solo lectura para mantener la integridad de los datos.`
          );
          
          // Revertir el cambio inmediatamente
          this.$nextTick(() => {
            this.revertirSolicitudArea(ticket);
          });
          return;
        }
      }
      
      // La prioridad ya NO se recalcula en el frontend
      // El backend es responsable de calcular la prioridad cuando se crea o actualiza el ticket
      this.mostrarNotificacion(`🔄 Área de solicitud actualizada a: ${this.getSolicitudText(ticket.solicitudArea)}`);
    },
    requiereValidacionSolucion(ticket) {
      // Solo bloquear cambios en tickets resueltos
      // Con la nueva funcionalidad de reasignación, ya no se requiere validación de solución del técnico
      return ticket.estado === 'resuelto';
    },
    guardarEstadoAnterior(ticket) {
      // Guardar el valor actual antes de que el usuario lo cambie
      this.solicitudAreaAnterior[ticket.id] = ticket.solicitudArea;
      console.log(`Estado anterior guardado para ticket ${ticket.id}: ${ticket.solicitudArea}`);
    },
    revertirSolicitudArea(ticket) {
      // Restaurar el valor anterior
      const valorAnterior = this.solicitudAreaAnterior[ticket.id];
      if (valorAnterior !== undefined) {
        ticket.solicitudArea = valorAnterior;
        console.log(`Revertido área de solicitud para ticket ${ticket.id} a "${valorAnterior}"`);
      } else {
        // Fallback: usar el primer valor disponible
        ticket.solicitudArea = 'tecnologia';
      }
    },
    obtenerNivelPrioridad(prioridad) {
      // Convierte las prioridades en números para poder compararlas
      // Solo 3 niveles: Alta = 3, Media = 2, Baja = 1
      switch (prioridad?.toLowerCase()) {
        case 'alta':
          return 3;
        case 'media':
          return 2;
        case 'baja':
          return 1;
        default:
          return 2; // Por defecto, prioridad media
      }
    },
    esTicketFinalizado(ticket) {
      const estado = (ticket?.estado || '').toString().toUpperCase();
      return estado === 'RESUELTO' || estado === 'CANCELADO';
    },
    obtenerFechaFinalizacion(ticket) {
      return ticket?.fechaCierre || null;
    },
    
    // Método para cambiar la prioridad manualmente (solo administradores y técnicos)
    async cambiarPrioridadManual(ticket) {
      if (!this.esAdminOTecnico || !ticket) return;
      
      const nuevaPrioridad = ticket.prioridad;
      const prioridadAnterior = ticket.prioridad || 'Media';
      
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/actualizarPrioridad',
          method: 'POST',
          data: {
            ticketId: ticket.id,
            prioridad: nuevaPrioridad.toUpperCase(), // BAJA, MEDIA, ALTA
          }
        });
        
        if (response.data.success || response.data.estado) {
          this.mostrarNotificacion(`🚨 Prioridad cambiada de "${prioridadAnterior}" a "${nuevaPrioridad}"`);
          // Recargar tickets desde backend
          await this.cargarTicketsDesdeBackend();
        }
      } catch (error) {
        console.error('❌ Error al actualizar prioridad:', error);
        this.mostrarNotificacion(`❌ Error al actualizar la prioridad`);
        this.$store.dispatch('security/revisaError', error);
        // Recargar para revertir cambio local
        await this.cargarTicketsDesdeBackend();
      }
    },
    
    
    // Método auxiliar para obtener información de prioridad
    obtenerInfoPrioridad(prioridad) {
      switch (prioridad?.toLowerCase()) {
        case 'alta':
          return {
            color: '#FF6600',
            descripcion: 'Prioridad alta - requiere atención rápida',
            tiempoRespuesta: 'Alta (15-30 min)'
          };
        case 'media':
          return {
            color: '#FFCC00',
            descripcion: 'Prioridad media - atención normal',
            tiempoRespuesta: 'Media (30-60 min)'
          };
        case 'baja':
          return {
            color: '#00CC00',
            descripcion: 'Prioridad baja - puede esperar',
            tiempoRespuesta: 'Baja (1-2 horas)'
          };
        default:
          return {
            color: '#FFCC00',
            descripcion: 'Prioridad media por defecto',
            tiempoRespuesta: 'Media (30-60 min)'
          };
      }
    },
    handlePhotoUpload(event) {
      const files = Array.from(event.target.files);
      console.log(`📷 Archivos seleccionados: ${files.length}`);
      
      files.forEach(file => {
        // Validar que sea una imagen
        if (!file.type.startsWith('image/')) {
          alert(`❌ El archivo "${file.name}" no es una imagen válida.`);
          return;
        }
        
        // Validar tamaño (máximo 5MB)
        if (file.size > 5 * 1024 * 1024) {
          alert(`❌ La imagen "${file.name}" es demasiado grande. Máximo 5MB permitido.`);
          return;
        }
        
        // Crear objeto URL para vista previa
        const reader = new FileReader();
        reader.onload = (e) => {
          const foto = {
            nombre: file.name,
            tamaño: file.size,
            tipo: file.type,
            archivo: file,
            url: e.target.result,
            fecha: new Date().toISOString()
          };
          
          // Inicializar array si no existe
          if (!this.ticketDetalle.fotosAdjuntas) {
            this.ticketDetalle.fotosAdjuntas = [];
          }
          
          // Agregar foto al ticket
          this.ticketDetalle.fotosAdjuntas.push(foto);
          
          console.log(`✅ Foto agregada: ${foto.nombre}`);
          this.mostrarNotificacion(`📷 Foto "${foto.nombre}" agregada exitosamente`);
        };
        
        reader.readAsDataURL(file);
      });
      
      // Limpiar el input para permitir seleccionar los mismos archivos nuevamente
      event.target.value = '';
    },
    removePhoto(index) {
      if (this.ticketDetalle.fotosAdjuntas && index >= 0 && index < this.ticketDetalle.fotosAdjuntas.length) {
        const fotoRemovida = this.ticketDetalle.fotosAdjuntas[index];
        this.ticketDetalle.fotosAdjuntas.splice(index, 1);
        
        console.log(`🗑️ Foto removida: ${fotoRemovida.nombre}`);
        this.mostrarNotificacion(`🗑️ Foto "${fotoRemovida.nombre}" removida`);
      }
    },
    mostrarNotificacion(mensaje) {
      // Crear una notificación temporal
      const notificacion = document.createElement('div');
      notificacion.className = 'notificacion-temp';
      notificacion.textContent = mensaje;
      notificacion.style.cssText = `
        position: fixed;
        top: 40px;
        right: 40px;
        background: #009a44;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        z-index: 9999;
        font-size: 0.9rem;
        font-weight: 600;
        animation: slideInRight 0.3s ease-out;
      `;
      
      document.body.appendChild(notificacion);
      
      // Remover la notificación después de 3 segundos
      setTimeout(() => {
        notificacion.style.animation = 'slideOutRight 0.3s ease-in';
        setTimeout(() => {
          if (notificacion.parentNode) {
            notificacion.parentNode.removeChild(notificacion);
          }
        }, 300);
      }, 3000);
    },
    // ===== MÉTODOS DE EJEMPLO PARA USAR LAS NUEVAS RUTAS =====
    
    // Ejemplo: Asignar ticket con interfaz mejorada
    async asignarTicketConInterfaz(ticket) {
      if (!ticket || !ticket.id) {
        this.mostrarNotificacion('❌ Ticket no válido para asignación');
        return;
      }
      
      // Mostrar diálogo para seleccionar técnico
      const tecnicoSeleccionado = prompt(
        `Asignar ticket #${ticket.id} a técnico:\n\n` +
        `Técnicos disponibles:\n${this.listaTecnicos.join('\n')}\n\n` +
        `Ingresa el nombre del técnico:`
      );
      
      if (!tecnicoSeleccionado) return;
      
      // Buscar ID del técnico (esto dependería de cómo esté estructurada la lista)
      const tecnicoId = this.listaTecnicos.indexOf(tecnicoSeleccionado) + 1; // Ejemplo simple
      
      const comentario = prompt('Comentario adicional (opcional):') || '';
      
      const exito = await this.asignarTicket(ticket.id, tecnicoId, comentario);
      if (exito) {
        this.mostrarNotificacion(`✅ Ticket #${ticket.id} asignado a ${tecnicoSeleccionado}`);
      }
    },
    
    // Ejemplo: Mostrar estadísticas generales
    async mostrarEstadisticasGenerales() {
      try {
        const filtros = {
          fechaInicio: prompt('Fecha inicio (YYYY-MM-DD) o dejar vacío:') || undefined,
          fechaFin: prompt('Fecha fin (YYYY-MM-DD) o dejar vacío:') || undefined,
          area: prompt('Área específica o dejar vacío:') || undefined
        };
        
        const estadisticas = await this.obtenerEstadisticas(filtros);
        
        if (estadisticas) {
          const mensaje = `
📊 ESTADÍSTICAS DE TICKETS

📈 Total de tickets: ${estadisticas.totalTickets || 'N/A'}
✅ Resueltos: ${estadisticas.ticketsResueltos || 'N/A'}
⏳ Pendientes: ${estadisticas.ticketsPendientes || 'N/A'}
🔄 En proceso: ${estadisticas.ticketsEnProceso || 'N/A'}
📊 Tasa de resolución: ${estadisticas.tasaResolucion || 'N/A'}%
⏱️ Tiempo promedio: ${estadisticas.tiempoPromedio || 'N/A'}
          `;
          
          alert(mensaje);
        } else {
          this.mostrarNotificacion('❌ No se pudieron obtener las estadísticas');
        }
      } catch (error) {
        console.error('Error al mostrar estadísticas:', error);
        this.mostrarNotificacion('❌ Error al obtener estadísticas');
      }
    },
    
    // Ejemplo: Mostrar historial de un ticket
    async mostrarHistorialTicket(ticketId) {
      if (!ticketId) {
        this.mostrarNotificacion('❌ ID de ticket requerido');
        return;
      }
      
      try {
        const historial = await this.obtenerHistorialTicket(ticketId);
        
        if (historial && historial.length > 0) {
          let mensaje = `📋 HISTORIAL DEL TICKET #${ticketId}\n\n`;
          
          historial.forEach((evento, index) => {
            mensaje += `${index + 1}. ${evento.fecha || 'Sin fecha'}\n`;
            mensaje += `   Acción: ${evento.accion || 'Sin acción'}\n`;
            mensaje += `   Usuario: ${evento.usuario || 'Sin usuario'}\n`;
            mensaje += `   Comentario: ${evento.comentario || 'Sin comentario'}\n\n`;
          });
          
          alert(mensaje);
        } else {
          this.mostrarNotificacion(`ℹ️ No hay historial disponible para el ticket #${ticketId}`);
        }
      } catch (error) {
        console.error('Error al mostrar historial:', error);
        this.mostrarNotificacion('❌ Error al obtener historial');
      }
    },
    
    // Ejemplo: Mostrar estadísticas de un técnico específico
    async mostrarEstadisticasTecnico() {
      const tecnicoId = prompt('Ingresa el ID del técnico:');
      if (!tecnicoId) return;
      
      try {
        const filtros = {
          fechaInicio: prompt('Fecha inicio (YYYY-MM-DD) o dejar vacío:') || undefined,
          fechaFin: prompt('Fecha fin (YYYY-MM-DD) o dejar vacío:') || undefined,
          periodo: prompt('Período (mes/año) o dejar vacío:') || undefined
        };
        
        const estadisticas = await this.obtenerEstadisticasTecnico(tecnicoId, filtros);
        
        if (estadisticas) {
          const mensaje = `
👨‍💼 ESTADÍSTICAS DEL TÉCNICO #${tecnicoId}

   Tickets atendidos: ${estadisticas.ticketsAtendidos || 'N/A'}
   Tickets resueltos: ${estadisticas.ticketsResueltos || 'N/A'}
   Tickets pendientes: ${estadisticas.ticketsPendientes || 'N/A'}
   Eficiencia: ${estadisticas.eficiencia || 'N/A'}%
   Tiempo promedio: ${estadisticas.tiempoPromedio || 'N/A'}
   Calificación: ${estadisticas.calificacion || 'N/A'}
          `;
          
          alert(mensaje);
        } else {
          this.mostrarNotificacion('❌ No se pudieron obtener las estadísticas del técnico');
        }
      } catch (error) {
        console.error('Error al mostrar estadísticas del técnico:', error);
        this.mostrarNotificacion('❌ Error al obtener estadísticas del técnico');
      }
    },
    
    // ===== FIN DE MÉTODOS DE EJEMPLO =====
    
    // Funciones para manejar la reasignación
    async confirmarReasignacion() {
      if (!this.reassignData.razon.trim()) {
        alert('⚠️ Por favor ingresa la razón de la reasignación');
        return;
      }
      
      if (!this.reassignData.nuevaArea) {
        alert('⚠️ Por favor selecciona el área de destino');
        return;
      }
      
      if (this.ticketToReassign) {
        try {
          // Guardar el área anterior para el mensaje
          const areaAnterior = this.getSolicitudText(this.ticketToReassign.solicitudArea);
          const areaNueva = this.getSolicitudText(this.reassignData.nuevaArea);
          
          // Usar el nuevo endpoint específico de transferirArea
          const response = await this.$http({
            url: '/mantenimiento/tickets/transferirArea',
            method: 'POST',
            data: {
              ticketId: this.ticketToReassign.id,
              nuevaArea: this.reassignData.nuevaArea.toUpperCase(),
              motivo: this.reassignData.razon
            }
          });
          
          if (response.data.success || response.data.estado) {
            // Mostrar el mensaje del backend
            this.mostrarNotificacion(response.data.mensaje || `🔄 Ticket reasignado de ${areaAnterior} a ${areaNueva}`);
            
            // Recargar tickets desde backend
            await this.cargarTicketsDesdeBackend();
            
            // Cerrar modal
            this.cerrarModalReasignacion();
          } else {
            // Mostrar error del backend
            alert(`❌ ${response.data.mensaje || 'Error al reasignar el ticket'}`);
          }
        } catch (error) {
          console.error('❌ Error al reasignar ticket:', error);
          const mensajeError = error.response?.data?.mensaje || 'Error al reasignar el ticket';
          this.mostrarNotificacion(`❌ ${mensajeError}`);
          this.$store.dispatch('security/revisaError', error);
        }
      }
    },
    
    cancelarReasignacion() {
      // No revertir el estado, mantener el estado actual
      this.cerrarModalReasignacion();
    },
    
    cerrarModalReasignacion() {
      // Restaurar estado anterior si se canceló la reasignación
      if (this.ticketToReassign && this.ticketToReassign.estadoAnterior) {
        this.ticketToReassign.estado = this.ticketToReassign.estadoAnterior;
      }
      
      this.showReassignModal = false;
      this.ticketToReassign = null;
      this.reassignData.razon = '';
      this.reassignData.nuevaArea = '';
    },
    
    // Funciones para manejar la cancelación
    async confirmarCancelacion() {
      if (!this.cancelData.motivo.trim()) {
        this.mostrarNotificacion('⚠️ Por favor ingresa el motivo de la cancelación');
        return;
      }
      
      if (this.ticketToCancel) {  
        try {
          const response = await this.$http({
            url: '/mantenimiento/tickets/cancelarTicket',
            method: 'POST',
            data: {
              id: this.ticketToCancel.id,
              motivo: this.cancelData.motivo,
            }
          });
          
          if (response.data.success === true || response.data.estado === true) {
            this.mostrarNotificacion(`✅ Ticket cancelado exitosamente`);
            // Recargar tickets desde backend
            await this.cargarTicketsDesdeBackend();
            // Cerrar modal
            this.cerrarModalCancelacion();
          } else {
            const mensaje = response.data.mensaje || 'Error al cancelar el ticket';
            this.mostrarNotificacion(`❌ ${mensaje}`);
          }
        } catch (error) {
          console.error('❌ Error al cancelar ticket:', error);
          this.mostrarNotificacion(`❌ Error al cancelar el ticket`);
          this.$store.dispatch('security/revisaError', error);
        }
      }
    },
    
    cancelarCancelacion() {
      // Revertir el estado del ticket
      if (this.ticketToCancel) {
        this.ticketToCancel.estado = 'pendiente'; // Volver al estado anterior
      }
      this.cerrarModalCancelacion();
    },
    
    cerrarModalCancelacion() {
      this.showCancelModal = false;
      this.ticketToCancel = null;
      this.cancelData.motivo = '';
    },
    
    eliminarTicket(ticketId) {
      if (confirm('¿Estás seguro de que quieres eliminar este ticket?')) {
        this.tickets = this.tickets.filter(t => t.id !== ticketId);
      }
    },
    ///////////////////////////////
    async abrirDetalle(ticket) {
      // Cargar detalle completo desde el backend
      try {
        await this.cargarDetalleTicket(ticket.id);
        this.showTicketDetail = true;
      } catch (error) {
        console.error('Error al abrir detalle:', error);
        this.mostrarNotificacion('❌ Error al cargar el detalle del ticket');
      }
    },
    async cerrarDetalle() {
      const recargar = this.ticketDetalle?.id || null;
      this.ticketDetalle = null;
      this.showTicketDetail = false;
      if (recargar) {
        try {
          await this.cargarTicketsDesdeBackend();
        } catch (error) {
          console.error('❌ Error al recargar tickets después de cerrar detalle:', error);
          this.$store.dispatch('security/revisaError', error);
        }
      }
    },
    
    // Función para reporte normal (usuarios y admins)
    async descargarTicketNormal() {
      if (!this.ticketDetalle) {
        return;
      }

      // bloqueamos la petición si el ticket no está resuelto
      if (!this.ticketDetalle.esResuelto) {
        console.warn('Intento de descarga en ticket no resuelto');
        this.mostrarNotificacion('⚠️ El ticket no está resuelto, no se puede descargar aún');
        return;
      }

      const fechaDescarga = new Date().toISOString().split('T')[0];
      await this.descargarTicketDesdeBackend({
        url: '/mantenimiento/tickets/generarReporteNormal',
        params: { id: this.ticketDetalle.id },
        nombrePredeterminado: `ticket_${this.ticketDetalle.id}_${fechaDescarga}.pdf`,
        mensajeExito: '📄 Ticket descargado en formato PDF correctamente'
      });
    },

    // Función para reporte completo (solo administradores)
    async descargarTicketCompleto() {
      if (!this.ticketDetalle) {
        return;
      }

      const fechaDescarga = new Date().toISOString().split('T')[0];
      await this.descargarTicketDesdeBackend({
        url: '/mantenimiento/tickets/generarReporteCompleto',
        params: { id: this.ticketDetalle.id },
        nombrePredeterminado: `ticket_completo_${this.ticketDetalle.id}_${fechaDescarga}.pdf`,
        mensajeExito: '📋 Reporte completo descargado exitosamente'
      });
    },
    async descargarTicketDesdeBackend({
      url,
      params = {},
      nombrePredeterminado = 'reporte.pdf',
      mensajeExito = ''
    }) {
      if (!this.ticketDetalle) {
        return;
      }

      try {
        const response = await this.$http({
          url,
          method: 'GET',
          params,
          responseType: 'arraybuffer',
          headers: {
            Accept: 'application/pdf'
          }
        });

        const contentType = response.headers['content-type'] || response.headers['Content-Type'] || '';
        if (contentType.includes('application/json')) {
          // el servidor devolvió JSON en lugar de PDF, interpretar como error
          try {
            const text = new TextDecoder('utf-8').decode(response.data);
            const obj = JSON.parse(text);
            if (obj && obj.mensaje) {
              this.mostrarNotificacion(`⚠️ ${obj.mensaje}`);
            } else {
              this.mostrarNotificacion('❌ Error al descargar el PDF del ticket');
            }
          } catch (parseErr) {
            console.error('Error parseando JSON de respuesta PDF:', parseErr);
            this.mostrarNotificacion('❌ Error al descargar el PDF del ticket');
          }
          return;
        }

        this.descargarBlobComoArchivo(response.data, response.headers, nombrePredeterminado);
        if (mensajeExito) {
          this.mostrarNotificacion(mensajeExito);
        }
      } catch (error) {
        console.error('❌ Error al descargar el PDF del ticket:', error);
        const msg = error.response?.data?.mensaje || '❌ Error al descargar el PDF del ticket';
        this.mostrarNotificacion(msg);
        this.$store.dispatch('security/revisaError', error);
      }
    },

    descargarBlobComoArchivo(data, headers = {}, nombrePredeterminado = 'reporte.pdf') {
      if (!data) {
        return;
      }

      const contentType = headers['content-type'] || headers['Content-Type'] || 'application/pdf';
      let nombreArchivo = nombrePredeterminado;

      const contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];
      if (contentDisposition) {
        const filenameMatch = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(contentDisposition);
        if (filenameMatch) {
          try {
            nombreArchivo = decodeURIComponent(filenameMatch[1] || filenameMatch[2] || nombrePredeterminado);
      } catch (error) {
            nombreArchivo = filenameMatch[1] || filenameMatch[2] || nombrePredeterminado;
          }
        }
      }

      const blob = new Blob([data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombreArchivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    
    guardarSolucionTecnico() {
      if (!this.ticketDetalle) return;
      
      // Actualizar la fecha de actualización
      this.ticketDetalle.fechaActualizacionSolucion = new Date().toISOString();
      
      // Encontrar el ticket en la lista y actualizarlo
      const ticketIndex = this.tickets.findIndex(t => t.id === this.ticketDetalle.id);
      if (ticketIndex !== -1) {
        // Actualizar el ticket en la lista
        this.tickets[ticketIndex] = { ...this.ticketDetalle };
      }
      
      // Mostrar notificación de éxito
      this.mostrarNotificacion('✅ Solución del técnico guardada exitosamente');
      
      // solucion del tecnico
      console.log('Solución del técnico guardada:', {
        ticketId: this.ticketDetalle.id,
        //problemaIdentificado: this.ticketDetalle.problemaIdentificado,
        //solucionAplicada: this.ticketDetalle.solucionAplicada,
        //herramientasUtilizadas: this.ticketDetalle.herramientasUtilizadas,
        //tiempoRealSolucion: this.ticketDetalle.tiempoRealSolucion,
        observacionesTecnico: this.ticketDetalle.observacionesTecnico,
        fechaActualizacionSolucion: this.ticketDetalle.fechaActualizacionSolucion
      });
    },
    
    // Agregar nueva solución al feed
    async agregarSolucion() {
      if (!this.ticketDetalle || !this.nuevaSolucion.solucion.trim()) return;
      if (this.guardandoSolucion) return;

      // Validar que no se puedan agregar soluciones en estado pendiente
      if (this.ticketDetalle.estado === 'pendiente') {
        alert('❌ No se pueden agregar soluciones a tickets pendientes. Cambia el estado a "En Proceso" primero.');
        return;
      }
      
      // Validar que no se pueda agregar seguimiento si el ticket no está resuelto
      if (this.nuevaSolucion.tipo === 'seguimiento' && this.ticketDetalle.estado !== 'resuelto') {
        alert('❌ Solo se pueden agregar seguimientos a tickets resueltos.');
        return;
      }
      
      // Validar que no se pueda agregar solución inicial si el ticket está resuelto
      if (this.nuevaSolucion.tipo === 'solucion_inicial' && this.ticketDetalle.estado === 'resuelto') {
        alert('❌ No se pueden agregar soluciones a tickets resueltos. Solo se permite seguimiento.');
        return;
      }
      
      this.guardandoSolucion = true;
      try {
        // Determinar el endpoint según el tipo de solución
        const url = this.nuevaSolucion.tipo === 'seguimiento'
          ? '/mantenimiento/tickets/agregarSolucionSeguimiento'
          : '/mantenimiento/tickets/agregarSolucionTecnico';
        
        const response = await this.$http({
          url: url,
          method: 'POST',
          data: {
            ticketId: this.ticketDetalle.id,
            solucion: this.nuevaSolucion.solucion.trim(),
          }
        });

        const successRaw = response?.data?.success;
        const estadoRaw = response?.data?.estado;
        const ok = successRaw === true || estadoRaw === true || successRaw === 'true' || estadoRaw === 'true';

        if (!ok) {
          const msg = response?.data?.mensaje || '❌ No se pudo agregar la solución';
          this.mostrarNotificacion(msg);
          return;
        }

        const tipoSolucion = this.nuevaSolucion.tipo;
        const imagenesPendientes = Array.isArray(this.nuevaSolucion.imagenes)
          ? [...this.nuevaSolucion.imagenes]
          : [];

        // Limpiar texto de inmediato (aunque el upload de imágenes falle o tarde)
        // para evitar que el usuario piense que no se guardó.
        this.limpiarFormularioSolucion();

        // Si hay imágenes, subirlas por separado con el solucionId retornado
        if (imagenesPendientes.length > 0) {
          const solucionId = response?.data?.solucionId || response?.data?.seguimientoId;
          if (solucionId) {
            try {
              await this.subirImagenesSolucion(this.ticketDetalle.id, solucionId, tipoSolucion, imagenesPendientes);
            } catch (uploadErr) {
              console.error('⚠️ Error al subir imágenes (la solución sí se guardó):', uploadErr);
              this.mostrarNotificacion('⚠️ La solución se guardó, pero hubo un error al subir imágenes');
            }
          } else {
            console.warn('No se recibió solucionId/seguimientoId del backend, las imágenes no se subirán');
          }
        }

        this.mostrarNotificacion('💬 Solución agregada exitosamente');

        // Recargar el detalle del ticket desde el backend
        await this.cargarDetalleTicket(this.ticketDetalle.id);
      } catch (error) {
        console.error('❌ Error al agregar solución:', error);
        const msg = error.response?.data?.mensaje || '❌ Error al agregar la solución';
        this.mostrarNotificacion(msg);
        this.$store.dispatch('security/revisaError', error);
      } finally {
        this.guardandoSolucion = false;
      }
    },
    
    // Cargar detalle del ticket desde backend
    async cargarDetalleTicket(ticketId) {
      try {
        const response = await this.$http({
          url: '/mantenimiento/tickets/obtenerTicket',
          method: 'GET',
          params: { id: ticketId }
        });
        
        if (response.data) {
          const detalle = response.data;
          
          // Log detallado para depuración de campos
          console.log('🔍 Campos recibidos del backend:', {
            todosLosCampos: Object.keys(detalle),
            camposConImagen: Object.keys(detalle).filter(key => {
              const value = detalle[key];
              return value && (
                key.toLowerCase().includes('imagen') ||
                key.toLowerCase().includes('foto') ||
                key.toLowerCase().includes('archivo') ||
                key.toLowerCase().includes('adjunto') ||
                key.toLowerCase().includes('evidencia') ||
                (Array.isArray(value) && value.length > 0)
              );
            }),
            imagenesTecnico: detalle.imagenesTecnico,
            imagenesSeguimiento: detalle.imagenesSeguimiento,
            imagenes: detalle.imagenes,
            archivos: detalle.archivos,
            adjuntos: detalle.adjuntos,
            soluciones: detalle.soluciones,
            eventos: detalle.eventos,
            // Campos adicionales que podrían contener imágenes
            imagenesSeguimientoTecnico: detalle.imagenesSeguimientoTecnico,
            seguimientoImagenes: detalle.seguimientoImagenes,
            imagenesDeSeguimiento: detalle.imagenesDeSeguimiento,
            fotosSeguimiento: detalle.fotosSeguimiento,
            fotos: detalle.fotos,
            adjuntosSeguimiento: detalle.adjuntosSeguimiento,
            evidencias: detalle.evidencias,
            evidenciasSeguimiento: detalle.evidenciasSeguimiento,
            archivosSeguimiento: detalle.archivosSeguimiento
          });
          
          const fechaCreacionDate = this.parseFechaFlexible(detalle.fechaCreacion);
          const fechaAsignacionDate = this.parseFechaFlexible(detalle.fechaAsignacion);
          const fechaCierreDate = this.parseFechaFlexible(detalle.fechaCierre);

          // Procesar imágenes del backend - intentar múltiples campos
          const imagenesTecnicoRaw = detalle.imagenesTecnico || 
                                    detalle.imagenesTecnicoSolucion || 
                                    detalle.imagenesSolucion || 
                                    detalle.imagenes || [];
          
          let imagenesSeguimientoRaw = detalle.imagenesSeguimiento || 
                                        detalle.imagenesSeguimientoSolucion || 
                                        detalle.imagenesSeguimientoTecnico || 
                                        detalle.seguimientoImagenes ||
                                        detalle.imagenesDeSeguimiento ||
                                        detalle.fotosSeguimiento ||
                                        detalle.fotos ||
                                        detalle.adjuntosSeguimiento ||
                                        detalle.evidencias ||
                                        detalle.evidenciasSeguimiento ||
                                        detalle.archivosSeguimiento ||
                                        detalle.archivosAdjuntos ||
                                        [];
          
          const imagenesTecnicoProcesadas = this.transformarImagenesSolucion(imagenesTecnicoRaw);
          const imagenesSeguimientoProcesadas = this.transformarImagenesSolucion(imagenesSeguimientoRaw);
          
          // Log para depuración
          console.log('📸 Imágenes recibidas del backend:', {
            imagenesTecnico: imagenesTecnicoRaw,
            imagenesSeguimiento: imagenesSeguimientoRaw,
            imagenesTecnicoProcesadas: imagenesTecnicoProcesadas,
            imagenesSeguimientoProcesadas: imagenesSeguimientoProcesadas,
            // Analizar si hay imágenes de seguimiento mezcladas en imagenesTecnico
            analisisImagenesTecnico: imagenesTecnicoRaw.map((img, index) => ({
              index,
              nombre: img.nombre || img.filename || 'Sin nombre',
              url: img.url,
              subidaPor: img.subidaPor,
              fecha: img.fecha,
              posibleSeguimiento: img.nombre && (
                img.nombre.toLowerCase().includes('seguimiento') ||
                img.nombre.toLowerCase().includes('follow') ||
                img.nombre.toLowerCase().includes('actualizacion')
              )
            }))
          });

          this.ticketDetalle = {
            ...detalle,
            solicitudArea: detalle.solicitudArea?.toLowerCase(),
            prioridad: this.capitalizarPrioridad(detalle.prioridad),
            estado: detalle.estado?.toLowerCase(),
            // preferir mostrar el equipo si existe
            tecnico: detalle.tecnicosEquipo && detalle.tecnicosEquipo.length ? detalle.tecnicosEquipo.map(t=>t.nombre).join(', ') : (detalle.tecnicoAsignado?.nombre || detalle.tecnico || 'Sin asignar'),
            tecnicoAsignadoId: (detalle.tecnicoAsignado?.id ?? null),
            tecnicosEquipo: detalle.tecnicosEquipo || [],
            equipoNombres: detalle.tecnicosEquipo && detalle.tecnicosEquipo.length ? detalle.tecnicosEquipo.map(t=>t.nombre).join(', ') : null,
            fechaCreacion: fechaCreacionDate ? fechaCreacionDate.toISOString() : detalle.fechaCreacion,
            fechaAsignacion: fechaAsignacionDate ? fechaAsignacionDate.toISOString() : detalle.fechaAsignacion,
            fechaCierre: fechaCierreDate ? fechaCierreDate.toISOString() : null,
            fechaCreacionTexto: detalle.fechaCreacion,
            fechaAsignacionTexto: detalle.fechaAsignacion,
            fechaCierreTexto: detalle.fechaCierre,
            // Guardar imágenes procesadas para usar en el historial
            imagenesTecnico: imagenesTecnicoProcesadas,
            imagenesSeguimiento: imagenesSeguimientoProcesadas,
          };
          
          // Verificar y corregir automáticamente si es un garrafón con prioridad incorrecta
          await this.corregirPrioridadGarrafonAutomatico(this.ticketDetalle);
          
          await this.cargarHistorialSoluciones(ticketId);
        }
      } catch (error) {
        console.error('❌ Error al cargar detalle del ticket:', error);
        this.$store.dispatch('security/revisaError', error);
      }
    },
    async cargarHistorialSoluciones(ticketId) {
      this.historialSoluciones = [];
      try {
        const response = await this.$http({
          url: `/mantenimiento/tickets/obtenerHistorial/${ticketId}`,
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });
        const eventos = response.data?.root || [];
        
        // Obtener imágenes del ticket detalle como respaldo
        const imagenesTecnicoDelTicket = this.ticketDetalle?.imagenesTecnico || [];
        const imagenesSeguimientoDelTicket = this.ticketDetalle?.imagenesSeguimiento || [];
        
        // Log para depuración
        console.log('📋 Historial recibido:', {
          eventosCount: eventos.length,
          imagenesTecnicoDelTicket: imagenesTecnicoDelTicket.length,
          imagenesSeguimientoDelTicket: imagenesSeguimientoDelTicket.length,
          eventos: eventos.map(e => ({
            tipo: e.tipo,
            tieneImagenes: !!e.imagenes,
            imagenesCount: e.imagenes ? (Array.isArray(e.imagenes) ? e.imagenes.length : 1) : 0
          }))
        });
        
        const soluciones = eventos
          .filter(evento => evento && (evento.tipo === 'SOLUCION' || evento.tipo === 'SEGUIMIENTO'))
          .map((evento, index) => {
            // Log detallado para depurar imágenes en eventos
            console.log(`🔍 Evento ${evento.tipo}:`, {
              id: evento.id,
              todosLosCampos: Object.keys(evento),
              eventoCompleto: evento, // Agregar el evento completo para inspección
              imagenes: evento.imagenes,
              imagenesSeguimiento: evento.imagenesSeguimiento,
              archivos: evento.archivos,
              adjuntos: evento.adjuntos,
              archivosAdjuntos: evento.archivosAdjuntos,
              archivosSeguimiento: evento.archivosSeguimiento,
              imagenesArray: Array.isArray(evento.imagenes) ? evento.imagenes : 'No es array'
            });
            
            const fechaParsed = this.parseFechaFlexible(evento.fecha) || new Date();
            const tipo = evento.tipo === 'SOLUCION' ? 'solucion_inicial' : 'seguimiento';
            const tiempoMin = evento.tiempoMinutos ?? evento.tiempoDedicadoMinutos;
            let tiempoTexto = '';
            if (Number.isFinite(Number(tiempoMin)) && Number(tiempoMin) > 0) {
              const minutos = Number(tiempoMin);
              if (minutos >= 60) {
                tiempoTexto = `${(minutos / 60).toFixed(1)} horas dedicadas`;
              } else {
                tiempoTexto = `${minutos} minutos dedicados`;
              }
            }
            const accionLabel = evento.accion && evento.accion !== 'SOLUCION_TECNICA'
              ? evento.accion.replace(/_/g, ' ')
              : '';
            
            // Procesar imágenes: intentar múltiples campos para eventos de seguimiento
            let imagenesDelEvento = [];
            
            if (tipo === 'seguimiento') {
              // Para eventos de seguimiento, intentar múltiples campos
              const imagenesRaw = evento.imagenesSeguimiento || 
                                evento.imagenes || 
                                evento.archivosSeguimiento || 
                                evento.archivosAdjuntos || 
                                evento.adjuntos || 
                                evento.archivos ||
                                evento.imagenesSeguimientoTecnico ||
                                evento.seguimientoImagenes ||
                                evento.imagenesDeSeguimiento ||
                                evento.fotosSeguimiento ||
                                evento.fotos ||
                                evento.adjuntosSeguimiento ||
                                evento.evidencias ||
                                evento.evidenciasSeguimiento ||
                                [];
              
              console.log(`📸 Imágenes raw para seguimiento:`, imagenesRaw);
              imagenesDelEvento = this.transformarImagenesSolucion(imagenesRaw);
            } else {
              // Para eventos de solución inicial
              const imagenesRaw = evento.imagenes || 
                                evento.imagenesTecnico || 
                                evento.archivos || [];
              
              console.log(`📸 Imágenes raw para solución:`, imagenesRaw);
              imagenesDelEvento = this.transformarImagenesSolucion(imagenesRaw);
            }
            
            let imagenesCombinadas = [];
            
            // Prioridad: usar imágenes del evento si existen
            if (imagenesDelEvento && imagenesDelEvento.length > 0) {
              imagenesCombinadas = imagenesDelEvento;
              console.log(`✅ Imágenes encontradas en evento ${tipo}:`, imagenesCombinadas.length);
            } else {
              // Si no hay imágenes en el evento, usar las del ticket detalle según el tipo
              if (tipo === 'solucion_inicial' && imagenesTecnicoDelTicket.length > 0) {
                imagenesCombinadas = imagenesTecnicoDelTicket;
                console.log(`🔄 Usando imágenes técnicas del ticket detalle:`, imagenesCombinadas.length);
              } else if (tipo === 'seguimiento' && imagenesSeguimientoDelTicket.length > 0) {
                imagenesCombinadas = imagenesSeguimientoDelTicket;
                console.log(`🔄 Usando imágenes de seguimiento del ticket detalle:`, imagenesCombinadas.length);
              } else {
                console.log(`⚠️ No se encontraron imágenes para evento ${tipo}`);
              }
            }
            
            return {
              id: evento.id || `${evento.tipo}-${fechaParsed.getTime()}-${index}`,
              tipo,
              fecha: fechaParsed.toISOString(),
              tecnico: evento.usuario || 'Usuario desconocido',
              solucion: evento.descripcion || evento.solucionTecnico || evento.solucionSeguimiento || 'Sin descripción',
              accion: evento.accion || null,
              accionLabel,
              exitosa: typeof evento.exitosa !== 'undefined' ? evento.exitosa : null,
              tiempoMinutos: tiempoMin || null,
              tiempoTexto: tiempoTexto || '',
              imagenes: imagenesCombinadas
            };
          })
          .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

        // Si no hay eventos en el historial pero hay imágenes en el ticket detalle,
        // crear entradas para mostrar las imágenes (incluso si no hay texto de solución)
        if (soluciones.length === 0) {
          // Si hay imágenes técnicas, crear entrada (con o sin texto de solución)
          if (this.ticketDetalle?.imagenesTecnico && this.ticketDetalle.imagenesTecnico.length > 0) {
            soluciones.push({
              id: `solucion-tecnico-${ticketId}`,
              tipo: 'solucion_inicial',
              fecha: this.ticketDetalle.fechaAsignacion || this.ticketDetalle.fechaCreacion || new Date().toISOString(),
              tecnico: this.ticketDetalle.tecnico || 'Usuario desconocido',
              solucion: this.ticketDetalle.solucionTecnico || 'Solución técnica con imágenes',
              accion: null,
              accionLabel: '',
              exitosa: null,
              tiempoMinutos: null,
              tiempoTexto: '',
              imagenes: this.ticketDetalle.imagenesTecnico
            });
          }
          
          // Si hay imágenes de seguimiento, crear entrada (con o sin texto de solución)
          if (this.ticketDetalle?.imagenesSeguimiento && this.ticketDetalle.imagenesSeguimiento.length > 0) {
            soluciones.push({
              id: `solucion-seguimiento-${ticketId}`,
              tipo: 'seguimiento',
              fecha: this.ticketDetalle.fechaCierre || this.ticketDetalle.fechaAsignacion || new Date().toISOString(),
              tecnico: this.ticketDetalle.tecnico || 'Usuario desconocido',
              solucion: this.ticketDetalle.solucionSeguimiento || 'Seguimiento con imágenes',
              accion: null,
              accionLabel: '',
              exitosa: null,
              tiempoMinutos: null,
              tiempoTexto: '',
              imagenes: this.ticketDetalle.imagenesSeguimiento
            });
          }
        }

        this.historialSoluciones = soluciones;
        if (this.ticketDetalle) {
          this.ticketDetalle.solucionesTecnico = soluciones;
        }
        
        // Log final para verificar que las imágenes se asignaron correctamente
        console.log('✅ Soluciones procesadas:', {
          totalSoluciones: soluciones.length,
          solucionesConImagenes: soluciones.filter(s => s.imagenes && s.imagenes.length > 0).length,
          soluciones: soluciones.map(s => ({
            id: s.id,
            tipo: s.tipo,
            imagenesCount: s.imagenes ? s.imagenes.length : 0,
            imagenes: s.imagenes ? s.imagenes.map(img => ({ nombre: img.nombre, url: img.url?.substring(0, 50) + '...' })) : []
          }))
        });
      } catch (error) {
        console.warn('⚠️ No se pudo cargar el historial de soluciones:', error);
        // Si falla el historial pero tenemos imágenes en el ticket detalle, crear entradas básicas
        if (this.ticketDetalle) {
          const solucionesFallback = [];
          
          // Crear entrada si hay imágenes técnicas (con o sin texto)
          if (this.ticketDetalle.imagenesTecnico && this.ticketDetalle.imagenesTecnico.length > 0) {
            solucionesFallback.push({
              id: `solucion-tecnico-${ticketId}`,
              tipo: 'solucion_inicial',
              fecha: this.ticketDetalle.fechaAsignacion || this.ticketDetalle.fechaCreacion || new Date().toISOString(),
              tecnico: this.ticketDetalle.tecnico || 'Usuario desconocido',
              solucion: this.ticketDetalle.solucionTecnico || 'Solución técnica con imágenes',
              accion: null,
              accionLabel: '',
              exitosa: null,
              tiempoMinutos: null,
              tiempoTexto: '',
              imagenes: this.ticketDetalle.imagenesTecnico
            });
          }
          
          // Crear entrada si hay imágenes de seguimiento (con o sin texto)
          if (this.ticketDetalle.imagenesSeguimiento && this.ticketDetalle.imagenesSeguimiento.length > 0) {
            solucionesFallback.push({
              id: `solucion-seguimiento-${ticketId}`,
              tipo: 'seguimiento',
              fecha: this.ticketDetalle.fechaCierre || this.ticketDetalle.fechaAsignacion || new Date().toISOString(),
              tecnico: this.ticketDetalle.tecnico || 'Usuario desconocido',
              solucion: this.ticketDetalle.solucionSeguimiento || 'Seguimiento con imágenes',
              accion: null,
              accionLabel: '',
              exitosa: null,
              tiempoMinutos: null,
              tiempoTexto: '',
              imagenes: this.ticketDetalle.imagenesSeguimiento
            });
          }
          
          if (solucionesFallback.length > 0) {
            console.log('✅ Creando soluciones de respaldo con imágenes:', solucionesFallback);
            this.historialSoluciones = solucionesFallback;
            this.ticketDetalle.solucionesTecnico = solucionesFallback;
          }
        }
      }
    },
    esUsuarioEnEquipo(ticket) {
      if (!ticket) return false;
      const usuarioId = this.$store.state.security.user?.id;
      if (!usuarioId) return false;
      try {
        return (ticket.tecnicosEquipo || []).some(t => t && (t.id === usuarioId || String(t.id) === String(usuarioId)));
      } catch (e) {
        return false;
      }
    },
    
    // Subir imágenes de la solución
    async subirImagenesSolucion(ticketId,solucionId, tipoSolucion, listaImagenes = null) {
      const endpoint = tipoSolucion === 'seguimiento'
        ? '/mantenimiento/tickets/subirImagenSolucionSeguimiento'
        : '/mantenimiento/tickets/subirImagenSolucionTecnico';
      
      const imagenesParaSubir = Array.isArray(listaImagenes) ? listaImagenes : this.nuevaSolucion.imagenes;
      for (const imagen of (imagenesParaSubir || [])) {
        const archivo = imagen.archivo;
        if (!archivo || !(archivo instanceof File)) {
          console.warn('Imagen sin archivo File, se omite subida:', imagen.nombre);
          continue;
        }
        try {
          const formData = new FormData();
          formData.append('imagen', archivo);
          formData.append('ticketId', String(ticketId));
          if (solucionId) formData.append('solucionId', String(solucionId));
          // No fijar Content-Type: el navegador debe enviar multipart/form-data con boundary
          await this.$http({
            url: endpoint,
            method: 'POST',
            data: formData
          });
        } catch (error) {
          console.error('Error al subir imagen:', error);
        }
      }
    },
    
    handleImageError(event, imagen) {
      console.warn('Error al cargar imagen:', imagen.nombre, imagen.url);
      console.warn('Intentando cargar con URL:', imagen.url);
      
      // Marcar la imagen como con error para mostrar placeholder
      this.$set(imagen, 'error', true);
      
      // Intentar diferentes estrategias de recuperación
      const img = event.target;
      
      // Estrategia 1: Intentar con HTTP si HTTPS falló
      if (imagen.url && imagen.url.startsWith('https://')) {
        const urlHttp = imagen.url.replace('https://', 'http://');
        console.log('Intentando con HTTP:', urlHttp);
        setTimeout(() => {
          img.src = urlHttp;
        }, 1000);
        return;
      }
      
      // Estrategia 2: Si es un nombre de archivo simple, intentar construir URL alternativa
      if (imagen.url && !imagen.url.includes('/') && imagen.url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
        // Intentar sin timestamp
        const urlSinTimestamp = imagen.url.split('?')[0];
        console.log('Intentando sin timestamp:', urlSinTimestamp);
        setTimeout(() => {
          img.src = urlSinTimestamp;
        }, 2000);
        return;
      }
      
      // Estrategia 3: Intentar con diferentes rutas base
      if (imagen.url && imagen.url.includes('/imagenes-tickets/')) {
        const nombreArchivo = imagen.url.split('/').pop();
        const urlsAlternativas = [
          `/imagenes-tickets/${nombreArchivo}`,
          `imagenes-tickets/${nombreArchivo}`,
          `/api/imagenes-tickets/${nombreArchivo}`
        ];
        
        urlsAlternativas.forEach((url, index) => {
          setTimeout(() => {
            console.log(`Intentando URL alternativa ${index + 1}:`, url);
            img.src = url;
          }, (index + 3) * 1000);
        });
      }
    },
    
    handleImageLoad(event, imagen) {
      console.log('✅ Imagen cargada:', imagen.nombre);
      // Marcar la imagen como cargada exitosamente
      this.$set(imagen, 'error', false);
      this.$set(imagen, 'loaded', true);
    },
    
    transformarImagenesSolucion(imagenes) {
      if (!imagenes) {
        return [];
      }
      
      const listaImagenes = Array.isArray(imagenes)
        ? imagenes
        : typeof imagenes === 'object'
          ? Object.values(imagenes)
          : [];
      
      if (!listaImagenes.length) {
        return [];
      }
      
      return listaImagenes
        .map((imagen, index) => {
          if (!imagen) {
            return null;
          }
          
          // Caso 1: Si es un string simple (URL), procesarlo primero
          if (typeof imagen === 'string') {
            const url = this.construirUrlImagen(imagen);
            if (!url) {
              return null;
            }
            const nombre = this.extraerNombreArchivo(imagen) || `Imagen ${index + 1}`;
            return {
              nombre,
              url
            };
          }
          
          // Caso 2: Ya viene formateada con url y nombre
          if (imagen.url && imagen.nombre) {
            return {
              nombre: imagen.nombre,
              url: this.construirUrlImagen(imagen.url)
            };
          }
          
          // Obtener nombre amigable
          let nombre = imagen.nombre
            || imagen.nombreOriginal
            || imagen.filename
            || imagen.nombreArchivo
            || `Imagen ${index + 1}`;
          
          let url = null;
          
          // 1. Si trae un campo url/route
          const posibleRuta = imagen.url || imagen.enlace || imagen.link || imagen.ruta || imagen.path;
          if (posibleRuta) {
            url = this.construirUrlImagen(posibleRuta);
            if (!nombre || nombre === `Imagen ${index + 1}`) {
              nombre = this.extraerNombreArchivo(posibleRuta) || nombre;
            }
          }
          
          // 2. Si trae base64 embebido
          if (!url) {
            const posibleBase64 = imagen.base64 || imagen.contenido || imagen.data || imagen.contenidoBase64;
            if (posibleBase64) {
              url = posibleBase64.startsWith('data:')
                ? posibleBase64
                : `data:${imagen.tipoContenido || imagen.contentType || 'image/jpeg'};base64,${posibleBase64}`;
            }
          }
          
          // 3. Si trae un id, construir endpoint estándar
          if (!url) {
            const posibleId = imagen.id || imagen.imagenId || imagen.archivoId;
            if (posibleId) {
              const endpoint = imagen.endpointDescarga || `/mantenimiento/tickets/imagenSolucion/${posibleId}`;
              url = this.construirUrlImagen(endpoint);
            }
          }
          
          if (!url) {
            console.warn('⚠️ No se pudo procesar imagen:', imagen);
            return null;
          }
          
          if (!nombre || nombre === `Imagen ${index + 1}`) {
            nombre = this.extraerNombreArchivo(url) || `Imagen ${index + 1}`;
          }
          
          return {
            nombre,
            url
          };
        })
        .filter(Boolean);
    },
    
    construirUrlImagen(ruta) {
      if (!ruta) {
        return null;
      }
      
      // Si ya es data URL, blob o http(s), regresarlo tal cual
      if (/^(data:|blob:|https?:\/\/)/i.test(ruta)) {
        return ruta;
      }
      
      // Las imágenes están en /imagenes-tickets/ (raíz del servidor, NO bajo /api)
      // Usar $baseUrl (app root) en lugar de baseURL (api) para que carguen correctamente
      const rutaNormalizada = ruta.startsWith('/') ? ruta : `/${ruta}`;
      const baseImagenes = (this.$baseUrl || '').replace(/\/$/, '');
      const baseAPI = (this.$http?.defaults?.baseURL || '').replace(/\/$/, '');
      
      // Convertir HTTPS a HTTP para evitar problemas de CORS
      const rutaSinHttps = rutaNormalizada.replace(/^https:\/\//i, 'http://');
      
      // Si la ruta es /imagenes-tickets/* usar base del app (sin /api)
      const base = rutaNormalizada.startsWith('/imagenes-tickets/') && baseImagenes
        ? baseImagenes
        : baseAPI;
      
      const urlFinal = base ? `${base}${rutaSinHttps}` : rutaSinHttps;
      
      // Agregar parámetro de cache para evitar bloqueos ORB
      const urlConTimestamp = `${urlFinal}?t=${Date.now()}`;
      
      return urlConTimestamp;
    },
    
    extraerNombreArchivo(ruta) {
      if (!ruta || typeof ruta !== 'string') {
        return '';
      }
      const sinParametros = ruta.split('?')[0];
      const partes = sinParametros.split('/');
      return partes.pop() || '';
    },
    
    // Limpiar formulario de nueva solución
            limpiarFormularioSolucion() {
              this.nuevaSolucion = {
                solucion: '',
                tipo: 'solucion_inicial',
                imagenes: []
              };
            },
    
    // Obtener texto del tipo de solución
    getTipoSolucionText(tipo) {
      const tipos = {
        'solucion_inicial': 'Solución',
        'seguimiento': 'Seguimiento'
      };
      return tipos[tipo] || tipo;
    },
    
    // Formatear fecha y hora para el feed
            formatearFechaHora(fecha) {
              const fechaObj = new Date(fecha);
              return fechaObj.toLocaleString('es-ES', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              });
            },

            // Métodos para manejar imágenes en soluciones
            handleSolutionImageUpload(event) {
              const files = Array.from(event.target.files);
              
              files.forEach(file => {
                if (file.type.startsWith('image/')) {
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    this.nuevaSolucion.imagenes.push({
                      nombre: file.name,
                      url: e.target.result,
                      archivo: file
                    });
                  };
                  reader.readAsDataURL(file);
                }
              });
            },

            removeSolutionImage(index) {
              this.nuevaSolucion.imagenes.splice(index, 1);
            },

            openImageModal(imagen) {
              this.imagenModal = {
                visible: true,
                imagen: imagen
              };
            },

            closeImageModal() {
              this.imagenModal = {
                visible: false,
                imagen: { nombre: '', url: '' }
              };
            },
    
    // Métodos para dictamen técnico
    abrirModalDictamen() {
      this.showDictamenModal = true;
    },
    
    cerrarModalDictamen() {
      this.showDictamenModal = false;
      // Limpiar formulario de dictamen
      this.dictamenTecnico = {
        equipo: '',
        marca: '',
        modelo: '',
        numeroSerie: '',
        descripcion: '',
        recomendaciones: '',
        conclusion: ''
      };
    },
    
    async generarDictamenTecnico() {
      // Validar campos requeridos
      if (!this.dictamenTecnico.equipo.trim() ||
          !this.dictamenTecnico.marca.trim() ||
          !this.dictamenTecnico.modelo.trim() ||
          !this.dictamenTecnico.numeroSerie.trim() ||
          !this.dictamenTecnico.descripcion.trim() ||
          !this.dictamenTecnico.recomendaciones.trim() ||
          !this.dictamenTecnico.conclusion.trim()) {
        alert('❌ Por favor completa todos los campos del dictamen');
        return;
      }
      
      this.guardandoDictamen = true;
      
      try {
        // Preparar datos del dictamen
        const dictamenData = {
          ticketId: this.ticketDetalle?.id,
          equipo: this.dictamenTecnico.equipo.trim(),
          marca: this.dictamenTecnico.marca.trim(),
          modelo: this.dictamenTecnico.modelo.trim(),
          numeroSerie: this.dictamenTecnico.numeroSerie.trim(),
          numeroInventario: this.dictamenTecnico.numeroInventario.trim(),
          area: this.ticketDetalle?.solicitudArea || 'TECNOLOGIAS',
          descripcion: this.dictamenTecnico.descripcion.trim(),
          recomendaciones: this.dictamenTecnico.recomendaciones.trim(),
          conclusion: this.dictamenTecnico.conclusion.trim(),
          fechaGeneracion: new Date().toISOString(),
          tecnico: this.userName || 'Técnico'
        };
        
        console.log('📋 Generando dictamen técnico:', dictamenData);
        
        // Aquí puedes agregar la llamada al backend cuando esté listo
        // await this.$http({
        //   url: '/mantenimiento/tickets/generarDictamen',
        //   method: 'POST',
        //   data: dictamenData
        // });
        
        // Por ahora, simular éxito y mostrar notificación
        this.mostrarNotificacion('✅ Dictamen técnico generado exitosamente');
        
        // Cerrar modal y limpiar
        this.cerrarModalDictamen();
        
      } catch (error) {
        console.error('❌ Error al generar dictamen:', error);
        const msg = error.response?.data?.mensaje || '❌ Error al generar el dictamen técnico';
        this.mostrarNotificacion(msg);
        this.$store.dispatch('security/revisaError', error);
      } finally {
        this.guardandoDictamen = false;
      }
    },
    
    abrirFormulario() {
      this.showFormModal = true;
      // Resetear pestaña biomédica al abrir formulario
      this.biomedicaTab = 'solicitud';
    },
    abrirModalTipoTicket() {
      this.showTipoTicketModal = true;
    },
    cerrarModalTipoTicket() {
      this.showTipoTicketModal = false;
    },
    seleccionarTipoTicket(tipo) {
      this.tipoFormulario = tipo;
      
      // Si es gestión de información, establecer automáticamente el área de Tecnologías
      if (tipo === 'gestion_informacion') {
        this.form.solicitudArea = 'TECNOLOGIAS';
      } else {
        // Para crear ticket, resetear el área para que el usuario la seleccione
        this.form.solicitudArea = '';
      }
      
      // Cerrar modal de tipo y abrir el formulario
      this.showTipoTicketModal = false;
      this.abrirFormulario();
    },
    continuarConTipoTicket() {
      // Usar el tipo ya seleccionado en el dropdown (tipoFormulario)
      const tipo = this.tipoFormulario;
      
      // Si es gestión de información, establecer automáticamente el área de Tecnologías
      if (tipo === 'gestion_informacion') {
        this.form.solicitudArea = 'TECNOLOGIAS';
      } else {
        // Para crear ticket, resetear el área para que el usuario la seleccione
        this.form.solicitudArea = '';
      }
      
      // Cerrar modal de tipo y abrir el formulario
      this.showTipoTicketModal = false;
      this.abrirFormulario();
    },
    cerrarFormulario() {
      this.showFormModal = false;
      // Limpiar formulario al cerrar
      this.form = {
        nombre: this.userName || this.form.nombre, // Mantener el nombre del usuario
        titulo: '',
        descripcion: '',
        areaSolicita: '',
        ubicacion: '',
        equipo: '',
        tieneEquipo: false,
        descripcionEquipo: '',
        tieneInsumos: false,
        insumos: '',
        descripcionInsumos: '',
        cantidadInsumos: 1,
        solicitudArea: '',
        serialNumber: '',
        notas: '',
        fechaCreacion: '',
        fechaCierre: '',
      };
    },
    cerrarTicketsCreadosResueltos() {
      this.showTicketsCreadosResueltos = false;
    },
    cerrarTiempoPromedio() {
      this.showTiempoPromedio = false;
    },
    cerrarTicketsPorTecnico() {
      this.showTicketsPorTecnico = false;
    },
    cerrarTicketsPorArea() {
      this.showTicketsPorArea = false;
    },
    cerrarProblemasMasComunes() {
      this.showProblemasMasComunes = false;
    },
    cerrarEstadisticasPreventivas() {
      this.showEstadisticasPreventivas = false;
    },
    limpiarFiltros() {
      this.filtroArea = '';
      this.filtroPrioridad = '';
      this.filtroEstado = 'activos';
      this.filtroGestionInformacion = '';
      this.filtroTurno = '';
    },

    formatoTurno(turno) {
      const formatos = {
        'manana': 'Mañana',
        'tarde': 'Tarde',
        'noche': 'Noche'
      };
      return formatos[turno] || turno;
    },

    // Función para verificar si un usuario puede cancelar un ticket
    puedeCancelarTicket(ticket) {
      if (!ticket) {
        console.log('🔍 puedeCancelarTicket: No hay ticket');
        return false;
      }
      
      // Usar el campo puedeCancelar del backend si está disponible (basado en IDs, más confiable)
      if (ticket.puedeCancelar !== undefined && ticket.puedeCancelar !== null) {
        console.log('🔍 puedeCancelarTicket - usando campo del backend:', ticket.puedeCancelar);
        return ticket.puedeCancelar === true || ticket.puedeCancelar == 'true';
      }
      
      // Fallback: validación manual por nombre (caso el backend no envíe el campo)
      const estado = (ticket.estado || '').toString().toLowerCase();
      console.log('🔍 puedeCancelarTicket - estado:', estado);
      if (!(estado === 'pendiente')) {
        console.log('🔍 puedeCancelarTicket: Estado no es pendiente');
        return false;
      }

      const creadorId = ticket.usuarioCreador?.id || ticket.usuarioCreadorId;
      const usuarioActualId = this.$store.state.security.user?.id;
      
      console.log('🔍 puedeCancelarTicket - creadorId:', creadorId);
      console.log('🔍 puedeCancelarTicket - usuarioActualId:', usuarioActualId);
      console.log('🔍 puedeCancelarTicket - ¿Coinciden IDs?:', creadorId == usuarioActualId);

      return creadorId && usuarioActualId && creadorId == usuarioActualId;
    },
    
    // Función para abrir el modal de cancelación
    abrirModalCancelacion(ticket) {
      console.log('🔍 abrirModalCancelacion llamado con ticket:', ticket);
      console.log('🔍 Estado actual showCancelModal:', this.showCancelModal);
      this.ticketToCancel = ticket;
      this.cancelData.motivo = '';
      this.showCancelModal = true;
      console.log('🔍 Nuevo estado showCancelModal:', this.showCancelModal);
    },
    getEstadoClass(estado) {
      switch (estado) {
        case 'pendiente':
          return 'badge-pending';
        case 'en_proceso':
          return 'badge-in-progress';
        case 'resuelto':
          return 'badge-resolved';
        case 'reasignado':
          return 'badge-reassigned';
        case 'reasignar':
          return 'badge-reassign';
        case 'cancelado':
          return 'badge-cancelled';
        case 'cancelar':
          return 'badge-cancel';
        default:
          return '';
      }
    },
    getEstadoText(estado, esGestionInformacion = false) {
      // Normalizar estado a minúsculas para comparación
      const estadoNormalizado = (estado || '').toString().toLowerCase();
      
      // Si es gestión de información, usar estados personalizados
      if (esGestionInformacion) {
        switch (estadoNormalizado) {
          case 'pendiente':
            return 'En Revisión';
          case 'en_proceso':
            return 'En Revisión';
          case 'resuelto':
            return 'Aprobado';
          case 'cancelado':
            return 'Rechazado';
          default:
            return estado || 'Desconocido';
        }
      }
      
      // Estados normales para tickets regulares
      switch (estadoNormalizado) {
        case 'pendiente':
          return 'Pendiente';
        case 'asignado':
          return 'Asignado';
        case 'en_proceso':
          return 'En Proceso';
        case 'reasignar':
          return 'Reasignar';
        case 'resuelto':
          return 'Resuelto';
        case 'cancelado':
          return 'Cancelado';
        default:
          return estado || 'Desconocido';
      }
    },
    getSolicitudText(solicitud) {
      if (!solicitud) return 'Sin área';
      const sol = solicitud.toLowerCase();
      switch (sol) {
        case 'tecnologia':
        case 'tecnologias':
          return 'Tecnología';
        case 'mantenimiento':
          return 'Mantenimiento';
        case 'biomedica':
          return 'Biomédica';
        default:
          return solicitud;
      }
    },
    
    // Función para generar el folio según el área
    generarFolio(ticket) {
      if (!ticket) return '-';
      
      // Si el ticket ya tiene folio del backend, usarlo directamente
      if (ticket.folio) {
        return ticket.folio;
      }
      
      // Fallback: Generar folio localmente si no existe
      let prefijo = '';
      const area = ticket.solicitudArea?.toLowerCase();
      
      switch (area) {
        case 'tecnologias': // Corregido: era 'tecnologia'
          prefijo = 'Tec';
          break;
        case 'biomedica':
          prefijo = 'Bio';
          break;
        case 'mantenimiento':
          prefijo = 'Mtt';
          break;
        default:
          prefijo = 'Gen'; // General para tickets sin área específica
      }
      
      // Formatear el número con ceros a la izquierda (4 dígitos)
      const numero = String(ticket.id).padStart(4, '0');
      
      return `${prefijo}-${numero}`;
    },
    parseFechaFlexible(valor) {
      if (!valor || valor === '' || valor === 'null') {
        return null;
      }

      if (valor instanceof Date) {
        return isNaN(valor.getTime()) ? null : valor;
      }

      if (typeof valor === 'number') {
        const fechaNumero = new Date(valor);
        return isNaN(fechaNumero.getTime()) ? null : fechaNumero;
      }

      // Trim only for strings
      const valorTrim = typeof valor === 'string' ? valor.trim() : valor;

      // Detectar si es timestamp ISO (con T)
      if (typeof valor === 'string' && valorTrim.includes('T')) {
        const directa = new Date(valorTrim);
        if (!isNaN(directa.getTime())) {
          return directa;
        }
      }

      // Detectar si es string con espacio (fecha y hora separadas)
      if (typeof valor === 'string' && valorTrim.includes(' ')) {
        const iso = valorTrim.replace(' ', 'T');
        const directa = new Date(iso);
        if (!isNaN(directa.getTime())) {
          return directa;
        }
        
        const partes = valorTrim.split(' ');
        if (partes.length >= 1) {
          const fechaPart = partes[0];
          const horaPart = partes.length > 1 ? partes[1] : '00:00';
          const separador = fechaPart.includes('/') ? '/' : '-';
          const componentes = fechaPart.split(separador);
          if (componentes.length === 3) {
            let anio, mes, dia;
            if (componentes[0].length === 4) {
              // yyyy-MM-dd o yyyy/MM/dd
              anio = parseInt(componentes[0], 10);
              mes = parseInt(componentes[1], 10) - 1;
              dia = parseInt(componentes[2], 10);
            } else {
              // dd-MM-yyyy o dd/MM/yyyy
              dia = parseInt(componentes[0], 10);
              mes = parseInt(componentes[1], 10) - 1;
              anio = parseInt(componentes[2], 10);
            }

            const [horaStr = '0', minutoStr = '0'] = horaPart.split(':');
            const hora = parseInt(horaStr, 10);
            const minuto = parseInt(minutoStr, 10);

            const fechaConstruida = new Date(anio, mes, dia, hora, minuto);
            if (!isNaN(fechaConstruida.getTime())) {
              return fechaConstruida;
            }
          }
        }
      }

      // Detectar si es solo fecha sin hora (sin espacios)
      if (typeof valor === 'string' && !valorTrim.includes(' ')) {
        const separador = valorTrim.includes('/') ? '/' : '-';
        const componentes = valorTrim.split(separador);
        if (componentes.length === 3) {
          let anio, mes, dia;
          if (componentes[0].length === 4) {
            // yyyy-MM-dd o yyyy/MM/dd
            anio = parseInt(componentes[0], 10);
            mes = parseInt(componentes[1], 10) - 1;
            dia = parseInt(componentes[2], 10);
          } else {
            // dd-MM-yyyy o dd/MM/yyyy
            dia = parseInt(componentes[0], 10);
            mes = parseInt(componentes[1], 10) - 1;
            anio = parseInt(componentes[2], 10);
          }

          const fechaConstruida = new Date(anio, mes, dia, 0, 0);
          if (!isNaN(fechaConstruida.getTime())) {
            return fechaConstruida;
          }
        }
      }

      return null;
    },
    esFechaPosterior(fechaInicial, fechaFinal) {
      const inicio = this.parseFechaFlexible(fechaInicial);
      const fin = this.parseFechaFlexible(fechaFinal);
      if (!inicio || !fin) {
        return false;
      }
      return fin.getTime() >= inicio.getTime();
    },
    formatearFecha(fechaISO) {
      // Validar que la fecha no sea null, undefined o string vacío
      if (!fechaISO || fechaISO === '' || fechaISO === 'null') {
        return 'Sin fecha';
      }
      
      try {
        const fecha = this.parseFechaFlexible(fechaISO);
        if (!fecha) {
          return 'Sin fecha';
        }
        
        return fecha.toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        console.error('Error al formatear fecha:', fechaISO, e);
        return 'Sin fecha';
      }
    },
    formatearFechaCorta(fechaISO) {
      // Validar que la fecha no sea null, undefined o string vacío
      if (!fechaISO || fechaISO === '' || fechaISO === 'null') {
        return '-';
      }
      
      try {
        const fecha = this.parseFechaFlexible(fechaISO);
        if (!fecha) {
          return '-';
        }
        
        return fecha.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      } catch (e) {
        console.error('Error al formatear fecha:', fechaISO, e);
        return '-';
      }
    },
    formatearFechaHoraCorta(fechaISO) {
      // Validar que la fecha no sea null, undefined o string vacío
      if (!fechaISO || fechaISO === '' || fechaISO === 'null') {
        return { fecha: 'Sin fecha', hora: '' };
      }
      
      try {
        const fecha = this.parseFechaFlexible(fechaISO);
        if (!fecha) {
          return { fecha: 'Sin fecha', hora: '' };
        }
        
        const fechaStr = fecha.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const horaStr = fecha.toLocaleTimeString('es-ES', {
          hour: '2-digit',
          minute: '2-digit'
        });
        return { fecha: fechaStr, hora: horaStr };
      } catch (e) {
        console.error('Error al formatear fecha:', fechaISO, e);
        return { fecha: 'Sin fecha', hora: '' };
      }
    },
    calcularTiempoResolucion(fechaCreacion, fechaCierre) {
      const fechaInicio = this.parseFechaFlexible(fechaCreacion);
      const fechaFin = this.parseFechaFlexible(fechaCierre);
      if (!fechaInicio || !fechaFin) return 'Sin tiempo de resolución';

      const diferencia = fechaFin.getTime() - fechaInicio.getTime();
      if (diferencia <= 0) {
        return 'Sin tiempo de resolución';
      }

      const horas = diferencia / (1000 * 60 * 60);
      
      if (horas < 1) {
        const minutos = Math.round(horas * 60);
        return `${minutos} minutos`;
      } else if (horas < 24) {
        return `${horas.toFixed(1)} horas`;
      } else {
        const dias = Math.floor(horas / 24);
        const horasRestantes = horas % 24;
        return `${dias} días y ${horasRestantes.toFixed(1)} horas`;
      }
    },
    calcularTiempoAtencion(fechaAsignacion, fechaCierre) {
      const fechaInicio = this.parseFechaFlexible(fechaAsignacion);
      const fechaFin = this.parseFechaFlexible(fechaCierre);
      if (!fechaInicio || !fechaFin) return 'Sin tiempo de atención';

      const diferencia = fechaFin.getTime() - fechaInicio.getTime();
      if (diferencia <= 0) {
        return 'Sin tiempo de atención';
      }

      const horas = diferencia / (1000 * 60 * 60);
      
      if (horas < 1) {
        const minutos = Math.round(horas * 60);
        return `${minutos} minutos`;
      } else if (horas < 24) {
        return `${horas.toFixed(1)} horas`;
      } else {
        const dias = Math.floor(horas / 24);
        const horasRestantes = horas % 24;
        return `${dias} días y ${horasRestantes.toFixed(1)} horas`;
      }
    },
    incrementarCantidad() {
      const cantidadActual = parseInt(this.form.cantidadInsumos) || 0;
      if (cantidadActual < 999) {
        this.form.cantidadInsumos = cantidadActual + 1;
      }
    },
    decrementarCantidad() {
      const cantidadActual = parseInt(this.form.cantidadInsumos) || 0;
      if (cantidadActual > 1) {
        this.form.cantidadInsumos = cantidadActual - 1;
      }
    },
    agregarInsumo() {
      if (!this.form.insumos || this.form.insumos.trim() === '') {
        this.mostrarNotificacion('⚠️ Debe ingresar el nombre del insumo');
        return;
      }
      if (!this.form.cantidadInsumos || this.form.cantidadInsumos < 1) {
        this.mostrarNotificacion('⚠️ Debe ingresar una cantidad válida');
        return;
      }

      // Agregar insumo al array
      this.form.listaInsumos.push({
        nombre: this.form.insumos,
        cantidad: this.form.cantidadInsumos,
        descripcion: this.form.descripcionInsumos || ''
      });

      // Limpiar campos
      this.form.insumos = '';
      this.form.cantidadInsumos = 1;
      this.form.descripcionInsumos = '';

      this.mostrarNotificacion('✅ Insumo agregado correctamente');
    },
    eliminarInsumo(index) {
      this.form.listaInsumos.splice(index, 1);
      this.mostrarNotificacion('✅ Insumo eliminado');
    },

    // Métodos para manejar archivos PDF
    handlePdfFileChange(event) {
      const files = Array.from(event.target.files);
      
      // Validar que todos los archivos sean PDFs
      const validFiles = files.filter(file => {
        if (file.type !== "application/pdf") {
          this.$emit('show-alert', {
            type: 'error',
            message: `El archivo "${file.name}" no es un PDF válido`
          });
          return false;
        }
        
        // Validar tamaño (10MB máximo)
        const maxSize = 10 * 1024 * 1024; // 10MB en bytes
        if (file.size > maxSize) {
          this.$emit('show-alert', {
            type: 'error',
            message: `El archivo "${file.name}" excede el tamaño máximo de 10MB`
          });
          return false;
        }
        
        return true;
      });
      
      // Agregar archivos válidos al array
      this.form.pdfFiles = [...this.form.pdfFiles, ...validFiles];
    },
    
    removePdfFile(index) {
      this.form.pdfFiles.splice(index, 1);
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const r = bytes / Math.pow(k, i);
      return parseFloat(r).toFixed(2) + ' ' + sizes[i];
    },
    
    async subirPdfsTicket(ticketId) {
      console.log('PDF DEBUG - ===== INICIO subirPdfsTicket =====');
      console.log('PDF DEBUG - subirPdfsTicket iniciado con ticketId:', ticketId);
      console.log('PDF DEBUG - pdfFiles.length:', this.form.pdfFiles.length);
      
      if (this.form.pdfFiles.length === 0) {
        console.log('PDF DEBUG - No hay archivos PDF para subir');
        this.mostrarNotificacion('No hay archivos PDF para subir', 'warning');
        return;
      }
      
      this.form.pdfUploadLoading = true;
      
      try {
        console.log('PDF DEBUG - Iniciando bucle de subida de PDFs...');
        for (let i = 0; i < this.form.pdfFiles.length; i++) {
          const file = this.form.pdfFiles[i];
          console.log(`PDF DEBUG - Subiendo archivo ${i + 1}/${this.form.pdfFiles.length}:`, file.name);
          
          const formData = new FormData();
          formData.append('pdfFile', file);
          formData.append('ticketId', String(ticketId));
          
          console.log('PDF DEBUG - Enviando petición al servidor...');
          const response = await this.$http({
            url: '/mantenimiento/tickets/subirPdfTicket',
            method: 'POST',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          
          console.log(`PDF DEBUG - Respuesta del servidor para archivo ${i + 1}:`, response.data);
        }
        
        const totalArchivosSubidos = this.form.pdfFiles.length;
        console.log('PDF DEBUG - Todos los PDFs subidos exitosamente. Total:', totalArchivosSubidos);
        
        // Limpiar archivos después de subir exitosamente
        this.form.pdfFiles = [];
        
        this.mostrarNotificacion(`Se subieron ${totalArchivosSubidos} archivo(s) PDF correctamente`, 'success');
        
        // Recargar el ticket para mostrar los nuevos PDFs
        if (this.ticketDetalle && this.ticketDetalle.id === ticketId) {
          console.log('PDF DEBUG - Recargando detalle del ticket para mostrar PDFs...');
          await this.cargarDetalleTicket(ticketId);
        }
        
      } catch (error) {
        console.error('PDF DEBUG - Error al subir PDFs:', error);
        console.error('PDF DEBUG - Error response:', error.response?.data);
        this.mostrarNotificacion('Error al subir los archivos PDF: ' + (error.response?.data?.mensaje || error.message), 'error');
      } finally {
        this.form.pdfUploadLoading = false;
        console.log('PDF DEBUG - ===== FIN subirPdfsTicket =====');
      }
    },
    
    // Métodos para manejar PDFs en el detalle del ticket
    handlePdfDetailChange(event) {
      const files = Array.from(event.target.files);
      
      // Validar que todos los archivos sean PDFs
      const validFiles = files.filter(file => {
        if (file.type !== "application/pdf") {
          this.mostrarNotificacion(`El archivo "${file.name}" no es un PDF válido`, 'error');
          return false;
        }
        
        // Validar tamaño (10MB máximo)
        const maxSize = 10 * 1024 * 1024; // 10MB en bytes
        if (file.size > maxSize) {
          this.mostrarNotificacion(`El archivo "${file.name}" excede el tamaño máximo de 10MB`, 'error');
          return false;
        }
        
        return true;
      });
      
      // Agregar archivos válidos al array
      this.form.pdfDetailFiles = [...this.form.pdfDetailFiles, ...validFiles];
    },
    
    removePdfDetailFile(index) {
      this.form.pdfDetailFiles.splice(index, 1);
    },
    
    async subirPdfsDetalle() {
      if (this.form.pdfDetailFiles.length === 0) {
        this.mostrarNotificacion('No hay archivos PDF para subir', 'warning');
        return;
      }
      
      if (!this.ticketDetalle || !this.ticketDetalle.id) {
        this.mostrarNotificacion('No se puede subir PDFs: ticket no encontrado', 'error');
        return;
      }
      
      this.form.pdfDetailUploadLoading = true;
      
      try {
        for (const file of this.form.pdfDetailFiles) {
          const formData = new FormData();
          formData.append('pdfFile', file);
          formData.append('ticketId', String(this.ticketDetalle.id));
          
          await this.$http({
            url: '/mantenimiento/tickets/subirPdfTicket',
            method: 'POST',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        }
        
        const totalArchivosSubidos = this.form.pdfDetailFiles.length;
        // Limpiar archivos después de subir exitosamente
        this.form.pdfDetailFiles = [];
        
        this.mostrarNotificacion(`Se subieron ${totalArchivosSubidos} archivo(s) PDF correctamente`, 'success');
        
        // Recargar el ticket para mostrar los nuevos PDFs
        await this.cargarDetalleTicket(this.ticketDetalle.id);
        
      } catch (error) {
        console.error('Error al subir PDFs:', error);
        this.mostrarNotificacion('Error al subir los archivos PDF: ' + (error.response?.data?.mensaje || error.message), 'error');
      } finally {
        this.form.pdfDetailUploadLoading = false;
      }
    },
    
    // Métodos para autocompletado de insumos
    async buscarSugerenciasInsumos() {
      // Si el texto es muy corto, no buscar
      if (!this.form.insumos || this.form.insumos.length < 2) {
        this.sugerenciasInsumos = [];
        this.mostrarSugerencias = false;
        return;
      }

      try {
        const areaActual = this.form.solicitudArea || this.form.areaRequerida || this.form.area || null;
        // Usar el nuevo servicio que se conecta al backend
        // Esto busca en la tabla catalogo_insumos de la base de datos
        this.sugerenciasInsumos = await InsumosService.buscarInsumos(this.form.insumos, 10, areaActual);
        this.mostrarSugerencias = this.sugerenciasInsumos.length > 0;
      } catch (error) {
        console.error('Error al buscar sugerencias de insumos:', error);
        this.sugerenciasInsumos = [];
        this.mostrarSugerencias = false;
      }
    },
    seleccionarSugerencia(sugerencia) {
      this.form.insumos = sugerencia.textoCompleto || sugerencia.descripcion;
      this.form.descripcionInsumos = InsumosService.formatearDetalles(sugerencia);
      this.mostrarSugerencias = false;
      this.sugerenciasInsumos = [];
    },
    ocultarSugerencias() {
      // Pequeño delay para permitir que se ejecute el click en las sugerencias
      setTimeout(() => {
        this.mostrarSugerencias = false;
      }, 200);
    },
    
    esSolicitudInsumos(ticket) {
      // Detectar por campo insumos o por tipo explicito
      return ticket.tipo === 'INSUMOS' ||
             (ticket.insumos && ticket.insumos.trim() !== '');
    },

    esSolicitudEquipo(ticket) {
      // Detectar por campo equipo o por tipo explicito
      return ticket.tipo === 'EQUIPO_AFECTADO' ||
             (ticket.equipo && ticket.equipo.trim() !== '' &&
              !(ticket.tipo === 'INSUMOS' || (ticket.insumos && ticket.insumos.trim() !== '')));
    },
    
    getPrioridadStyle(ticket) {
      // 1. Prioridad máxima: Gestión de información (morado)
      if (ticket.tipo === 'GESTION_INFORMACION' || ticket.esGestionInformacion) {
        return {
          borderLeft: `4px solid #9333EA`,
          backgroundColor: '#9333EA15'
        };
      }
      
      // 2. Solicitud de garrafón de agua (azul celeste)
      if (ticket.tipo === 'GARRAFON_AGUA') {
        return {
          borderLeft: `4px solid #0EA5E9`,
          backgroundColor: '#0EA5E920'
        };
      }
      
      // 3. Solicitud de insumos (azul) - verificar primero por tipo, luego por contenido
      if (ticket.tipo === 'INSUMOS' || this.esSolicitudInsumos(ticket)) {
        return {
          borderLeft: `4px solid #2563EB`,
          backgroundColor: '#2563EB20'
        };
      }

      // 4. Solicitud de equipo afectado (naranja fuerte) - verificar primero por tipo, luego por contenido
      if (ticket.tipo === 'EQUIPO_AFECTADO' || this.esSolicitudEquipo(ticket)) {
        return {
          borderLeft: `4px solid #EA580C`,
          backgroundColor: '#EA580C20'
        };
      }
      
      // 4. Como último recurso, usar color de prioridad automática
      if (ticket.prioridadColor) {
        return {
          borderLeft: `4px solid ${ticket.prioridadColor}`,
          backgroundColor: `${ticket.prioridadColor}10`
        };
      }
      
      return {};
    },
    
    getPrioridadBadgeStyle(ticket) {
      let color = ticket.prioridadColor || '#FFCC00';
      
      // Si es gestión de información, mostrar morado
      if (ticket.tipo === 'GESTION_INFORMACION' || ticket.esGestionInformacion) {
        color = '#9333EA';
      }
      // Si es garrafón de agua, mostrar azul celeste
      else if (ticket.tipo === 'GARRAFON_AGUA') {
        color = '#0EA5E9';
      }
      // Si es insumos, mostrar azul fuerte
      else if (ticket.tipo === 'INSUMOS' || this.esSolicitudInsumos(ticket)) {
        color = '#2563EB';
      }
      // Si es equipo afectado, mostrar naranja fuerte
      else if (ticket.tipo === 'EQUIPO_AFECTADO' || this.esSolicitudEquipo(ticket)) {
        color = '#EA580C';
      }
      
      return {
        backgroundColor: color,
        color: 'white',
        padding: '4px 8px',
        borderRadius: '12px',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        display: 'inline-block',
        minWidth: '60px',
        textAlign: 'center'
      };
    },
    
    // Métodos para manejo de PDFs
    verPdf(url, nombre) {
      if (!url) {
        this.mostrarNotificacion('URL del PDF no disponible');
        return;
      }
      
      // Abrir PDF en nueva pestaña
      const nuevaVentana = window.open(url, '_blank');
      if (!nuevaVentana) {
        this.mostrarNotificacion(`No se pudo abrir el PDF "${nombre || 'documento'}". Verifica que tu navegador permita ventanas emergentes.`);
      } else {
        this.mostrarNotificacion(`Abriendo PDF: ${nombre || 'documento'}`);
      }
    },
    
    descargarPdf(url, nombre) {
      if (!url) {
        this.mostrarNotificacion('URL del PDF no disponible');
        return;
      }
      
      // Crear un enlace temporal para descargar
      const enlace = document.createElement('a');
      enlace.href = url;
      enlace.download = nombre || 'documento.pdf';
      enlace.target = '_blank';
      
      // Forzar la descarga
      document.body.appendChild(enlace);
      enlace.click();
      document.body.removeChild(enlace);
      
      this.mostrarNotificacion(`Descargando: ${nombre || 'documento.pdf'}`);
    }
    

  },
  watch: {
    role: {
      immediate: true,
      handler() {
        if (!this.esAdminOTecnico) {
          if (!this.form.nombre) {
            this.form.nombre = '';
          }
        }
      },
    },
    userName: {
      immediate: true,
      handler(newUserName) {
        if (newUserName) {
          this.form.nombre = newUserName;
        }
      },
    },
    'form.solicitudArea': {
      handler(newArea) {
        const areaNormalizada = (newArea || '').toString().trim().toUpperCase();
        // Limpiar sugerencias únicamente cuando se cambia a un área distinta de Biomédica/Biomedica
        if (areaNormalizada && areaNormalizada !== 'BIOMEDICA') {
          this.sugerenciasInsumos = [];
          this.mostrarSugerencias = false;
        }
      }
    }
  },
};
</script>

<style scoped>
.ticket-form-container {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 10px 0;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  box-sizing: border-box;
  overflow-x: hidden;
}


.main-content {
  width: 98%;
  max-width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.table-header h3 {
  margin: 0;
  color: #009a44;
  font-size: 1.3rem;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}

.header-actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.new-ticket-btn {
  background: #009a44;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.new-ticket-btn:hover {
  background: #007a36;
}

.new-ticket-btn:active {
  background: #006a2e;
}

.header-with-actions {
  width: 90%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  box-sizing: border-box;
}

.header-with-actions h2 {
  margin: 0;
  font-size: 1.5rem;
}

.admin-actions {
  position: relative;
}

.dropdown {
  position: relative;
}

.stats-btn {
  background: #4a90e2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 18px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 10px rgba(74, 144, 226, 0.2);
}

.stats-btn:hover {
  background: #1f5fbf;
  box-shadow: 0 6px 14px rgba(31, 95, 191, 0.28);
}

.stats-toggle-btn {
  font-weight: 600;
  gap: 12px;
  min-width: 170px;
  justify-content: center;
}

.stats-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  padding: 12px 0;
}

.stats-option-btn {
  background: #ffffff;
  color: #1f2a44;
  border: 1px solid #d0d8e6;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.stats-option-btn:hover {
  background: linear-gradient(135deg, #edf3ff 0%, #dbe8ff 100%);
  border-color: #4a90e2;
  box-shadow: 0 10px 24px rgba(74, 144, 226, 0.18);
  transform: translateY(-1px);
}

.stats-option-btn:active {
  transform: translateY(0);
  box-shadow: 0 6px 14px rgba(74, 144, 226, 0.14);
}

.dropdown-arrow {
  font-size: 0.8rem;
  transition: transform 0.2s;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 1000;
  min-width: 200px;
}

.dropdown-menu button {
  display: block;
  width: 100%;
  padding: 8px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.dropdown-menu button:hover {
  background: #f0f0f0;
}

.ticket-list {
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;
}

.ticket-list h3 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 1.1rem;
  text-align: left;
}

.ticket-list table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  table-layout: fixed;
  font-family: 'Montserrat', sans-serif;
}

.ticket-list th, .ticket-list td {
  border-bottom: 1px solid #e0e0e0;
  padding: 6px 4px;
  text-align: left;
  word-wrap: break-word;
  vertical-align: middle;
}

/* Estilos para la celda de fecha y hora */
.fecha-hora-cell {
  padding: 8px 4px !important;
  text-align: center;
  vertical-align: middle;
}

.fecha-line {
  font-size: 0.85rem;
  font-weight: 500;
  color: #495057;
  line-height: 1.2;
  margin-bottom: 2px;
}

.hora-line {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 400;
  line-height: 1.2;
}

/* Optimización de ancho de columnas */
.ticket-list th:nth-child(1), .ticket-list td:nth-child(1) { /* Folio (usuarios) */
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  text-align: center;
  padding: 8px 6px;
}

.ticket-list th:nth-child(2), .ticket-list td:nth-child(2) { /* Título */
  width: 220px;
  min-width: 180px;
}

.ticket-list th:nth-child(3), .ticket-list td:nth-child(3) { /* Solicitante (solo admin) */
  width: 120px;
  min-width: 100px;
}

.ticket-list th:nth-child(4), .ticket-list td:nth-child(4) { /* Área Solicitante */
  width: 120px;
  min-width: 100px;
}

.ticket-list th:nth-child(5), .ticket-list td:nth-child(5) { /* Prioridad */
  width: 100px;
  min-width: 80px;
}

.ticket-list th:nth-child(6), .ticket-list td:nth-child(6) { /* Fecha Creación */
  width: 90px;
  min-width: 80px;
  text-align: center;
  font-size: 0.8rem;
}

.ticket-list th:nth-child(7), .ticket-list td:nth-child(7) { /* Fecha Cierre */
  width: 90px;
  min-width: 80px;
  text-align: center;
  font-size: 0.8rem;
}

.ticket-list th:nth-child(8), .ticket-list td:nth-child(8) { /* Técnico */
  width: 120px;
  min-width: 100px;
}

.ticket-list th:nth-child(9), .ticket-list td:nth-child(9) { /* Estado */
  width: 100px;
  min-width: 80px;
  text-align: center;
}


.ticket-list th {
  background: #f0f0f0;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ticket-list tr:last-child td {
  border-bottom: none;
}

/* Estilos para filas clickeables */
.ticket-row {
  cursor: pointer;
  transition: all 0.3s ease;
}

.ticket-row:hover {
  background: #f8fff9;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 154, 68, 0.1);
}

.ticket-row:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 154, 68, 0.2);
}

/* Estilos para badges de estado */
.estado-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  display: inline-block;
  min-width: 80px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-pending {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.badge-in-progress {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.badge-resolved {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.badge-reassigned {
  background: #ffeaa7;
  color: #856404;
  border: 1px solid #fdcb6e;
}

.badge-cancelled {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.badge-cancel {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.badge-reassign {
  background: #e2e3e5;
  color: #383d41;
  border: 1px solid #d6d8db;
}

.badge-closed {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}



/* Estilos para el filtro de áreas */
.filter-section {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
  position: relative;
  padding-right: 70px;
}

.filter-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.chatbot-trigger-wrapper {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 5;
}

.chatbot-trigger {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 44px;
  border-radius: 14px;
  transition: transform 160ms ease, filter 160ms ease;
}

.chatbot-trigger:hover {
  transform: translateY(-1px);
  filter: drop-shadow(0 10px 18px rgba(15, 23, 42, 0.18));
}

.chatbot-trigger:active {
  transform: translateY(0);
}

.chatbot-bot-icon {
  position: relative;
  width: 40px;
  height: 40px;
}

.chatbot-bot-antenna {
  position: absolute;
  left: 50%;
  top: -2px;
  width: 2px;
  height: 10px;
  transform: translateX(-50%);
  background: rgba(37, 99, 235, 0.65);
  border-radius: 99px;
}

.chatbot-bot-antenna-ball {
  position: absolute;
  left: 50%;
  top: -5px;
  width: 8px;
  height: 8px;
  transform: translateX(-50%);
  border-radius: 50%;
  background: linear-gradient(135deg, #22c55e 0%, #2563eb 100%);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.22);
}

.chatbot-bot-head {
  position: absolute;
  left: 50%;
  top: 6px;
  width: 38px;
  height: 22px;
  transform: translateX(-50%);
  border-radius: 12px;
  background: linear-gradient(135deg, #1f4f7a 0%, #2563eb 55%, #22c55e 110%);
  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.18);
  overflow: hidden;
}

.chatbot-bot-head::after {
  content: '';
  position: absolute;
  inset: -18px;
  background: radial-gradient(circle at 30% 20%, rgba(255,255,255,0.35), transparent 45%);
}

.chatbot-bot-eye {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 8px;
  z-index: 1;
}

.chatbot-bot-eye.left {
  left: 10px;
}

.chatbot-bot-eye.right {
  right: 10px;
}

.chatbot-bot-mouth {
  width: 14px;
  height: 5px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.85);
  position: absolute;
  left: 50%;
  bottom: 5px;
  transform: translateX(-50%);
  z-index: 1;
}

.chatbot-bot-body {
  position: absolute;
  left: 50%;
  bottom: 2px;
  width: 30px;
  height: 16px;
  transform: translateX(-50%);
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(15, 23, 42, 0.10);
}

.chatbot-bot-badge {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: rgba(34, 197, 94, 0.18);
  border: 1px solid rgba(34, 197, 94, 0.30);
}

.bot-thought {
  position: absolute;
  right: 50px;
  top: -2px;
  width: 220px;
  pointer-events: none;
}

.bot-thought-dots {
  position: absolute;
  right: 10px;
  bottom: -10px;
  display: flex;
  gap: 4px;
}

.bot-thought-dots .dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.25);
  border: 1px solid rgba(37, 99, 235, 0.22);
}

.bot-thought-text {
  display: inline-block;
  max-width: 220px;
  padding: 8px 10px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(15, 23, 42, 0.10);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  color: rgba(15, 23, 42, 0.86);
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.1rem;
}

.bot-thought-text-enter-active,
.bot-thought-text-leave-active {
  transition: opacity 200ms ease, transform 200ms ease;
}

.bot-thought-text-enter,
.bot-thought-text-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

.chatbot-pop-enter-active,
.chatbot-pop-leave-active {
  transition: transform 180ms ease, opacity 180ms ease;
}

.chatbot-pop-enter,
.chatbot-pop-leave-to {
  transform: translateY(-6px) scale(0.98);
  opacity: 0;
}

.chatbot-panel {
  position: absolute;
  right: 12px;
  top: 62px;
  width: min(560px, calc(100vw - 32px));
  max-height: min(720px, calc(100vh - 110px));
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 16px;
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.25);
  overflow: hidden;
  z-index: 6;
  display: flex;
  flex-direction: column;
}

.chatbot-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.95) 0%, rgba(34, 197, 94, 0.92) 100%);
  color: #fff;
}

.chatbot-title {
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.2px;
}

.chatbot-header-actions {
  display: flex;
  gap: 8px;
}

.chatbot-close,
.chatbot-clear {
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border-radius: 10px;
  padding: 6px 10px;
  font-size: 0.82rem;
  cursor: pointer;
  transition: background 160ms ease;
}

.chatbot-close:hover,
.chatbot-clear:hover {
  background: rgba(255, 255, 255, 0.22);
}

.chatbot-clear:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.chatbot-messages {
  padding: 12px;
  overflow-y: auto;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 60%);
  flex: 1;
  min-height: 340px;
}

.chatbot-message {
  display: flex;
  margin: 8px 0;
}

.chatbot-message.bot {
  justify-content: flex-start;
}

.chatbot-message.user {
  justify-content: flex-end;
}

.chatbot-bubble {
  max-width: 86%;
  padding: 10px 12px;
  border-radius: 14px;
  font-size: 0.92rem;
  line-height: 1.25rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
}

.chatbot-message.bot .chatbot-bubble {
  border-top-left-radius: 8px;
}

.chatbot-message.user .chatbot-bubble {
  background: rgba(37, 99, 235, 0.10);
  border-color: rgba(37, 99, 235, 0.22);
  border-top-right-radius: 8px;
}

.chatbot-bubble-text {
  color: #0f172a;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: pre-wrap;
}

.chatbot-soluciones {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chatbot-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.chatbot-keywords-label {
  font-weight: 700;
  color: #0f172a;
  margin-right: 4px;
}

.chatbot-keyword {
  font-size: 0.78rem;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.13);
  border: 1px solid rgba(34, 197, 94, 0.22);
  color: #166534;
}

.chatbot-results {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chatbot-result {
  padding: 10px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.03);
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.chatbot-result-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.78rem;
  color: rgba(15, 23, 42, 0.70);
  margin-bottom: 6px;
}

.chatbot-result-ticket {
  font-weight: 800;
  color: rgba(15, 23, 42, 0.82);
}

.chatbot-result-text {
  color: #0f172a;
  white-space: pre-wrap;
}

.chatbot-empty {
  color: rgba(15, 23, 42, 0.75);
  font-size: 0.86rem;
}

.chatbot-inputbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
}

.chatbot-settings {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.chatbot-setting {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  color: rgba(15, 23, 42, 0.78);
}

.chatbot-setting-label {
  font-weight: 700;
}

.chatbot-setting-select {
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.14);
  padding: 0 10px;
  background: #fff;
}

.chatbot-setting-toggle {
  gap: 10px;
}

.chatbot-setting-toggle input {
  transform: translateY(1px);
}

.chatbot-compose {
  display: flex;
  gap: 8px;
}

.chatbot-input {
  flex: 1;
  height: 40px;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.14);
  padding: 0 12px;
  font-size: 0.92rem;
  outline: none;
}

.chatbot-input:focus {
  border-color: rgba(37, 99, 235, 0.55);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);
}

.chatbot-send {
  height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #2563eb 0%, #22c55e 100%);
  font-weight: 700;
}

.chatbot-send:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.chatbot-basicas-title {
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 2px;
  line-height: 1.15rem;
}

.chatbot-basicas {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chatbot-basica {
  background: rgba(34, 197, 94, 0.07);
  border: 1px solid rgba(34, 197, 94, 0.18);
  border-radius: 12px;
  padding: 10px;
}

.chatbot-basica-header {
  font-weight: 800;
  margin-bottom: 6px;
  line-height: 1.15rem;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.chatbot-basica-list {
  padding-left: 18px;
  margin: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.chatbot-basica-step {
  margin: 4px 0;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.chatbot-confirm {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chatbot-confirm-text {
  font-weight: 700;
  color: #0f172a;
}

.chatbot-confirm-actions {
  display: flex;
  gap: 8px;
}

.chatbot-confirm-btn {
  flex: 1;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.14);
  background: #ffffff;
  cursor: pointer;
  font-weight: 800;
}

.chatbot-confirm-btn.yes {
  border-color: rgba(34, 197, 94, 0.35);
  background: rgba(34, 197, 94, 0.10);
  color: #166534;
}

.chatbot-confirm-btn.no {
  border-color: rgba(37, 99, 235, 0.35);
  background: rgba(37, 99, 235, 0.10);
  color: #1d4ed8;
}

.chatbot-error {
  padding: 10px 12px;
  color: #b91c1c;
  background: rgba(185, 28, 28, 0.08);
  border-top: 1px solid rgba(185, 28, 28, 0.16);
  font-size: 0.86rem;
}

.chatbot-typing {
  display: flex;
  gap: 6px;
  padding: 8px 0 0 0;
}

.chatbot-typing-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.55);
  animation: chatbotTyping 1.05s infinite;
}

.chatbot-typing-dot:nth-child(2) {
  animation-delay: 0.12s;
}

.chatbot-typing-dot:nth-child(3) {
  animation-delay: 0.24s;
}

@keyframes chatbotTyping {
  0%, 100% { transform: translateY(0); opacity: 0.45; }
  50% { transform: translateY(-3px); opacity: 1; }
}

/* Estilos para el menú del chatbot */
.chatbot-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Menú fijo siempre visible */
.chatbot-menu-fixed {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(34, 197, 94, 0.03) 100%);
  border-top: 1px solid rgba(37, 99, 235, 0.15);
  max-height: 200px;
  overflow-y: auto;
}

.chatbot-menu-title {
  font-weight: 700;
  color: #0f172a;
  font-size: 0.95rem;
  margin-bottom: 4px;
}

.chatbot-menu-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chatbot-menu-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(37, 99, 235, 0.25);
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(37, 99, 235, 0.03) 100%);
  border-radius: 10px;
  cursor: pointer;
  transition: all 150ms ease;
  text-align: left;
}

.chatbot-menu-btn:hover {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(37, 99, 235, 0.06) 100%);
  border-color: rgba(37, 99, 235, 0.4);
  transform: translateX(3px);
}

.chatbot-menu-btn:active {
  transform: translateX(1px);
}

.chatbot-menu-icon {
  font-size: 1.3rem;
  flex-shrink: 0;
}

.chatbot-menu-text {
  font-weight: 600;
  color: #1e40af;
  font-size: 0.9rem;
}

/* Estilos para subida de archivos PDF */
.pdf-upload-container {
  margin-top: 10px;
}

.pdf-input {
  display: none;
}

.pdf-upload-area {
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.pdf-upload-area:hover {
  border-color: #9333ea;
  background: #f0f4ff;
}

.upload-icon {
  font-size: 2rem;
  margin-bottom: 10px;
}

.upload-text p {
  margin: 0 0 10px 0;
  font-weight: 600;
  color: #495057;
}

.upload-text small {
  color: #6c757d;
  font-size: 0.85rem;
}

.pdf-list {
  margin-top: 15px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f8f9fa;
}

.pdf-list h4 {
  margin: 0 0 10px 0;
  font-size: 0.9rem;
  color: #495057;
}

.pdf-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #e9ecef;
  background: #ffffff;
}

.pdf-item:last-child {
  border-bottom: none;
}

.pdf-name {
  font-weight: 500;
  color: #495057;
  flex: 1;
}

.pdf-size {
  color: #6c757d;
  font-size: 0.8rem;
  margin-left: 8px;
}

.remove-pdf-btn {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 1rem;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.remove-pdf-btn:hover {
  color: #c82333;
  background: #f8d7da;
}

.upload-loading {
  text-align: center;
  padding: 10px;
  color: #007bff;
  font-weight: 600;
}

/* Estilos para PDFs en detalle del ticket */
.pdf-section {
  margin-top: 20px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #f8f9fa;
}

.pdf-list-detail {
  max-height: 300px;
  overflow-y: auto;
}

.pdf-item-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
  background: #ffffff;
}

.pdf-item-detail:last-child {
  border-bottom: none;
}

.pdf-info {
  flex: 1;
}

.pdf-name-detail {
  margin-bottom: 4px;
}

.pdf-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.pdf-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

/* Estilos para acciones de PDF */
.pdf-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.pdf-action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  font-weight: 500;
}

.pdf-action-btn.view-btn {
  background: #17a2b8;
  color: white;
}

.pdf-action-btn.view-btn:hover {
  background: #138496;
  transform: translateY(-1px);
}

.pdf-action-btn.download-btn {
  background: #28a745;
  color: white;
}

.pdf-action-btn.download-btn:hover {
  background: #218838;
  transform: translateY(-1px);
}

.pdf-action-btn:active {
  transform: translateY(0);
}

.pdf-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 0.8rem;
  color: #6c757d;
}

.pdf-size-detail {
  font-weight: 600;
}

.pdf-date {
  font-style: italic;
}

.pdf-upload-section {
  margin-top: 20px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #f8f9fa;
  padding: 16px;
}

.pdf-upload-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pdf-detail-input {
  display: none;
}

.pdf-upload-btn {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.pdf-upload-btn:hover {
  background: #0056b3;
}

.pdf-upload-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.pdf-detail-files {
  margin-top: 12px;
  max-height: 200px;
  overflow-y: auto;
}

.pdf-detail-files h5 {
  margin: 0 0 8px 0;
  font-size: 0.9rem;
  color: #495057;
}

.pdf-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 6px;
}

.pdf-detail-name {
  font-weight: 500;
  color: #495057;
  flex: 1;
}

.pdf-detail-size {
  color: #6c757d;
  font-size: 0.8rem;
}

.remove-pdf-detail-btn {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.remove-pdf-detail-btn:hover {
  color: #c82333;
  background: #f8d7da;
}

.upload-loading-detail {
  text-align: center;
  padding: 12px;
  color: #007bff;
  font-weight: 600;
  background: #e3f2fd;
  border-radius: 6px;
  margin-top: 12px;
}

/* Estilos para botón de volver al menú */
.chatbot-back-btn {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 10px 16px;
  margin-top: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
}

.chatbot-back-btn:hover {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-color: #94a3b8;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.chatbot-back-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.filter-controls label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
  margin: 0;
}

.area-filter {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
  color: #495057;
  min-width: 200px;
  transition: all 0.3s ease;
}

.area-filter:focus {
  outline: none;
  border-color: #009a44;
  box-shadow: 0 0 0 3px rgba(0, 154, 68, 0.1);
}

/* Estilos para autocomplete de áreas */
.autocomplete-container {
  min-width: 250px;
  max-width: 350px;
}

.area-autocomplete {
  font-size: 0.9rem !important;
}

.area-autocomplete >>> .v-input__control {
  min-height: 45px !important;
}

.area-autocomplete >>> .v-text-field__details {
  display: none !important;
}

.clear-filter-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
  align-self: flex-end;
}

.clear-filter-btn:hover {
  background: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.3);
}

.filter-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: #6c757d;
}

.ticket-count {
  font-weight: 600;
  color: #009a44;
  background: #d4edda;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
}

/* Responsive para el filtro */
@media (max-width: 600px) {
  .filter-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .filter-group {
    width: 100%;
  }
  
  .area-filter {
    min-width: auto;
    width: 100%;
  }
  
  .clear-filter-btn {
    align-self: stretch;
    justify-content: center;
  }
  
  .filter-info {
    flex-direction: column;
    gap: 5px;
    text-align: center;
  }
}

.form-group {
  margin-bottom: 12px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}

.required {
  color: #ef4444;
}

.form-group input,
.form-group select,
.ticket-form-modal textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  resize: vertical;
}

.auto-diagnostic-panel {
  margin-top: 10px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid rgba(31, 79, 122, 0.22);
  background: rgba(31, 79, 122, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.auto-diagnostic-text {
  font-size: 0.9rem;
  color: #143552;
  line-height: 1.2;
}

.auto-diagnostic-btn {
  background: linear-gradient(135deg, #1f4f7a, #143552);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.9rem;
  white-space: nowrap;
  box-shadow: 0 8px 18px rgba(20, 53, 82, 0.18);
}

.auto-diagnostic-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  box-shadow: none;
}

/* Estilos para sección de diagnóstico */
.diagnostic-section {
  background: linear-gradient(135deg, #f8fafb 0%, #e8f4f8 100%);
  border: 2px solid #1f4f7a;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(31, 79, 122, 0.1);
}

.diagnostic-section .section-header h3 {
  color: #1f4f7a;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.diagnostic-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
  padding: 20px;
}

.diagnostic-item {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.diagnostic-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #1f4f7a;
}

.diagnostic-label {
  font-weight: 600;
  color: #143552;
  font-size: 0.9rem;
  flex: 0 0 auto;
  min-width: 140px;
}

.diagnostic-value {
  color: #2c3e50;
  font-size: 0.95rem;
  flex: 1;
  text-align: right;
  word-break: break-word;
}

/* Responsive para diagnóstico */
@media (max-width: 768px) {
  .diagnostic-grid {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 15px;
  }
  
  .diagnostic-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .diagnostic-label {
    min-width: auto;
  }
  
  .diagnostic-value {
    text-align: left;
  }
}

.telegram-chat-modal {
  max-width: 780px;
}

.telegram-chat-body {
  padding: 12px;
}

.telegram-chat-layout {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 12px;
  align-items: stretch;
}

@media (max-width: 820px) {
  .telegram-chat-layout {
    grid-template-columns: 1fr;
  }
}

.telegram-sidebar {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 420px;
}

.telegram-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.telegram-sidebar-title {
  font-weight: 800;
  color: #0f172a;
}

.telegram-refresh {
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  border-radius: 10px;
  padding: 8px 10px;
  font-weight: 700;
  cursor: pointer;
}

.telegram-refresh:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.telegram-sidebar-list {
  overflow-y: auto;
  padding: 6px;
}

.telegram-contact {
  width: 100%;
  text-align: left;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 12px;
  padding: 10px;
  cursor: pointer;
}

.telegram-contact:hover {
  background: #f8fafc;
  border-color: rgba(15, 23, 42, 0.08);
}

.telegram-contact.active {
  background: rgba(31, 79, 122, 0.08);
  border-color: rgba(31, 79, 122, 0.20);
}

.telegram-contact-name {
  font-weight: 800;
  color: #0f172a;
  font-size: 0.92rem;
}

.telegram-contact-meta {
  color: #64748b;
  font-size: 0.82rem;
  margin-top: 2px;
}

.telegram-thread {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 420px;
}

.telegram-thread-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.telegram-thread-title {
  font-weight: 900;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.telegram-messages {
  height: 320px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f8fafc;
  padding: 10px;
  margin: 10px 0;
}

.telegram-empty {
  color: #64748b;
  font-size: 0.92rem;
  text-align: center;
  padding: 20px 8px;
}

.telegram-msg {
  max-width: 85%;
  margin: 8px 0;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
}

.telegram-msg.in {
  margin-right: auto;
  border-left: 4px solid #1f4f7a;
}

.telegram-msg.out {
  margin-left: auto;
  border-left: 4px solid #d17a22;
  background: #fffaf3;
}

.telegram-msg-meta {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.telegram-msg-name {
  font-weight: 700;
  font-size: 0.85rem;
  color: #0f172a;
}

.telegram-msg-time {
  font-size: 0.78rem;
  color: #64748b;
  white-space: nowrap;
}

.telegram-msg-text {
  font-size: 0.95rem;
  line-height: 1.35;
  color: #0f172a;
  white-space: pre-wrap;
  word-break: break-word;
}

.telegram-input-row {
  display: grid;
  grid-template-columns: 1fr 120px;
  gap: 10px;
  align-items: center;
}

.telegram-input-row input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 14px;
}

.form-group input[readonly] {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
  border-color: #dee2e6;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background: #009a44;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  opacity: 1;
  transition: background 0.2s;
}

.submit-btn:active {
  background: #007a36;
}

.detalle-btn {
  background: #009a44;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 0.8rem;
  cursor: pointer;
  margin: 0 1px;
  transition: background 0.2s;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.detalle-btn:active {
  background: #007a36;
}

.inline-select {
  padding: 4px 6px;
  font-size: 0.85rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  font-family: 'Montserrat', sans-serif;
  width: 90px;
  min-width: 90px;
}

.inline-input {
  padding: 4px 6px;
  font-size: 0.85rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 90px;
  min-width: 90px;
  font-family: 'Montserrat', sans-serif;
}

.delete-btn {
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 0.75rem;
  cursor: pointer;
  margin-left: 2px;
  transition: background 0.2s;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.delete-btn:hover {
  background: #b91c1c;
}

.delete-btn:active {
  background: #991b1b;
}



.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  min-width: 400px;
  max-width: 95vw;
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0,0,0,0.25);
  overflow-y: auto;
  box-sizing: border-box;
}

/* Estilos para modal de tipo de ticket */
.tipo-ticket-modal {
  min-width: 500px;
  max-width: 600px;
  text-align: center;
}

/* Modal compacto para nuevo ticket */
.tipo-ticket-modal.compact {
  min-width: 320px;
  max-width: 400px;
  padding: 20px;
  text-align: left;
}

.tipo-ticket-form {
  padding: 10px 0;
}

.tipo-ticket-form .compact-field {
  margin-bottom: 15px;
}

.tipo-ticket-form .compact-field label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
}

.tipo-ticket-form .readonly-field {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #f5f5f5;
  color: #666;
  font-size: 0.95rem;
  box-sizing: border-box;
}

.tipo-solicitud-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.95rem;
  background: white;
  cursor: pointer;
  box-sizing: border-box;
}

.tipo-solicitud-select:focus {
  outline: none;
  border-color: #009a44;
  box-shadow: 0 0 0 2px rgba(0,154,68,0.1);
}

.modal-actions.compact-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.tipo-ticket-options {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  justify-content: center;
}

.ticket-type-card {
  flex: 1;
  padding: 30px 20px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fa;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ticket-type-card:hover {
  border-color: #009a44;
  background: #009a44;
  color: white;
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,154,68,0.2);
}

.ticket-type-card .card-icon {
  font-size: 3rem;
  margin-bottom: 15px;
}

.ticket-type-card h4 {
  margin: 0 0 10px 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: inherit;
}

.ticket-type-card p {
  margin: 0;
  font-size: 0.9rem;
  color: inherit;
  opacity: 0.8;
}


.evidencia-placeholder {
  color: #888;
  font-size: 0.95rem;
  margin-left: 8px;
}

.modal-actions {
  text-align: right;
}

.modal-actions button {
  background: #009a44;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 8px;
}

.modal-actions button:active {
  background: #007a36;
}

/* Estilos para el modal de reasignación */
.reassign-modal {
  max-width: 500px;
  width: 90%;
}

.reassign-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #009a44;
}

.reassign-info p {
  margin: 5px 0;
  font-size: 0.9rem;
}

.reassign-info strong {
  color: #009a44;
}

/* Estilos para el modal de cancelación */
.cancel-modal {
  max-width: 500px;
  width: 90%;
}

.cancel-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #dc3545;
}

.cancel-info p {
  margin: 5px 0;
  font-size: 0.9rem;
}

.cancel-info strong {
  color: #dc3545;
}

.warning-message {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 15px;
  margin-top: 15px;
}

.warning-message p {
  margin: 0;
  color: #856404;
  font-size: 0.9rem;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover {
  background: #c82333;
}

.modal-footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}

.btn-primary {
  background: #009a44;
  color: white;
}

.btn-primary:hover {
  background: #007a36;
}

/* Estilos para botón de cancelar ticket */
.cancel-ticket-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.cancel-ticket-btn:hover {
  background: #c82333;
  transform: translateY(-1px);
}

.cancel-ticket-btn:active {
  background: #bd2130;
  transform: translateY(0);
}

/* Estilos para botón de cancelar en el detalle del ticket */
.cancel-ticket-btn-detail {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.cancel-ticket-btn-detail:hover {
  background: linear-gradient(135deg, #c82333, #bd2130);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

.cancel-ticket-btn-detail:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.3);
}

.no-action-text {
  color: #6c757d;
  font-style: italic;
  font-size: 0.9rem;
}

/* Estilo para la columna de acciones */
td:last-child {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  text-align: center;
  padding: 4px;
}

/* Estilo para el encabezado de Folio (usuarios) */
.folio-header {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #009a44;
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
  padding: 8px 6px !important;
  text-align: center !important;
  word-wrap: normal;
  overflow: hidden;
}

/* Estilo para la celda de folio (usuarios) */
.folio-cell {
  font-family: 'Courier New', monospace;
  font-weight: 700;
  font-size: 0.95rem;
  color: #009a44;
  letter-spacing: 0.5px;
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
  padding: 8px 6px !important;
  text-align: center !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Estilo específico para columna ID de admin (más pequeña) */
.admin-view .ticket-list th:nth-child(1),
.admin-view .ticket-list td:nth-child(1) {
  width: 60px !important;
  min-width: 60px !important;
  max-width: 60px !important;
  padding: 6px 4px !important;
  font-size: 0.85rem !important;
}

/* Asegurar que en vista de usuario el folio mantenga 120px */
.ticket-form-container:not(.admin-view) .ticket-list th:nth-child(1),
.ticket-form-container:not(.admin-view) .ticket-list td:nth-child(1) {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
  padding: 8px 6px !important;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6c757d;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: #f8f9fa;
  color: #495057;
}

/* Estilos para el modal del formulario */
.form-modal {
  max-width: 900px;
  width: 98%;
  max-height: 95vh;
  overflow-y: auto;
  margin: 10px;
  box-sizing: border-box;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 12px;
}

.modal-header h3 {
  margin: 0;
  color: #009a44;
  font-size: 1.1rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #6c757d;
  padding: 3px;
  border-radius: 4px;
  transition: background 0.2s;
}

.close-btn:hover {
  background: #f8f9fa;
}

.ticket-form-modal {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ticket-form-modal .form-group {
  margin-bottom: 0;
}

.ticket-form-modal .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

/* Estilos para las secciones del formulario */
.form-section {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
  border-left: 3px solid #009a44;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.section-title {
  margin: 0 0 10px 0;
  color: #009a44;
  font-size: 0.95rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 5px;
}

.form-section .form-group label {
  color: #495057;
  font-weight: 600;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 0.85rem;
}

.form-section .form-group input,
.form-section .form-group textarea,
.form-section .form-group select {
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 7px 10px;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  background: white;
}

.form-section .form-group input:focus,
.form-section .form-group textarea:focus,
.form-section .form-group select:focus {
  border-color: #009a44;
  box-shadow: 0 0 0 2px rgba(0, 154, 68, 0.1);
  outline: none;
}

.form-section .form-group input:hover,
.form-section .form-group textarea:hover,
.form-section .form-group select:hover {
  border-color: #009a44;
}

.ticket-form-modal .modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 12px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border-top: 2px solid #009a44;
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 18px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.cancel-btn:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(108, 117, 125, 0.3);
}

.ticket-form-modal .submit-btn {
  width: auto;
  padding: 8px 22px;
  background: #009a44;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.ticket-form-modal .submit-btn:hover {
  background: #007a36;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 154, 68, 0.3);
}

.ticket-form-modal .submit-btn:disabled {
  background: #6c757d;
  color: #fff;
  cursor: not-allowed;
  opacity: 0.7;
  transform: none;
  box-shadow: none;
}

.ticket-form-modal .submit-btn:disabled:hover {
  background: #6c757d;
  transform: none;
  box-shadow: none;
}

/* Estilos para radio buttons */
.radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 8px;
  margin-top: 8px;
}

.radio-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.85rem;
  padding: 8px 12px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  transition: all 0.3s ease;
  position: relative;
}

.radio-item:hover {
  border-color: #009a44;
  background: #f8fff9;
  transform: translateY(-1px);
  box-shadow: 0 1px 4px rgba(0, 154, 68, 0.1);
}

.radio-item input[type="radio"] {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
  accent-color: #009a44;
}

.radio-item input[type="radio"]:checked + span {
  color: #009a44;
  font-weight: 600;
}

.radio-item:has(input[type="radio"]:checked) {
  border-color: #009a44;
  background: #f0fff4;
}

/* Estilos para checkbox personalizado */
.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0;
}

.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  cursor: pointer;
  accent-color: #009a44;
}

.checkbox-custom {
  display: none;
}

.checkmark {
  margin-left: 8px;
  font-size: 0.9em;
  color: #666;
}

/* Estilos para el formulario de equipo */
.equipo-form {
  background: #f0fff4;
  border: 1px solid #009a44;
  border-radius: 5px;
  padding: 6px;
  margin-top: 4px;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.equipo-form .form-group {
  margin-bottom: 8px;
}

.equipo-form .form-group:last-child {
  margin-bottom: 0;
}

/* Estilos para el formulario de insumos */
.insumos-form {
  background: #fff3e0;
  border: 1px solid #ffcc02;
  border-radius: 5px;
  padding: 6px;
  margin-top: 4px;
  animation: slideDown 0.3s ease-out;
}

.insumos-form .form-group {
  margin-bottom: 8px;
}

.insumos-form .form-group:last-child {
  margin-bottom: 0;
}

/* Responsive para radio buttons */
@media (max-width: 600px) {
  .radio-group {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .radio-item {
    font-size: 0.9rem;
    padding: 10px 12px;
  }
  
  .ticket-form-modal .form-row {
    grid-template-columns: 1fr;
  }
  
  .form-section {
    padding: 15px;
  }
  
  .section-title {
    font-size: 1rem;
  }
  
  .ticket-form-modal .modal-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .cancel-btn,
  .ticket-form-modal .submit-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Estilos para modales de estadísticas */
.stats-modal {
  max-width: 900px;
  width: 95%;
  max-height: 90vh;
  overflow-y: auto;
}

/* Mejoras para modales en dispositivos móviles */
@media (max-width: 600px) {
  .stats-modal {
    width: 100%;
    max-width: 100vw;
  }
  
  /* Responsive para modal de tipo de ticket */
  .tipo-ticket-modal {
    min-width: auto;
    max-width: 95vw;
    padding: 15px;
  }
  
  .tipo-ticket-options {
    flex-direction: column;
    gap: 15px;
    margin-top: 15px;
  }
  
  .ticket-type-card {
    min-height: 140px;
    padding: 20px 15px;
  }
  
  .ticket-type-card .card-icon {
    font-size: 2.5rem;
    margin-bottom: 10px;
  }
  
  .ticket-type-card h4 {
    font-size: 1.1rem;
  }
  
  .ticket-type-card p {
    font-size: 0.85rem;
  }
  
  .stats-modal .modal-overlay {
    max-height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  
  .stats-modal .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 15px 10px;
    border-radius: 0;
  }
}

@media (max-width: 480px) {
  .stats-modal {
    width: 100vw;
    height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  
  .stats-modal .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 10px 8px;
    border-radius: 0;
  }
}

.stats-content {
  padding: 20px 0;
}

/* Estilos para reportes por técnico */
.stats-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 25px;
}

.stat-card {
  background: linear-gradient(135deg, #009a44, #007a36);
  color: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 154, 68, 0.3);
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.9;
}

.stats-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.stats-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.stats-table th {
  background: #f8f9fa;
  padding: 12px;
  font-weight: 600;
  color: #495057;
  text-align: left;
  border-bottom: 2px solid #e9ecef;
}

.stats-table td {
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
}

.efficiency {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.efficiency.high {
  background: #d4edda;
  color: #155724;
}

.efficiency.medium {
  background: #fff3cd;
  color: #856404;
}

.efficiency.low {
  background: #f8d7da;
  color: #721c24;
}

/* Estilos para exportar reportes */
.export-options {
  display: grid;
  gap: 20px;
}

.export-option {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.export-option:hover {
  border-color: #009a44;
  background: #f0fff4;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 154, 68, 0.1);
}

.export-icon {
  font-size: 2.5rem;
  min-width: 60px;
  text-align: center;
}

.export-info {
  flex: 1;
}

.export-info h4 {
  margin: 0 0 8px 0;
  color: #009a44;
  font-size: 1.1rem;
}

.export-info p {
  margin: 0 0 12px 0;
  color: #6c757d;
  font-size: 0.9rem;
}

.export-btn {
  background: #009a44;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.export-btn:hover {
  background: #007a36;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 154, 68, 0.3);
}

/* Estilos para gráficos por departamento */
.chart-container {
  margin-bottom: 25px;
}

.chart-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
}

.chart-label {
  min-width: 120px;
  font-weight: 600;
  color: #495057;
}

.chart-bar {
  flex: 1;
  height: 20px;
  background: #e9ecef;
  border-radius: 10px;
  overflow: hidden;
}

.chart-fill {
  height: 100%;
  background: linear-gradient(90deg, #009a44, #007a36);
  border-radius: 10px;
  transition: width 0.8s ease;
}

.chart-percentage {
  min-width: 50px;
  text-align: right;
  font-weight: 600;
  color: #009a44;
}

.chart-summary {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.summary-item:last-child {
  border-bottom: none;
}

.summary-label {
  color: #6c757d;
  font-size: 0.9rem;
}

.summary-value {
  font-weight: 600;
  color: #009a44;
}

/* Estilos para tiempo promedio */
.time-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.time-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
}

.time-card:hover {
  transform: translateY(-3px);
}

.time-card.critical {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
}

.time-card.high {
  background: linear-gradient(135deg, #fd7e14, #e55a00);
  color: white;
}

.time-card.medium {
  background: linear-gradient(135deg, #ffc107, #e0a800);
  color: #212529;
}

.time-card.low {
  background: linear-gradient(135deg, #6c757d, #545b62);
  color: white;
}

.time-icon {
  font-size: 2rem;
  min-width: 50px;
  text-align: center;
}

.time-info {
  flex: 1;
}

.time-label {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-bottom: 5px;
}

.time-value {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 3px;
}

.time-tickets {
  font-size: 0.8rem;
  opacity: 0.8;
}

.time-summary {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* Responsive para estadísticas */
@media (max-width: 600px) {
  .stats-summary {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .export-option {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
  
  .time-stats {
    grid-template-columns: 1fr;
  }
  
  .chart-item {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .chart-label {
    min-width: auto;
  }
  
  .chart-percentage {
    text-align: left;
  }
}

@media (max-width: 1400px) {
  .main-content {
    width: 98%;
    max-width: 1200px;
  }
  .form-row {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 1200px) {
  .main-content {
    width: 98%;
    max-width: 1000px;
  }
  .form-row {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .main-content {
    width: 95%;
    max-width: 100%;
  }
  .form-row {
    grid-template-columns: 1fr;
  }
  .table-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  .header-actions {
    justify-content: center;
  }
  .dropdown-menu {
    right: auto;
    left: 0;
  }
  .ticket-form-modal .form-row {
    grid-template-columns: 1fr;
  }
  
  /* Ajustes para la tabla en móviles */
  table {
    font-size: 0.8rem;
  }
  
  table th,
  table td {
    padding: 6px 4px;
  }
  
  /* Ajustes específicos para el modal en móviles */
  .form-modal {
    width: 98%;
    max-width: 98vw;
    max-height: 98vh;
    margin: 5px;
  }
  
  .modal-content {
    max-width: 98vw;
    max-height: 95vh;
    padding: 15px 12px;
  }
  
  .ticket-form-modal {
    gap: 6px;
  }
  
  .form-group {
    margin-bottom: 10px;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea {
    font-size: 16px; /* Evita zoom en iOS */
    padding: 8px 6px;
  }
}

@media (max-width: 480px) {
  .main-content {
    width: 100%;
    margin: 5px;
  }
  .ticket-form-container {
    padding: 5px 0;
  }
  .table-header {
    padding: 10px;
  }
  .ticket-list {
    padding: 10px;
  }
  
  /* Ajustes para pantallas muy pequeñas */
  .form-modal {
    width: 100%;
    max-width: 100vw;
    max-height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  
  .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 12px 10px;
    border-radius: 0;
  }
  
  .modal-header {
    padding: 8px 0;
    margin-bottom: 8px;
  }
  
  .modal-header h3 {
    font-size: 1rem;
  }
  
  .ticket-form-modal {
    gap: 5px;
  }
  
  .form-group {
    margin-bottom: 6px;
  }
  
  .form-group label {
    font-size: 0.8rem;
    margin-bottom: 3px;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea {
    font-size: 16px;
    padding: 6px 4px;
  }
  
  .equipo-form,
  .insumos-form {
    padding: 4px;
    margin-top: 3px;
  }
  
  /* Ajustes adicionales para la tabla en pantallas muy pequeñas */
  table {
    font-size: 0.7rem;
  }
  
  table th,
  table td {
    padding: 3px 1px;
  }
  
  .ticket-list {
    overflow-x: auto;
  }
  
  .filter-controls {
    flex-direction: column;
    gap: 6px;
  }
  
  .filter-group {
    width: 100%;
  }
  
  .area-filter {
    width: 100%;
  }
}

/* Animaciones para notificaciones */
@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutRight {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}


/* Estilos para el contador de cantidad */
.quantity-counter {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  background: white;
}

.counter-btn {
  background: #009a44;
  color: white;
  border: none;
  padding: 8px 12px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.counter-btn:hover {
  background: #007a35;
  transform: scale(1.05);
}

.counter-btn:active {
  transform: scale(0.95);
}

.counter-input {
  flex: 1;
  border: none;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  padding: 8px;
  background: white;
  color: #333;
  min-width: 60px;
}

.counter-input:focus {
  outline: none;
  background: #f8f9fa;
}

.counter-input::-webkit-inner-spin-button,
.counter-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.counter-input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}

/* Estilos para autocompletado de insumos */
.autocomplete-container {
  position: relative;
  width: 100%;
}

.sugerencias-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.sugerencia-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  transition: background-color 0.2s ease;
  line-height: 1.3;
}

.sugerencia-descripcion {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.sugerencia-presentacion {
  font-size: 11px;
  color: #666;
  font-style: italic;
}

.sugerencia-item:hover {
  background-color: #009a44;
}

.sugerencia-item:hover .sugerencia-descripcion {
  color: white;
}

.sugerencia-item:hover .sugerencia-presentacion {
  color: #e0e0e0;
}

.sugerencia-item:last-child {
  border-bottom: none;
}

.sugerencia-item:active {
  background-color: #007a35;
}

/* Estilos para prioridad automática */
.prioridad-badge {
  font-weight: bold;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.prioridad-display {
  font-weight: bold;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.tiempo-respuesta {
  color: #666;
  font-style: italic;
  font-size: 0.9rem;
}

.justificacion-prioridad {
  color: #333;
  font-size: 0.9rem;
  line-height: 1.4;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #009a44;
}

/* Estilos para filas de tickets con prioridad */
.ticket-row {
  transition: all 0.3s ease;
}

.ticket-row:hover {
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* Estilos para el panel de detalle del ticket */
.detail-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.back-btn {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 5px;
}

.back-btn:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(108, 117, 125, 0.3);
}

.ticket-detail-panel {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: #f8f9fa;
}

.detail-content {
  width: 100%;
  margin: 0 auto;
}

/* Indicador de prioridad manual */
.manual-indicator {
  margin-left: 4px;
  font-size: 0.8rem;
  opacity: 0.8;
  cursor: help;
}

.single-detail-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  overflow: hidden;
  border: 1px solid #e9ecef;
}

.card-header {
  background: linear-gradient(135deg, #009a44, #007a36);
  color: white;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.header-left {
  flex: 1;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.download-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.download-btn:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

/* Estilos para botones de administrador */
.admin-download-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.download-btn.normal-report {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
}

.download-btn.normal-report:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}

.download-btn.complete-report {
  background: linear-gradient(135deg, #6f42c1 0%, #5a2d91 100%);
}

.download-btn.complete-report:hover {
  background: linear-gradient(135deg, #5a2d91 0%, #4c2474 100%);
  box-shadow: 0 4px 15px rgba(111, 66, 193, 0.3);
}

.close-detail-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.close-detail-btn:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.card-header h2 {
  font-family: 'Helvetica LT Std Black Condensed Oblique', 'Helvetica', Arial, sans-serif;
  font-size: 1.5rem;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.status-summary {
  display: flex;
  gap: 10px;
  align-items: center;
}

.card-content {
  padding: 30px;
}

/* Nueva estructura en secciones organizadas */
.detail-section {
  margin-bottom: 30px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.section-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
}

.section-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-content {
  padding: 20px;
}

.status-badges-row {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.status-badge-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
}

.status-badge-item label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
  margin: 0;
}

.detail-form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.detail-form-group {
  margin-bottom: 15px;
}

.detail-form-group.full-width {
  grid-column: 1 / -1;
}

.detail-form-group label {
  display: block;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.detail-value {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
  font-size: 0.95rem;
  min-height: 20px;
  word-wrap: break-word;
  color: #333;
  transition: all 0.3s ease;
}

.detail-value:hover {
  border-color: #009a44;
  background: #f0fff4;
}

.detail-value.empty {
  color: #6c757d;
  font-style: italic;
}

.detail-value.title-value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #009a44;
  background: #f0fff4;
  border-color: #009a44;
}

.detail-value.description-value {
  min-height: 60px;
  line-height: 1.5;
}

.detail-sub-value {
  margin-top: 8px;
  padding: 6px 10px;
  background: #e9ecef;
  border-radius: 4px;
  font-size: 0.85rem;
  color: #6c757d;
}

.detail-sub-value small {
  display: block;
  line-height: 1.4;
}

/* Estilos para la sección de solución del técnico */
.solution-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #009a44;
  border-radius: 12px;
  padding: 25px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(0, 154, 68, 0.1);
}

.solution-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #009a44;
}

.solution-header h3 {
  font-family: 'Helvetica LT Std Black Condensed Oblique', 'Helvetica', Arial, sans-serif;
  color: #009a44;
  font-size: 1.2rem;
  margin: 0;
}

.solution-badge {
  background: #009a44;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Estilos para la sección de solución visible para usuarios */
.solution-display-section {
  background: linear-gradient(135deg, #e8f5e8 0%, #f0f8f0 100%);
  border: 2px solid #28a745;
  border-radius: 12px;
  padding: 25px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.1);
}

.solution-display-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #28a745;
}

.solution-display-header h3 {
  font-family: 'Helvetica LT Std Black Condensed Oblique', 'Helvetica', Arial, sans-serif;
  color: #28a745;
  font-size: 1.2rem;
  margin: 0;
}

.solution-status-badge {
  background: #28a745;
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: bold;
}

.solution-display-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.solution-text {
  background: white;
  border: 1px solid #d4edda;
  border-radius: 8px;
  padding: 15px;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #2c3e50;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.detail-textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: 'Helvetica LT Std Condensed Oblique', 'Helvetica', Arial, sans-serif;
  background: white;
  color: #333;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 80px;
}

.detail-textarea:focus {
  outline: none;
  border-color: #009a44;
  box-shadow: 0 0 0 3px rgba(0, 154, 68, 0.1);
  background: #f8fff9;
}

.detail-textarea::placeholder {
  color: #6c757d;
  font-style: italic;
}

.detail-input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  font-family: 'Helvetica LT Std Condensed Oblique', 'Helvetica', Arial, sans-serif;
  background: white;
  color: #333;
  transition: all 0.3s ease;
}

.detail-input:focus {
  outline: none;
  border-color: #009a44;
  box-shadow: 0 0 0 3px rgba(0, 154, 68, 0.1);
  background: #f8fff9;
}

.detail-input::placeholder {
  color: #6c757d;
  font-style: italic;
}

.solution-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #dee2e6;
  flex-wrap: wrap;
  gap: 15px;
}

.save-solution-btn {
  background: linear-gradient(135deg, #009a44, #007a36);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 154, 68, 0.3);
}

.save-solution-btn:hover {
  background: linear-gradient(135deg, #007a36, #006a2e);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 154, 68, 0.4);
}

.save-solution-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 154, 68, 0.3);
}

.last-updated {
  color: #6c757d;
  font-size: 0.85rem;
  font-style: italic;
}

.status-badges {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

.detail-badge {
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;
  text-align: center;
  min-width: 80px;
}

.detail-badge-prioridad {
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.detail-badge-estado {
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;
}

.detail-badge-estado.badge-pendiente {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.detail-badge-estado.badge-in-progress {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.detail-badge-estado.badge-resolved {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.detail-badge-estado.badge-reassigned {
  background: #ffeaa7;
  color: #856404;
  border: 1px solid #fdcb6e;
}

.detail-badge-estado.badge-cancelled {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.detail-badge-estado.badge-cancel {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Responsive para el panel de detalle */
@media (max-width: 600px) {
  .detail-section {
    margin-bottom: 20px;
  }
  
  .section-header {
    padding: 12px 15px;
  }
  
  .section-content {
    padding: 15px;
  }
  
  .status-badges-row {
    flex-direction: column;
    gap: 15px;
    padding: 12px;
  }
  
  .detail-form-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .back-btn {
    align-self: flex-start;
  }
  
  .ticket-detail-panel {
    padding: 15px;
  }
  
  .card-content {
    padding: 20px;
  }
  
  .card-header {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .card-header h2 {
    font-size: 1.3rem;
  }
  
  .status-summary {
    align-self: stretch;
    justify-content: center;
  }
  
  .solution-section {
    padding: 20px;
  }
  
  .solution-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .solution-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .save-solution-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .card-content {
    padding: 15px;
  }
  
  .card-header {
    padding: 15px;
  }
  
  .detail-form-row {
    gap: 10px;
  }
  
  .detail-value {
    padding: 10px;
  }
  
  .solution-section {
    padding: 15px;
  }
  
  .detail-textarea,
  .detail-input {
    padding: 10px;
  }
}

/* Estilos para adjuntar fotos */
.photo-upload-section {
  margin-bottom: 15px;
}

.photo-input {
  display: none;
}

.photo-upload-btn {
  display: inline-block;
  background: linear-gradient(135deg, #009a44, #007a36);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
  font-size: 0.9rem;
  text-align: center;
  min-width: 150px;
}

.photo-upload-btn:hover {
  background: linear-gradient(135deg, #007a36, #006a2e);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 154, 68, 0.4);
}

.photo-upload-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(0, 154, 68, 0.3);
}

.photo-help-text {
  margin: 8px 0 0 0;
  color: #6c757d;
  font-size: 0.85rem;
  font-style: italic;
}

.photos-preview {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.photos-preview h4 {
  margin: 0 0 15px 0;
  color: #009a44;
  font-size: 1rem;
  font-weight: 600;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
}

.photo-item {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.photo-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.photo-preview {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-bottom: 1px solid #e9ecef;
}

.photo-info {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
}

.photo-name {
  font-size: 0.85rem;
  color: #495057;
  font-weight: 500;
  flex: 1;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remove-photo-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.remove-photo-btn:hover {
  background: #c82333;
  transform: scale(1.1);
}

.remove-photo-btn:active {
  transform: scale(0.95);
}

/* Responsive para fotos */
@media (max-width: 600px) {
  .photos-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 10px;
  }
  
  .photo-preview {
    height: 120px;
  }
  
  .photo-info {
    padding: 8px;
  }
  
  .photo-name {
    font-size: 0.8rem;
  }
  
  .photo-upload-btn {
    width: 100%;
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .photos-grid {
    grid-template-columns: 1fr;
  }
  
  .photo-preview {
    height: 200px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .download-btn {
    padding: 8px 12px;
    font-size: 0.8rem;
  }
  
  .admin-download-buttons {
    flex-direction: column;
    gap: 6px;
    width: 100%;
  }
  
  .admin-download-buttons .download-btn {
    width: 100%;
    justify-content: center;
  }
  
  .close-detail-btn {
    width: 35px;
    height: 35px;
    font-size: 0.9rem;
  }
}

/* ===== ESTILOS PARA SECCIÓN DE SOLUCIÓN DEL TÉCNICO ===== */

.solution-section {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.solution-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f8f9fa;
}

.solution-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 600;
}

.solution-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-form-group.full-width {
  grid-column: 1 / -1;
}

.detail-form-group label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}

.detail-textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.3s ease;
}

.detail-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.detail-input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
}

.detail-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.solution-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
}

.save-solution-btn {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.save-solution-btn:hover {
  background: linear-gradient(135deg, #20c997, #17a2b8);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.last-updated {
  color: #6c757d;
  font-size: 0.8rem;
  font-style: italic;
}

/* ===== ESTILOS PARA FEED DE SOLUCIONES (ESTILO FACEBOOK) ===== */

.solutions-feed-section {
  margin-top: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e9ecef;
}

.feed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #dee2e6;
}

.feed-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 600;
}

.feed-count {
  background: #007bff;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.solutions-feed {
  max-height: 400px;
  overflow-y: auto;
}

.feed-item {
  display: flex;
  margin-bottom: 16px;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  position: relative;
}

.feed-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.feed-item:last-child {
  margin-bottom: 0;
}

.feed-avatar {
  margin-right: 12px;
  flex-shrink: 0;
}

.avatar-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: white;
}

.feed-content {
  flex: 1;
  min-width: 0;
}

.feed-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
}

.feed-author {
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.9rem;
}

.feed-type-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-solucion_inicial {
  background: #28a745;
  color: white;
}

.badge-actualizacion {
  background: #17a2b8;
  color: white;
}

.badge-seguimiento {
  background: #ffc107;
  color: #212529;
}

.badge-cierre {
  background: #6c757d;
  color: white;
}

.feed-time {
  color: #6c757d;
  font-size: 0.8rem;
  margin-left: auto;
}

.feed-message {
  color: #495057;
  line-height: 1.5;
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-break: break-word;
}

.feed-action {
  margin-top: 4px;
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.feed-extra-info {
  margin-top: 6px;
  font-size: 0.8rem;
  color: #495057;
}

/* Tipos de feed con colores específicos */
.feed-type-solucion_inicial {
  border-left: 4px solid #28a745;
}

.feed-type-actualizacion {
  border-left: 4px solid #17a2b8;
}

.feed-type-seguimiento {
  border-left: 4px solid #ffc107;
}

.feed-type-cierre {
  border-left: 4px solid #6c757d;
}

/* Formulario para nueva solución */
.new-solution-section {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.new-solution-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f8f9fa;
}

.new-solution-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.2rem;
  font-weight: 600;
}

.solution-status {
  background: #e9ecef;
  color: #6c757d;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.new-solution-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}

.form-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.add-solution-btn {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-solution-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3, #004085);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.add-solution-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.clear-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.clear-btn:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

/* Estilos para carga de imágenes */
.image-upload-section {
  margin-top: 10px;
}

.image-input {
  display: none;
}

.image-upload-btn {
  background: #28a745;
  color: white;
  padding: 10px 15px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.image-upload-btn:hover {
  background: #218838;
  transform: translateY(-1px);
}

.image-help-text {
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 5px;
  font-style: italic;
}

/* Vista previa de imágenes */
.images-preview {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.images-preview h4 {
  margin: 0 0 10px 0;
  font-size: 0.9rem;
  color: #495057;
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}

.image-item {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.image-preview {
  width: 100%;
  height: 80px;
  object-fit: cover;
  display: block;
}

.image-info {
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.image-name {
  font-size: 0.7rem;
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 5px;
}

.remove-image-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.remove-image-btn:hover {
  background: #c82333;
  transform: scale(1.1);
}

/* Estilos para imágenes en el feed */
.feed-images {
  margin-top: 10px;
}

.feed-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.feed-image-item {
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.feed-image-item:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.feed-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f5f5f5;
  min-height: 120px;
}

.image-error-placeholder {
  width: 100%;
  height: 120px;
  border: 2px dashed #ff6b6b;
  border-radius: 4px;
  background-color: #ffe0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
  font-size: 12px;
  color: #d63031;
  min-height: 120px;
}

/* Modal para ver imágenes */
.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(5px);
}

.image-modal-content {
  background: white;
  border-radius: 12px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0,0,0,0.3);
}

.image-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.image-modal-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 15px;
}

.close-modal-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-modal-btn:hover {
  background: #c82333;
  transform: scale(1.1);
}

.image-modal-body {
  padding: 20px;
  text-align: center;
}

.modal-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* Responsive */
@media (max-width: 600px) {
  .solutions-feed-section,
  .new-solution-section {
    margin: 15px;
    padding: 15px;
  }
  
  .feed-item {
    padding: 10px;
  }
  
  .avatar-icon {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
  
  .feed-author {
    font-size: 0.85rem;
  }
  
  .feed-time {
    font-size: 0.75rem;
  }
  
  .feed-message {
    font-size: 0.85rem;
  }
  
  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }
  
  .add-solution-btn,
  .clear-btn {
    justify-content: center;
  }
}

/* ===== MEJORAS RESPONSIVAS PARA DISPOSITIVOS MÓVILES ===== */

/* ===== OPTIMIZACIONES ESPECÍFICAS PARA MODO VERTICAL (PORTRAIT) ===== */

/* Móviles en modo vertical - anchos más estrechos */
@media (max-width: 480px) and (orientation: portrait) {
  .main-content {
    width: 100%;
    margin: 0;
    padding: 3px;
  }
  
  .ticket-form-container {
    padding: 0;
  }
  
  
  .table-header h3 {
    font-size: 1rem;
    text-align: center;
    margin-bottom: 10px;
  }
  
  .header-actions {
    gap: 6px;
  }
  
  .new-ticket-btn {
    padding: 10px 6px;
    font-size: 0.85rem;
    min-height: 44px;
  }
  
  /* Tabla optimizada para modo vertical */
  .ticket-list {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  }
  
  .ticket-list table {
    min-width: 600px; /* Reducido para modo vertical */
    font-size: 0.7rem;
  }
  
  .ticket-list th:nth-child(1), .ticket-list td:nth-child(1) { /* ID */
    width: 20px;
    min-width: 20px;
  }
  
  .ticket-list th:nth-child(2), .ticket-list td:nth-child(2) { /* Título */
    width: 100px;
    min-width: 80px;
  }
  
  .ticket-list th:nth-child(3), .ticket-list td:nth-child(3) { /* Solicitante */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(4), .ticket-list td:nth-child(4) { /* Área Solicitante */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(5), .ticket-list td:nth-child(5) { /* Prioridad */
    width: 50px;
    min-width: 40px;
  }
  
  .ticket-list th:nth-child(6), .ticket-list td:nth-child(6) { /* Fecha Creación */
    width: 50px;
    min-width: 40px;
    font-size: 0.6rem;
  }
  
  .ticket-list th:nth-child(7), .ticket-list td:nth-child(7) { /* Fecha Cierre */
    width: 50px;
    min-width: 40px;
    font-size: 0.6rem;
  }
  
  .ticket-list th:nth-child(8), .ticket-list td:nth-child(8) { /* Técnico */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(9), .ticket-list td:nth-child(9) { /* Estado */
    width: 50px;
    min-width: 40px;
  }
  
  /* Modales en modo vertical */
  .form-modal {
    width: 100vw;
    height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  
  .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 8px 5px;
    border-radius: 0;
  }
  
  .ticket-form-modal .form-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .ticket-form-modal .submit-btn {
    width: 100%;
    padding: 12px;
    font-size: 1rem;
    min-height: 48px;
  }
  
  /* Botones optimizados para modo vertical */
  .action-btn {
    min-height: 44px;
    padding: 10px 12px;
    font-size: 0.8rem;
  }
  
  .status-badge {
    padding: 3px 6px;
    font-size: 0.65rem;
  }
}

/* Tablets en modo vertical */
@media (max-width: 768px) and (orientation: portrait) {
  .main-content {
    width: 100%;
    margin: 0;
    padding: 8px;
  }
  
  .ticket-form-container {
    padding: 3px;
  }
  
  
  .table-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .header-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .new-ticket-btn {
    width: 100%;
    justify-content: center;
    padding: 12px 8px;
    font-size: 0.9rem;
    min-height: 46px;
  }
  
  /* Tabla con scroll horizontal para modo vertical */
  .ticket-list {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  }
  
  .ticket-list table {
    min-width: 700px; /* Ajustado para modo vertical */
    font-size: 0.75rem;
  }
  
  .ticket-list th:nth-child(1), .ticket-list td:nth-child(1) { /* ID */
    width: 25px;
    min-width: 25px;
  }
  
  .ticket-list th:nth-child(2), .ticket-list td:nth-child(2) { /* Título */
    width: 120px;
    min-width: 100px;
  }
  
  .ticket-list th:nth-child(3), .ticket-list td:nth-child(3) { /* Solicitante */
    width: 70px;
    min-width: 60px;
  }
  
  .ticket-list th:nth-child(4), .ticket-list td:nth-child(4) { /* Área */
    width: 70px;
    min-width: 60px;
  }
  
  .ticket-list th:nth-child(5), .ticket-list td:nth-child(5) { /* Solicitud */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(6), .ticket-list td:nth-child(6) { /* Fecha Creación */
    width: 60px;
    min-width: 50px;
    font-size: 0.65rem;
  }
  
  .ticket-list th:nth-child(7), .ticket-list td:nth-child(7) { /* Fecha Cierre */
    width: 60px;
    min-width: 50px;
    font-size: 0.65rem;
  }
  
  .ticket-list th:nth-child(8), .ticket-list td:nth-child(8) { /* Técnico */
    width: 70px;
    min-width: 60px;
  }
  
  .ticket-list th:nth-child(9), .ticket-list td:nth-child(9) { /* Estado */
    width: 60px;
    min-width: 50px;
  }
  
  /* Modales en modo vertical */
  .form-modal {
    width: 100%;
    max-width: 100vw;
    max-height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  
  .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 12px 8px;
    border-radius: 0;
  }
  
  .ticket-form-modal .form-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .ticket-form-modal .submit-btn {
    width: 100%;
    justify-content: center;
    min-height: 46px;
  }
}

/* Tablets grandes (1025px - 1200px) */
@media (max-width: 1200px) {
  .main-content {
    width: 98%;
    max-width: 100%;
  }
  
  .form-row {
    grid-template-columns: 1fr 1fr;
  }
}

/* Tablets (769px - 1024px) */
@media (max-width: 1024px) {
  .main-content {
    width: 98%;
    max-width: 100%;
  }
  
  .ticket-list table {
    font-size: 0.85rem;
  }
  
  .ticket-list th:nth-child(1), .ticket-list td:nth-child(1) { /* ID */
    width: 35px;
    min-width: 35px;
  }
  
  .ticket-list th:nth-child(2), .ticket-list td:nth-child(2) { /* Título */
    width: 180px;
    min-width: 140px;
  }
  
  .ticket-list th:nth-child(3), .ticket-list td:nth-child(3) { /* Solicitante */
    width: 100px;
    min-width: 80px;
  }
  
  .ticket-list th:nth-child(4), .ticket-list td:nth-child(4) { /* Área */
    width: 100px;
    min-width: 80px;
  }
  
  .ticket-list th:nth-child(5), .ticket-list td:nth-child(5) { /* Solicitud */
    width: 80px;
    min-width: 70px;
  }
  
  .ticket-list th:nth-child(6), .ticket-list td:nth-child(6) { /* Fecha Creación */
    width: 80px;
    min-width: 70px;
    font-size: 0.75rem;
  }
  
  .ticket-list th:nth-child(7), .ticket-list td:nth-child(7) { /* Fecha Cierre */
    width: 80px;
    min-width: 70px;
    font-size: 0.75rem;
  }
  
  .ticket-list th:nth-child(8), .ticket-list td:nth-child(8) { /* Técnico */
    width: 100px;
    min-width: 80px;
  }
  
  .ticket-list th:nth-child(9), .ticket-list td:nth-child(9) { /* Estado */
    width: 80px;
    min-width: 70px;
  }
}

/* Tablets pequeñas y móviles grandes (481px - 768px) - MEJORADO */
@media (max-width: 600px) {
  .main-content {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 10px;
  }
  
  .ticket-form-container {
    padding: 5px;
  }
  
  
  .table-header {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .header-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .new-ticket-btn {
    width: 100%;
    justify-content: center;
  }
  
  /* Tabla con scroll horizontal mejorado */
  .ticket-list {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .ticket-list table {
    min-width: 800px; /* Ancho mínimo para mantener legibilidad */
    font-size: 0.8rem;
  }
  
  .ticket-list th:nth-child(1), .ticket-list td:nth-child(1) { /* ID */
    width: 30px;
    min-width: 30px;
  }
  
  .ticket-list th:nth-child(2), .ticket-list td:nth-child(2) { /* Título */
    width: 150px;
    min-width: 120px;
  }
  
  .ticket-list th:nth-child(3), .ticket-list td:nth-child(3) { /* Solicitante */
    width: 80px;
    min-width: 70px;
  }
  
  .ticket-list th:nth-child(4), .ticket-list td:nth-child(4) { /* Área */
    width: 80px;
    min-width: 70px;
  }
  
  .ticket-list th:nth-child(5), .ticket-list td:nth-child(5) { /* Solicitud */
    width: 70px;
    min-width: 60px;
  }
  
  .ticket-list th:nth-child(6), .ticket-list td:nth-child(6) { /* Fecha Creación */
    width: 70px;
    min-width: 60px;
    font-size: 0.7rem;
  }
  
  .ticket-list th:nth-child(7), .ticket-list td:nth-child(7) { /* Fecha Cierre */
    width: 70px;
    min-width: 60px;
    font-size: 0.7rem;
  }
  
  .ticket-list th:nth-child(8), .ticket-list td:nth-child(8) { /* Técnico */
    width: 80px;
    min-width: 70px;
  }
  
  .ticket-list th:nth-child(9), .ticket-list td:nth-child(9) { /* Estado */
    width: 70px;
    min-width: 60px;
  }
  
  .form-modal {
    width: 100%;
    max-width: 100vw;
    max-height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  
  .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 15px 10px;
    border-radius: 0;
  }
  
  .ticket-form-modal .form-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .ticket-form-modal .submit-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Móviles pequeños (320px - 480px) */
@media (max-width: 480px) {
  .main-content {
    width: 100%;
    margin: 0;
    padding: 5px;
  }
  
  .ticket-form-container {
    padding: 0;
  }
  
  
  .table-header h3 {
    font-size: 1.1rem;
    text-align: center;
  }
  
  .header-actions {
    gap: 8px;
  }
  
  .new-ticket-btn {
    padding: 12px 8px;
    font-size: 0.9rem;
  }
  
  /* Tabla más compacta para móviles pequeños */
  .ticket-list table {
    min-width: 700px;
    font-size: 0.75rem;
  }
  
  .ticket-list th:nth-child(1), .ticket-list td:nth-child(1) { /* ID */
    width: 25px;
    min-width: 25px;
  }
  
  .ticket-list th:nth-child(2), .ticket-list td:nth-child(2) { /* Título */
    width: 120px;
    min-width: 100px;
  }
  
  .ticket-list th:nth-child(3), .ticket-list td:nth-child(3) { /* Solicitante */
    width: 70px;
    min-width: 60px;
  }
  
  .ticket-list th:nth-child(4), .ticket-list td:nth-child(4) { /* Área */
    width: 70px;
    min-width: 60px;
  }
  
  .ticket-list th:nth-child(5), .ticket-list td:nth-child(5) { /* Solicitud */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(6), .ticket-list td:nth-child(6) { /* Fecha Creación */
    width: 60px;
    min-width: 50px;
    font-size: 0.65rem;
  }
  
  .ticket-list th:nth-child(7), .ticket-list td:nth-child(7) { /* Fecha Cierre */
    width: 60px;
    min-width: 50px;
    font-size: 0.65rem;
  }
  
  .ticket-list th:nth-child(8), .ticket-list td:nth-child(8) { /* Técnico */
    width: 70px;
    min-width: 60px;
  }
  
  .ticket-list th:nth-child(9), .ticket-list td:nth-child(9) { /* Estado */
    width: 60px;
    min-width: 50px;
  }
  
  .form-modal {
    width: 100vw;
    height: 100vh;
    margin: 0;
    border-radius: 0;
  }
  
  .modal-content {
    max-width: 100vw;
    max-height: 100vh;
    padding: 10px 8px;
    border-radius: 0;
  }
  
  .ticket-form-modal .form-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .ticket-form-modal .submit-btn {
    width: 100%;
    padding: 12px;
    font-size: 1rem;
  }
  
  /* Botones más grandes para touch */
  .action-btn {
    min-height: 44px;
    padding: 12px 16px;
  }
  
  .status-badge {
    padding: 4px 8px;
    font-size: 0.7rem;
  }
}

/* Móviles muy pequeños (hasta 320px) */
@media (max-width: 320px) {
  .main-content {
    width: 100%;
    margin: 0;
    padding: 3px;
  }
  
  
  .table-header h3 {
    font-size: 1rem;
  }
  
  .new-ticket-btn {
    padding: 10px 6px;
    font-size: 0.85rem;
  }
  
  .ticket-list table {
    min-width: 650px;
    font-size: 0.7rem;
  }
  
  .ticket-list th:nth-child(1), .ticket-list td:nth-child(1) { /* ID */
    width: 20px;
    min-width: 20px;
  }
  
  .ticket-list th:nth-child(2), .ticket-list td:nth-child(2) { /* Título */
    width: 100px;
    min-width: 80px;
  }
  
  .ticket-list th:nth-child(3), .ticket-list td:nth-child(3) { /* Solicitante */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(4), .ticket-list td:nth-child(4) { /* Área Solicitante */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(5), .ticket-list td:nth-child(5) { /* Prioridad */
    width: 50px;
    min-width: 40px;
  }
  
  .ticket-list th:nth-child(6), .ticket-list td:nth-child(6) { /* Fecha Creación */
    width: 50px;
    min-width: 40px;
    font-size: 0.6rem;
  }
  
  .ticket-list th:nth-child(7), .ticket-list td:nth-child(7) { /* Fecha Cierre */
    width: 50px;
    min-width: 40px;
    font-size: 0.6rem;
  }
  
  .ticket-list th:nth-child(8), .ticket-list td:nth-child(8) { /* Técnico */
    width: 60px;
    min-width: 50px;
  }
  
  .ticket-list th:nth-child(9), .ticket-list td:nth-child(9) { /* Estado */
    width: 50px;
    min-width: 40px;
  }
  
  .modal-content {
    padding: 8px 5px;
  }
}

/* ===== OPTIMIZACIONES PARA PANTALLAS TÁCTILES ===== */

/* ===== OPTIMIZACIONES ESPECÍFICAS PARA MODO VERTICAL EN TÁCTILES ===== */

/* Controles táctiles optimizados para modo vertical */
@media (max-width: 480px) and (orientation: portrait) {
  /* Botones principales más compactos en modo vertical */
  .new-ticket-btn {
    min-height: 48px;
    padding: 12px 8px;
    font-size: 0.9rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de acción más pequeños para modo vertical */
  .action-btn, .detalle-btn {
    min-height: 42px;
    padding: 8px 12px;
    font-size: 0.8rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de estadísticas */
  .stats-btn {
    min-height: 42px;
    padding: 10px 14px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de dropdown */
  .dropdown-menu button {
    min-height: 42px;
    padding: 10px 14px;
    font-size: 0.85rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de filtro */
  .clear-filter-btn {
    min-height: 42px;
    padding: 10px 14px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de formulario */
  .submit-btn {
    min-height: 48px;
    padding: 12px 16px;
    font-size: 1rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Inputs optimizados para modo vertical */
  input[type="text"], 
  input[type="email"], 
  input[type="tel"], 
  input[type="number"],
  textarea,
  select {
    min-height: 44px;
    padding: 12px 14px;
    font-size: 16px; /* Previene zoom en iOS */
    touch-action: manipulation;
  }
  
  /* Radio buttons y checkboxes */
  input[type="radio"], 
  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
  
  /* Labels optimizados para modo vertical */
  .radio-item, .checkbox-label {
    min-height: 44px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    touch-action: manipulation;
  }
}

/* Tablets en modo vertical - controles táctiles */
@media (max-width: 768px) and (orientation: portrait) {
  /* Botones principales */
  .new-ticket-btn {
    min-height: 46px;
    padding: 12px 16px;
    font-size: 0.95rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de acción */
  .action-btn, .detalle-btn {
    min-height: 44px;
    padding: 10px 14px;
    font-size: 0.85rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de estadísticas */
  .stats-btn {
    min-height: 44px;
    padding: 12px 16px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de dropdown */
  .dropdown-menu button {
    min-height: 44px;
    padding: 12px 16px;
    font-size: 0.9rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de filtro */
  .clear-filter-btn {
    min-height: 44px;
    padding: 12px 16px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de formulario */
  .submit-btn {
    min-height: 46px;
    padding: 12px 18px;
    font-size: 1rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Inputs optimizados */
  input[type="text"], 
  input[type="email"], 
  input[type="tel"], 
  input[type="number"],
  textarea,
  select {
    min-height: 44px;
    padding: 12px 16px;
    font-size: 16px;
    touch-action: manipulation;
  }
  
  /* Radio buttons y checkboxes */
  input[type="radio"], 
  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
  
  /* Labels optimizados */
  .radio-item, .checkbox-label {
    min-height: 44px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    touch-action: manipulation;
  }
}

/* Mejoras generales para botones en dispositivos táctiles */
@media (max-width: 600px) {
  /* Botones principales más grandes para touch */
  .new-ticket-btn {
    min-height: 48px;
    padding: 14px 20px;
    font-size: 1rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de acción en la tabla */
  .action-btn, .detalle-btn {
    min-height: 44px;
    padding: 10px 16px;
    font-size: 0.9rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de estadísticas */
  .stats-btn {
    min-height: 44px;
    padding: 12px 16px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de dropdown */
  .dropdown-menu button {
    min-height: 44px;
    padding: 12px 16px;
    font-size: 0.9rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de filtro */
  .clear-filter-btn {
    min-height: 44px;
    padding: 12px 16px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Botones de formulario */
  .submit-btn {
    min-height: 48px;
    padding: 14px 20px;
    font-size: 1rem;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  
  /* Mejorar la experiencia táctil en inputs */
  input[type="text"], 
  input[type="email"], 
  input[type="tel"], 
  input[type="number"],
  textarea,
  select {
    min-height: 44px;
    padding: 12px 16px;
    font-size: 16px; /* Previene zoom en iOS */
    touch-action: manipulation;
  }
  
  /* Radio buttons y checkboxes más grandes */
  input[type="radio"], 
  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
  
  /* Labels más grandes para touch */
  .radio-item, .checkbox-label {
    min-height: 44px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    touch-action: manipulation;
  }
}

/* Optimizaciones adicionales para móviles pequeños */
@media (max-width: 480px) {
  .new-ticket-btn {
    min-height: 52px;
    padding: 16px 20px;
    font-size: 1.1rem;
  }
  
  .action-btn, .detalle-btn {
    min-height: 48px;
    padding: 12px 18px;
    font-size: 1rem;
  }
  
  .submit-btn {
    min-height: 52px;
    padding: 16px 20px;
    font-size: 1.1rem;
  }
  
  input[type="text"], 
  input[type="email"], 
  input[type="tel"], 
  input[type="number"],
  textarea,
  select {
    min-height: 48px;
    padding: 14px 18px;
    font-size: 16px;
  }
  
  input[type="radio"], 
  input[type="checkbox"] {
    width: 22px;
    height: 22px;
    margin-right: 14px;
  }
  
  .radio-item, .checkbox-label {
    min-height: 48px;
    padding: 14px 18px;
  }
}

/* Optimizaciones para móviles muy pequeños */
@media (max-width: 320px) {
  .new-ticket-btn {
    min-height: 50px;
    padding: 14px 16px;
    font-size: 1rem;
  }
  
  .action-btn, .detalle-btn {
    min-height: 46px;
    padding: 10px 14px;
    font-size: 0.9rem;
  }
  
  .submit-btn {
    min-height: 50px;
    padding: 14px 16px;
    font-size: 1rem;
  }
  
  input[type="text"], 
  input[type="email"], 
  input[type="tel"], 
  input[type="number"],
  textarea,
  select {
    min-height: 46px;
    padding: 12px 14px;
    font-size: 16px;
  }
  
  input[type="radio"], 
  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
  
  .radio-item, .checkbox-label {
    min-height: 46px;
    padding: 12px 14px;
  }
}

/* Estilos para pestañas biomédicas */
.biomedica-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 2px;
}

.tab-btn {
  background: transparent;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 600;
  color: #6b7280;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  border-radius: 8px 8px 0 0;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tab-btn:hover {
  background: rgba(59, 130, 246, 0.05);
  color: #3b82f6;
}

.tab-btn.active {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
  border-bottom-color: #3b82f6;
}

.tab-content {
  min-height: 200px;
}

.tab-panel {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive para pestañas */
@media (max-width: 600px) {
  .biomedica-tabs {
    flex-direction: column;
    gap: 8px;
    border-bottom: none;
    margin-bottom: 16px;
  }
  
  .tab-btn {
    border-bottom: none;
    border-radius: 8px;
    padding: 14px 16px;
    justify-content: center;
  }
  
  .tab-btn.active {
    border-bottom: none;
    background: rgba(59, 130, 246, 0.15);
    border: 2px solid rgba(59, 130, 246, 0.3);
  }
}

/* Estilos para escáner QR de equipo biomédico */
.qr-scanner-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 2px dashed #3b82f6;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.qr-scanner-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.qr-label {
  font-weight: 600;
  color: #1e293b;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.qr-icon {
  font-size: 1.4rem;
}

.qr-scan-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.qr-scan-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.qr-scan-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.qr-manual-input {
  margin-bottom: 16px;
}

.input-with-button {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.input-with-button input {
  flex: 1;
  padding: 12px 16px;
  border: 2px solid #cbd5e1;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s ease;
}

.input-with-button input:focus {
  outline: none;
  border-color: #3b82f6;
}

.search-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.search-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.search-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.qr-result {
  padding: 16px;
  border-radius: 8px;
  margin-top: 12px;
}

.qr-result.success {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 2px solid #10b981;
}

.qr-result.error {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border: 2px solid #ef4444;
  color: #dc2626;
}

.qr-result-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 600;
}

.success-icon {
  font-size: 1.2rem;
}

.success-text {
  color: #065f46;
}

.error-icon {
  font-size: 1.2rem;
}

.error-text {
  color: #dc2626;
}

.equipo-info-escaneado {
  background: white;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 12px;
}

.equipo-info-escaneado p {
  margin: 6px 0;
  font-size: 0.95rem;
  color: #374151;
}

.clear-btn {
  background: #ef4444;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.clear-btn:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

@media (max-width: 600px) {
  .qr-scanner-section {
    padding: 16px;
  }
  
  .qr-scanner-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .input-with-button {
    flex-direction: column;
  }
  
  .search-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Estilos para el botón de Garrafón de Agua (mismo tamaño que Nuevo Ticket) */
.garrafon-btn {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  color: white;
  border: 2px solid #1976d2;
  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
  animation: garrafonPulse 2s infinite;
  position: relative;
}

.garrafon-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  border-color: #1565c0;
  box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
  transform: translateY(-1px);
}

.garrafon-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}

@keyframes garrafonPulse {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
  }
  50% {
    box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
  }
}

/* Estilos para el botón de Manuales (mismo tamaño que Nuevo Ticket) */
.manuales-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
  color: white;
  border: 2px solid #f57c00;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3);
  position: relative;
}

.manuales-btn:hover {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
  border-color: #ef6c00;
  box-shadow: 0 6px 20px rgba(255, 152, 0, 0.4);
  transform: translateY(-1px);
}

.manuales-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);
}

/* Estilos para el modal de Manuales */
.manuales-content {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.manuales-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.manual-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.manual-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.manual-item h4 {
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 600;
}

.manual-item p {
  margin: 0 0 12px 0;
  color: #6c757d;
  font-size: 0.9rem;
}

/* Estilos para modal de confirmación de paciente */
.modal-overlay.modal-paciente-confirmacion {
  z-index: 10001 !important;
}

/* Estilos para modal de cancelación de ticket */
.modal-overlay.modal-cancelacion {
  z-index: 99999 !important;
}

.confirmacion-paciente-content {
  padding: 24px;
}

.alerta-paciente {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.mensaje-principal {
  font-size: 1.1rem;
  color: #856404;
  margin: 0 0 12px 0;
  font-weight: 600;
}

.mensaje-instruccion {
  font-size: 1rem;
  color: #856404;
  margin: 0 0 16px 0;
}

.lista-requisitos {
  list-style: none;
  padding: 0;
  margin: 0;
}

.lista-requisitos li {
  padding: 8px 0;
  color: #856404;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.checkbox-confirmacion {
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
}

.checkbox-label-large {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  font-size: 0.95rem;
  color: #495057;
  line-height: 1.5;
}

.checkbox-label-large input[type="checkbox"] {
  width: 24px;
  height: 24px;
  min-width: 24px;
  margin-top: 2px;
  cursor: pointer;
  accent-color: #009a44;
}

.texto-checkbox {
  flex: 1;
}

.submit-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.manual-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
}

.manual-btn:hover {
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

/* Estilos para lista de insumos */
.lista-insumos {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.lista-insumos label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #495057;
  font-size: 0.95rem;
}

.insumo-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 8px;
  border: 1px solid #dee2e6;
  transition: all 0.2s ease;
}

.insumo-item:hover {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-color: #009a44;
}

.insumo-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.insumo-info strong {
  color: #009a44;
  font-size: 0.95rem;
}

.insumo-cantidad {
  color: #6c757d;
  font-size: 0.85rem;
}

.insumo-descripcion {
  color: #495057;
  font-size: 0.85rem;
  font-style: italic;
}

/* Estilos para lista de insumos en detalle del ticket */
.insumos-list-container {
  margin-top: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
  border: 1px solid #e9ecef;
}

.insumo-list-item {
  background: #fff;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #dee2e6;
  transition: all 0.2s ease;
}

.insumo-list-item:last-child {
  margin-bottom: 0;
}

.insumo-list-item:hover {
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  border-color: #009a44;
}

.insumo-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.insumo-list-header strong {
  color: #009a44;
  font-size: 0.95rem;
  flex: 1;
}

.insumo-list-cantidad {
  color: #6c757d;
  font-size: 0.85rem;
  font-weight: 600;
  background: #e9ecef;
  padding: 2px 8px;
  border-radius: 4px;
}

.insumo-list-description {
  color: #495057;
  font-size: 0.85rem;
  line-height: 1.4;
  padding-top: 6px;
  border-top: 1px solid #e9ecef;
}

.btn-agregar-insumo {
  background: linear-gradient(135deg, #009a44 0%, #007a35 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.btn-agregar-insumo:hover {
  background: linear-gradient(135deg, #007a35 0%, #006a2e 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 154, 68, 0.3);
}

.btn-eliminar-insumo {
  background: #dc3545;
  color: white;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-left: 10px;
}

.btn-eliminar-insumo:hover {
  background: #c82333;
  transform: scale(1.1);
}
</style>